"use strict";

export default {
  ACC_CAM_CO: "Đang cầm cố",
  ACC_CHI_TIET_TAI_KHOAN: "Chi tiết tài khoản",
  ACC_CHON_LOAI_TAI_KHOAN: "Chọn loại tài khoản",
  ACC_CHON_TAI_KHOAN: "Chọn tài khoản",
  ACC_TAI_KHOAN: "Tài khoản",
  ACC_DANG_KY: "Đăng ký",
  ACC_DANG_NHAP: "Đăng nhập",
  ACC_DANG_XUAT: "Đăng xuất",
  ACC_DANG_NHAP_BANG_TAI_KHOAN_KHAC: "Đăng nhập bằng tài khoản khác",
  ACC_DEN_HAN: "Đến hạn",
  ACC_DIA_CHI: "Địa chỉ",
  ACC_DON_VI: "Đơn vị",
  ACC_EMAIL: "Email",
  ACC_FAX: "Fax",
  ACC_GOC_TRONG_HAN: "Gốc trong hạn",
  ACC_GIOI_TINH: "Giới tính",
  ACC_GIOI_TINH_NAM: "Nam",
  ACC_GIOI_TINH_NU: "Nữ",
  ACC_HAN_MUC_GD: "Hạn mức giao dịch",
  ACC_HINH_THUC_MO_SO: "Hình thức mở sổ",
  ACC_HOAT_DONG: "Hoạt động",
  ACC_KHONG_CO_GIAO_DICH_NAO: "Không có giao dịch nào phát sinh.",
  ACC_KHONG_CO_TAI_KHOAN: "Không có tài khoản",
  ACC_KHONG_HOAT_DONG: "Không hoạt động",
  ACC_KY_HAN: "Kỳ hạn",
  ACC_LAI_SUAT: "Lãi suất",
  ACC_LAI_THAU_CHI: "Lãi suất thấu chi",
  ACC_LAI_CONG_DON: "Lãi suất cộng dồn",
  ACC_LOI_CHUA_NHAP_LAI_MAT_KHAU_MOI: "Quý khách vui lòng nhập lại mật khẩu mới",
  ACC_LOI_CHUA_NHAP_MAT_KHAU: "Quý khách vui lòng nhập mật khẩu.",
  ACC_LOI_CHUA_NHAP_MAT_KHAU_HIEN_TAI: "Quý khách vui lòng nhập mật khẩu hiện tại",
  ACC_LOI_CHUA_NHAP_MAT_KHAU_MOI: "Quý khách vui lòng nhập mật khẩu mới",
  ACC_LOI_CHUA_NHAP_TAI_KHOAN: "Quý khách vui lòng nhập tên đăng nhập.",
  ACC_LOI_TAI_KHOAN: "Tài khoản không đúng định dạng",
  ACC_MAN_CHI_TIET_LICH_TRA_NO: "Chi tiết lịch trả nợ",
  ACC_MAN_DONG: "Đóng",
  ACC_MAN_DU_NO_HIEN_TAI: "Dư nợ hiện tại",
  ACC_MAN_GIA_TRI_TAI_SAN: "Giá trị tài sản",
  ACC_MAN_GOC: "Gốc",
  ACC_MAN_GOC_CON_LAI: "Gốc còn lại",
  ACC_MAN_GOC_QUA_HAN: "Gốc quá hạn",
  ACC_MAN_GOC_TRA_LAI: "Gốc trả lãi",
  ACC_MAN_LAI: "Lãi",
  ACC_MAN_LAI_PHAI_TRA: "Lãi phải trả",
  ACC_MAN_LAI_PHAT_TREN_GOC_QUA_HAN: "Lãi phạt trên gốc quá hạn",
  ACC_MAN_LAI_PHAT_TREN_LAI_QUA_HAN: "Lãi phạt trên lãi quá hạn",
  ACC_MAN_LAI_QUA_HAN: "Lãi quá hạn",
  ACC_MAN_LICH_SU_TRA_NO: "Lịch sử trả nợ",
  ACC_MAN_LOAI_TAI_SAN: "Loại tài sản",
  ACC_MAN_MO_TA_TAI_SAN: "Mô tả tài sản",
  ACC_MAN_NGAY_HIEU_LUC: "Ngày hiệu lực",
  ACC_MAN_PHI: "Phí",
  ACC_MAN_SO_KY_CON_LAI: "Số kỳ còn lại",
  ACC_MAN_TAI_KHOAN_VAY: "Tài khoản vay",
  ACC_MAN_TAI_SAN_DAM_BAO: "Tài sản đảm bảo",
  ACC_MAN_TB_CHON_KHOANG_NGAY_NHO_HON_1_NAM: "Ngày bắt đầu và ngày kết thúc không quá 1 năm.",
  ACC_MAN_TB_CHON_NGAY_BAT_DAU_TRUOC_KET_THUC: "Quý khách vui lòng chọn ngày bắt đầu trước ngày kết thúc.",
  ACC_MAN_THONG_TIN_KHOAN_VAY: "Thông tin khoản vay",
  ACC_MAN_TONG_GOC_LAI: "Tổng gốc lãi",
  ACC_MAN_XEM_TAI_SAN_DAM_BAO: "Xem tài sản đảm bảo",
  ACC_MAT_KHAU_HIEN_TAI: "Mật khẩu hiện tại",
  ACC_MAT_KHAU_INT_BANK: "Mật khẩu",
  ACC_CAPCHA_INT_BANK: "Mã bảo vệ",
  ACC_MAT_KHAU_MOI: "Mật khẩu mới",
  ACC_MAT_KHAU_XAC_MINH_KHONG_DUNG: "Mật khẩu mới không trùng khớp",
  ACC_CAPCHA_XAC_MINH_KHONG_DUNG: "Vui lòng nhập đúng mã bảo vệ",
  ACC_CAPCHA_XAC_MINH_CHUA_NHAP: "Vui lòng nhập mã bảo vệ",
  ACC_MO_ONLINE: "Mở online",
  ACC_MO_TA: "Mô tả",
  ACC_MO_TAI_QUAY: "Mở tại quầy",
  ACC_NGAY_DEN_HAN: "Ngày đến hạn",
  ACC_NGAY_HET_HAN: "Ngày hết hạn",
  ACC_NGAY_HIEU_LUC: "Ngày hiệu lực",
  ACC_NGAY_MO_TAI_KHOAN: "Ngày mở tài khoản",
  ACC_NGAY_MO_SO: "Ngày mở sổ",
  ACC_NGAY_NHAN_LAI_KE_TIEP: "Ngày nhận lãi kế tiếp",
  ACC_NHAP_LAI_MAT_KHAU: "Nhập lại mật khẩu mới",
  ACC_NHAP_MAT_KHAU: "Nhập mật khẩu",
  ACC_ONLINE: "Online",
  ACC_QUAN_LY_TAI_KHOAN: "Quản lý tài khoản",
  ACC_QUAN_LY: "Quản lý",
  ACC_QUAY_LAI: "Quay lại",
  ACC_QUEN_MAT_KHAU: "Quên mật khẩu?",
  ACC_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  ACC_SAN_PHAM: "Sản phẩm",
  ACC_SAO_KE_GIAO_DICH: "Sao kê giao dịch",
  ACC_SAO_KE: "Sao kê",
  ACC_SO_BUT_TOAN: "Số bút toán",
  ACC_SO_DU: "Số dư",
  ACC_SO_DU_HIEN_TAI: "Số dư hiện tại",
  ACC_SO_DU_KHA_DUNG: "Số dư khả dụng",
  ACC_SO_DU_KHA_DUNG_NOT_ENOUGH: "Tài khoản của Quý khách không đủ số dư để thực hiện giao dịch.",
  ACC_SO_DU_SO: "Số dư sổ",
  ACC_SO_DU_GOC: "Số dư gốc",
  ACC_SO_HOP_DONG: "Số hợp đồng",
  ACC_SO_TAI_KHOAN: "Số tài khoản",
  ACC_SO_TIEN: "Số tiền",
  ACC_TAI_KHOAN_THANH_TOAN: "Tài khoản thanh toán",
  ACC_TAI_KHOAN_TIEN_GUI_TRA_LAI_SAU: "Tài khoản tiền gửi trả lãi sau",
  ACC_TAI_KHOAN_TIEN_GUI_TRA_LAI_TRUOC: "Tài khoản tiền gửi trả lãi trước",
  ACC_TAI_KHOAN_TIEN_VAY: "Tài khoản tiền vay",
  ACC_TAI_KHOAN_TIET_KIEM: "Tài khoản tiết kiệm",
  ACC_TAI_QUAY: "Tại quầy",
  ACC_TAT_CA_TAI_KHOAN: "Tất cả tài khoản",
  ACC_TEN_DANG_NHAP: "Tên đăng nhập",
  ACC_TEN_SAN_PHAM: "Tên sản phẩm",
  ACC_TEN_TAI_KHOAN: "Tên tài khoản",
  ACC_THOI_GIAN: "Thời gian",
  ACC_THONG_BAO_DOI_MAT_KHAU_THANH_CONG: "Đổi mật khẩu thành công. Quý khách vui lòng đăng nhập lại.",
  ACC_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Ngày bắt đầu và ngày kết thúc không quá 90 ngày.",
  ACC_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_SO_NGAY: "Ngày bắt đầu và ngày kết thúc không quá {day} ngày.",
  ACC_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "Quý khách vui lòng chọn ngày bắt đầu trước ngày kết thúc.",
  ACC_VUI_LONG_CHON_NGAY_BAT_DAU: "Quý khách vui lòng chọn ngày bắt đầu",
  ACC_VUI_LONG_CHON_NGAY_KET_THUC: "Quý khách vui lòng chọn ngày kết thúc",
  ACC_THONG_BAO_VUI_LONG_CHON_TAI_KHOAN: "Quý khách vui lòng chọn tài khoản",
  ACC_TIEP_TUC: "Tiếp tục",
  ACC_TIM_KIEM_TAI_KHOAN: "Tìm kiếm tài khoản",
  ACC_TONG_SO_GIAO_DICH: "Tổng cộng {count} giao dịch",
  ACC_TRANG_THAI: "Trạng thái",
  ACC_TRA_SOAT_GIAO_DICH: "Tra soát giao dịch",
  ACC_WEBSITE: "Website",
  ACC_DANG_KI_TRUC_TUYEN: "Đăng ký trực tuyến",
  ACC_HOAC: "hoặc",
  ACC_PVCB_CONNECT_LA_GI: "PVcomBank Connect là gì?",
  ACC_DANH_SACH_TAI_KHOAN: "Danh sách tài khoản",
  ACC_LOAI_TAI_KHOAN: "Loại tài khoản",
  ACC_SO_TIEN_PHONG_TOA: "Số tiền phong tỏa",
  ACC_GIAO_DICH_GAN_NHAT: "Giao dịch gần nhất",
  ACC_HAN_MUC_THAU_CHI: "Hạn mức thấu chi",
  ACC_XEM_SAO_KE: "Xem sao kê",
  ACC_XUAT_SO_PHU: "Xuất sổ phụ",
  ACC_XUAT_EXCEL: "Xuất file excel",
  ACC_DIEN_THOAI_DI_DONG: "Điện thoại di động",
  ACC_DIEN_THOAI: "Điện thoại",
  ACC_GIAY_TO_TUY_THAN: "Giấy tờ tùy thân",
  ACC_SO_GIAY_TO: "Số giấy tờ tùy thân",
  ACC_NGAY_CAP: "Ngày cấp",
  ACC_DIA_CHI_NOI_CAP: "Địa chỉ nơi cấp",
  ACC_KIEU_XAC_THUC: "Kiểu xác thực",
  ACC_THAY_ANH_DAI_DIEN: "Thay đổi",
  ACC_XAC_THUC_SMS: "SMS",
  ACC_XAC_THUC_SMART_OTP: "Smart OTP",
  ACC_LAI_TRONG_NGAY: "Lãi suất trong ngày",
  ACC_SDT_XAC_THUC: "Số điện thoại xác thực",
  ACC_SO_LAI_NHAN_DUOC: "Số lãi nhận được",
  ACC_CHI_NHANH: "Chi nhánh",
  ACC_CHI_NHANH_QL_SO: "Chi nhánh quản lý sổ",
  ACC_NGAY_TRA_LAI_KE_TIEP: "Ngày trả lãi kế tiếp",
  ACC_LICH_SU_GIAO_DICH: "Lịch sử giao dịch",
  ACC_NGAY_GIAO_DICH: "Ngày giao dịch",
  ACC_SO_THAM_CHIEU: "Số tham chiếu",
  ACC_SO_TIEN_GHI_NO: "Số tiền ghi nợ",
  ACC_SO_TIEN_GHI_CO: "Số tiền ghi có",
  ACC_NOI_DUNG: "Nội dung",
  ACC_XEM_GIAO_DICH: "Xem giao dịch",
  ACC_TAI_VE: "Tải về",
  ACC_MIN: "Nhỏ nhất",
  ACC_MAX: "Lớn nhất",
  ACC_LOAI_GIAO_DICH: "Loại giao dịch",
  ACC_THANH_CONG: "Thành công",
  ACC_KHONG_THANH_CONG: "Không thành công",
  ACC_TRANG_THAI_GD: "Trạng thái giao dịch",
  ACC_TIM_NANG_CAO: "Tìm kiếm nâng cao",
  ACC_TIM_CO_BAN: "Tìm kiếm cơ bản",
  ACC_NGAY_LAP_LENH: "Ngày lập lệnh",
  ACC_PHI_GD: "Phí giao dịch",
  ACC_TK_NHAN: "Tài khoản nhận",
  ACC_TEN_NGUOI_NHAN: "Tên người nhận",
  ACC_TEN_NGUOI_CHUYEN: "Tên người chuyển",
  ACC_CHI_TIET_GIAO_DICH: "Chi tiết giao dịch",
  ACC_NGAN_HANG_NHAN: "Ngân hàng nhận",
  ACC_NGAN_HANG_CHUYEN: "Ngân hàng chuyển",
  ACC_CHUA_CO_GD_PHAT_SINH: "Chưa có giao dịch",

  ATM_BUTON_THONG_BAO_KHONG: "Không, cảm ơn",
  ATM_CHI_NHANH_ATM: "ATM",
  ATM_CHI_NHANH_CHI_NHANH: "Chi nhánh",
  ATM_CHI_NHANH_KHONG_TIM_THAY_TIM_KIEM: "Không tìm thấy kết quả theo yêu cầu",
  ATM_CHI_NHANH_TAT_CA: "Tất cả",
  ATM_NOI_DUNG_MO_LOCATION_SETTING:
    "Quý khách vui lòng truy cập Cài đặt - Ứng dụng trên thiết bị để cấp quyền truy cập vị trí cho ứng dụng.",
  ATM_THONG_BAO_BAT_LOCATION_THIET_BI: "PVcomBank cần vị trí của bạn. Vui lòng bật dịch vụ định vị của thiết bị.",

  AUTO_BILLING_DANG_KY_THANH_TOAN_HOA_DON_TU_DONG: "Đăng ký thanh toán hoá đơn tự động",
  AUTO_BILLING_DANG_KY_THANH_TOAN_TU_DONG_THANH_CONG: "Đăng ký thanh toán hóa đơn tự động thành công dịch vụ {dich_vu}",
  AUTO_BILLING_DANG_KY_THEM: "Đăng ký thêm",
  AUTO_BILLING_DICH_VU: "Dịch vụ",
  AUTO_BILLING_DICH_VU_CHUA_HO_TRO_DANG_KY: "Dịch vụ chưa hỗ trợ đăng ký thanh toán hóa đơn tự động",
  AUTO_BILLING_GHI_CHU: "Ghi chú",
  AUTO_BILLING_GOI_DICH_VU: "Gói dịch vụ",
  AUTO_BILLING_KHONG_CO_GIAO_DICH_NAO: "Không có giao dịch nào phát sinh.",
  AUTO_BILLING_LICH_SU_GIAO_DICH: "Lịch sử giao dịch",
  AUTO_BILLING_LI_DO: "Lý do",
  AUTO_BILLING_MA_HOA_DON: "Mã hoá đơn",
  AUTO_BILLING_MA_HOA_DON_DA_DANG_KY_THANH_TOAN_TU_DONG: "Mã hoá đơn hoặc mã khách hàng đã đăng ký thanh toán tự động.",
  AUTO_BILLING_MA_HOA_DON_KHACH_HANG: "Mã hoá đơn/Mã khách hàng/SĐT",
  AUTO_BILLING_MO_TA: "Mô tả",
  AUTO_BILLING_NGAY_DANG_KY: "Ngày đăng ký",
  AUTO_BILLING_NGAY_THANH_TOAN: "Ngày thanh toán",
  AUTO_BILLING_CHON_NGAY_THANH_TOAN: "Chọn ngày thanh toán",
  AUTO_BILLING_NGAY_THANH_TOAN_HOA_DON: "Ngày {ngay_thanh_toan} hàng tháng",
  AUTO_BILLING_NHA_CUNG_CAP: "Nhà cung cấp",
  AUTO_BILLING_NOTE_CHUYEN_NHANH_THU_HUONG_GIAO_DICH: "Để giao dịch nhanh hơn và không cần nhớ các thông tin?",
  AUTO_BILLING_PHUONG_THUC_THANH_TOAN: "Phương thức thanh toán",
  AUTO_BILLING_CHON_PHUONG_THUC_THANH_TOAN: "Chọn phương thức thanh toán",
  AUTO_BILLING_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  AUTO_BILLING_SO_TIEN: "Số tiền",
  AUTO_BILLING_TAI_KHOAN_NGUON: "Tài khoản nguồn",
  AUTO_BILLING_TAI_KHOAN_THANH_TOAN: "Tài khoản thanh toán",
  AUTO_BILLING_TAI_KHOAN_TRICH_NO: "Tài khoản trích nợ",
  AUTO_BILLING_THANH_TOAN_CO_DINH: "Ngày cố định hàng tháng",
  AUTO_BILLING_THANH_TOAN_HOA_DON_TU_DONG: "Thanh toán hoá đơn tự động",
  AUTO_BILLING_THANH_TOAN_NGAY_PHAT_SINH_NO: "Ngay khi phát sinh nợ",
  AUTO_BILLING_THOI_GIAN_GIAO_DICH: "Thời gian giao dịch",
  AUTO_BILLING_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Ngày bắt đầu và ngày kết thúc không quá 90 ngày.",
  AUTO_BILLING_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "Quý khách vui lòng chọn ngày bắt đầu trước ngày kết thúc.",
  AUTO_BILLING_THONG_BAO_TRANG_THAI_TAI_KHOAN:
    "Tài khoản thanh toán ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  AUTO_BILLING_THONG_TIN_DANG_KY: "Thông tin đăng ký",
  AUTO_BILLING_TRUY_VAN: "Truy vấn",
  AUTO_BILLING_VUI_LONG_CHON_NGAY_THANH_TOAN: "Quý khách vui lòng chọn ngày thanh toán.",
  AUTO_BILLING_VUI_LONG_CHON_MA_HOA_DON: "Quý khách vui lòng chọn Mã hoá đơn/Mã khách hàng/SĐT",
  AUTO_BILLING_VUI_LONG_NHAP_MA_HOA_DON: "Quý khách vui lòng nhập mã hóa đơn hoặc mã khách hàng cần thanh toán.",
  AUTO_BILLING_VUI_LONG_NHAP_NHA_CUNG_CAP: "Quý khách vui lòng nhập nhà cung cấp.",
  AUTO_SERVICE_XOA_DICH_VU: "Xoá hoá đơn dịch vụ",

  AUTO_TOPUP_DANH_SACH_DANG_KY_NAP_TIEN_TU_DONG: "Danh sách đăng ký nạp tiền tự động",
  AUTO_TOPUP_CHON_NGAY_DAT: "Chọn ngày nạp",
  AUTO_TOPUP_CHON_NGAY_NAP: "Chọn ngày nạp",
  AUTO_TOPUP_CHON_NHA_MANG: "Chọn nhà mạng",
  AUTO_TOPUP_DANG_KY_NAP_TIEN_TU_DONG: "Đăng ký nạp tiền tự động",
  AUTO_TOPUP_DANG_KY_NAP_TIEN_TU_DONG_THANH_CONG: "Đăng ký nạp tiền tự động thành công",
  AUTO_TOPUP_DANG_KY_THEM: "Đăng ký thêm",
  AUTO_TOPUP_HO_VA_TEN: "Họ và tên",
  AUTO_TOPUP_KHONG_CO_GIAO_DICH_NAO: "Không có giao dịch nào phát sinh.",
  AUTO_TOPUP_KHONG_CO_NHA_MANG: "Không có nhà mạng",
  AUTO_TOPUP_LAN_KHUYEN_MAI_DAU_TIEN: "Lần khuyến mại đầu tiên trong tháng",
  AUTO_TOPUP_LICH_SU_GIAO_DICH: "Lịch sử giao dịch",
  AUTO_TOPUP_MENH_GIA: "Mệnh giá",
  AUTO_TOPUP_NAP_TIEN_TU_DONG: "Nạp tiền tự động",
  AUTO_TOPUP_NGAY_DAT: "Ngày nạp",
  AUTO_TOPUP_NGAY_NAP: "Ngày nạp",
  AUTO_TOPUP_NGAY_THANH_TOAN: "Ngày thanh toán",
  AUTO_TOPUP_NHA_MANG: "Nhà mạng",
  AUTO_TOPUP_NOTE_CHUYEN_NHANH_THU_HUONG_GIAO_DICH: "Để giao dịch nhanh hơn và không cần nhớ các thông tin?",
  AUTO_TOPUP_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  AUTO_TOPUP_SO_DIEN_THOAI: "Số điện thoại",
  AUTO_TOPUP_SO_DIEN_THOAI_DA_DANG_KY_NAP_TIEN_TU_DONG: "Số điện thoại đã đăng ký dịch vụ nạp tiền tự động",
  AUTO_TOPUP_SO_DIEN_THOAI_KHONG_HOP_LE: "Số điện thoại không chính xác. Quý khách vui lòng kiểm tra lại.",
  AUTO_TOPUP_SO_TIEN: "Số tiền",
  AUTO_TOPUP_TAI_KHOAN_NGUON: "Tài khoản nguồn",
  AUTO_TOPUP_TAI_KHOAN_THANH_TOAN: "Tài khoản thanh toán",
  AUTO_TOPUP_TAI_KHOAN_TRICH_NO: "Tài khoản trích nợ",
  AUTO_TOPUP_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Ngày bắt đầu và ngày kết thúc không quá 90 ngày.",
  AUTO_TOPUP_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "Quý khách vui lòng chọn ngày bắt đầu trước ngày kết thúc.",
  AUTO_TOPUP_THONG_BAO_TRANG_THAI_TAI_KHOAN:
    "Tài khoản thanh toán ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  AUTO_TOPUP_THONG_TIN_DANG_KY: "Thông tin đăng ký",
  AUTO_TOPUP_THONG_TIN_NAP_TIEN: "Thông tin nạp tiền",
  AUTO_TOPUP_TIM_NHA_MANG: "Tìm nhà mạng",
  AUTO_TOPUP_VUI_LONG_CHON_NHA_MANG: "Quý khách vui lòng chọn nhà mạng",
  AUTO_TOPUP_VUI_LONG_CHON_SO_DIEN_THOAI: "Quý khách vui lòng chọn số điện thoại",
  AUTO_TOPUP_VUI_LONG_CHON_TAI_KHOAN_NGUON: "Quý khách vui lòng chọn tài khoản thanh toán",
  AUTO_TOPUP_VUI_LONG_NHAP_HO_VA_TEN: "Quý khách vui lòng nhập họ và tên",
  AUTO_TOPUP_VUI_LONG_NHAP_SO_DIEN_THOAI: "Quý khách vui lòng nhập số điện thoại",
  AUTO_TOPUP_NGAY_NAP_HANG_THANG: "Ngày {ngay} hàng tháng",

  BENE_CARD_NAP_TIEN_VAO_THE_TRA_TRUOC: "Nạp tiền vào thẻ trả trước",
  BENE_CARD_THANH_TOAN_THE_TIN_DUNG: "Thanh toán thẻ tín dụng",
  BENE_CASH_BY_CODE_TITLE: "Chuyển tiền qua code",
  BENE_CHI_TIET_THU_HUONG: "Chi tiết thụ hưởng",
  BENE_CHON_LOAI_GIAO_DICH: "Chọn loại giao dịch",
  BENE_CHUA_CO_THONG_TIN_THU_HUONG: "Chưa có thông tin thụ hưởng",
  BENE_CHON_TK_THU_HUONG: "Chọn tài khoản thụ hưởng",
  BENE_CHON_HOA_DON_DANH_SACH: "Chọn hoá đơn",
  BENE_CHON_SDT_TK_DV: "Chọn Số điện thoại/ Tài khoản",
  BENE_CHON_SDT: "Chọn Số điện thoại",
  BENE_CHUC_NANG_SAP_RA_MAT: "Chức năng sắp ra mắt",
  BENE_CHUYEN_DEN_PROFILE_KHAC: "Chuyển đến profile khác",
  BENE_CHUYEN_TIEN: "Chuyển tiền",
  BENE_CHUYEN_TIEN_CHUNG_KHOAN: "Chuyển tiền chứng khoán",
  BENE_CHUYEN_TIEN_NGOAI_PVCOMBANK: "Chuyển tiền ngoài PVcomBank",
  BENE_CHUYEN_TIEN_NHANH_247: "Chuyển tiền nhanh 24/7",
  BENE_CHUYEN_TIEN_TRONG_PVCOMBANK: "Chuyển tiền trong PVcomBank",
  BENE_DANH_SACH_THU_HUONG: "Danh sách thụ hưởng",
  BENE_DANH_SACH_THU_HUONG_CHUYEN_DEN: "Danh sách thụ hưởng",
  BENE_DIA_CHI: "Địa chỉ",
  BENE_DICH_VU: "Dịch vụ",
  BENE_DICH_VU_CHUNG_KHOAN: "Dịch vụ chứng khoán",
  BENE_HET_DU_LIEU: "Hết dữ liệu",
  BENE_HO_TEN: "Họ tên",
  BENE_HUY: "Hủy",
  BENE_KHONG_CO_THONG_TIN_YEU_CAU: "Không có kết quả tìm kiếm theo yêu cầu",
  BENE_KHONG_PHAI_KI_TU_TRONG_BANG_CHU_CAI: "Other",
  BENE_LOAI_GIAO_DICH: "Loại giao dịch",
  BENE_LUU: "Lưu",
  BENE_MA_HOA_DON: "Mã hoá đơn",
  BENE_NAP_TIEN: "Nạp tiền",
  BENE_NGAN_HANG: "Ngân hàng",
  BENE_NGOAI_NGAN_HANG: "Ngoài PVcomBank",
  BENE_NHA_CUNG_CAP: "Nhà cung cấp",
  BENE_QUY_KHACH_CHUA_TAO_LOAI_THU_HUONG_NAO: "Quý khách chưa tạo loại hình thụ hưởng nào. Vui lòng nhấn tạo mới bên dưới",
  BENE_QUY_KHACH_CO_MUON_XOA_PROFILE_THU_HUONG: "Quý khách có chắc chắn muốn xoá profile này không ?",
  BENE_QUY_KHACH_MUON_HUY_TEMPLATE_THU_HUONG: "Quý khách có chắc chắn muốn xóa thông tin thụ hưởng này không?",
  BENE_QUY_KHACH_MUON_HUY_THU_HUONG: "Thông tin thụ hưởng chưa được lưu. Quý khách có chắc chắn muốn Hủy?",
  BENE_SO_DIEN_THOAI: "Số điện thoại",
  BENE_SO_DIEN_THOAI_KHONG_HOP_LE: "Số điện thoại không chính xác. Quý khách vui lòng kiểm tra lại.",
  BENE_SO_DIEN_THOAI_SO_TAI_KHOAN: "Số điện thoại/Số tài khoản",
  BENE_SO_DIEN_THOAI_SO_TAI_KHOAN_KHONG_DUOC_DE_TRONG: "Quý khách vui lòng nhập số điện thoại / số tài khoản.",
  BENE_SO_DIEN_THOAI_TAI_KHOAN_DICH_VU: "Số điện thoại/Tài khoản dịch vụ",
  BENE_MA_HD_KH_SDT: "Mã HĐ/Mã KH/SĐT",
  BENE_SO_DIEN_THOAI_TAI_KHOAN_KHONG_TON_TAI: "Số điện thoại/Số tài khoản không tồn tại.",
  BENE_SO_TAI_KHOAN: "Số tài khoản",
  BENE_SO_TAI_KHOAN_SO_THE: "Số tài khoản/ Số thẻ",
  BENE_SO_TAI_KHOAN_CHUNG_KHOAN: "Số tài khoản chứng khoán",
  BENE_SO_THE: "Số thẻ",
  BENE_SO_THE_THU_HUONG_KHONG_DUOC_DE_TRONG: "Quý khách vui lòng nhập số thẻ thụ hưởng",
  BENE_SO_TIEN: "Số tiền",
  BENE_SUA: "Sửa",
  BENE_SUA_GIAO_DICH_THU_HUONG: "Sửa thông tin thụ hưởng",
  BENE_TAI_KHOAN_THU_HUONG_KHONG_TON_TAI: "Tài khoản thụ hưởng không tồn tại.",
  BENE_TAI_KHOAN_CUA_TOI: "Tài khoản của tôi",
  BENE_TAI_KHOAN_THU_HUONG: "Tài khoản thụ hưởng",
  BENE_TEN_CHU_TAI_KHOAN: "Tên chủ tài khoản",
  BENE_THANH_TOAN: "Thanh toán",
  BENE_THANH_TOAN_CUOC_VIEN_THONG: "Thanh toán cước viễn thông",
  BENE_THANH_TOAN_HOA_DON: "Thanh toán hoá đơn",
  BENE_THEM_GIAO_DICH_THU_HUONG: "Thông tin thụ hưởng",
  BENE_THEM_LOAI_HINH_THU_HUONG: "Thêm loại hình thụ hưởng",
  BENE_THONG_BAO_KIEM_TRA_SO_THE: "Số thẻ không chính xác . Quý khách vui lòng kiểm tra lại",
  BENE_THONG_TIN_THU_HUONG: "Thông tin thụ hưởng",
  BENE_TIM_KIEM: "Tìm kiếm",
  BENE_TRONG_PVCOMBANK: "Trong PVcomBank",
  BENE_TUY_CHON: "Tuỳ chọn",
  BENE_UA_THICH: "Ưa thích",
  BENE_VAN_TIN_TAI_KHOAN: "Vấn tin tài khoản",
  BENE_VUI_LONG_CHON_CHI_NHANH: "Quý khách vui lòng chọn chi nhánh",
  BENE_VUI_LONG_CHON_KHU_VUC: "Quý khách vui lòng chọn khu vực",
  BENE_VUI_LONG_CHON_NGAN_HANG: "Quý khách vui lòng chọn ngân hàng",
  BENE_VUI_LONG_NHAP_CHI_NHANH_KHAC: "Quý khách vui lòng chọn chi nhánh khác",
  BENE_VUI_LONG_NHAP_HO_VA_TEN: "Quý khách vui lòng nhập họ và tên",
  BENE_VUI_LONG_NHAP_MA_HOA_DON_THU_HUONG: "Quý khách vui lòng nhập mã hóa đơn hoặc mã khách hàng.",
  BENE_VUI_LONG_NHAP_SO_DIEN_THOAI: "Quý khách vui lòng nhập số điện thoại",
  BENE_VUI_LONG_NHAP_SO_DIEN_THOAI_SO_TAI_KHOAN: "Quý khách vui lòng nhập số điện thoại / tài khoản",
  BENE_VUI_LONG_NHAP_SO_TAI_KHOAN: "Quý khách vui lòng nhập số tài khoản",
  BENE_VUI_LONG_NHAP_SO_TAI_KHOAN_CHUNG_KHOAN: "Quý khách vui lòng nhập số tài khoản chứng khoán",
  BENE_VUI_LONG_NHAP_SO_TAI_KHOAN_KHONG_CO_DAU: "Vui lòng không được nhập số tài khoản là Tiếng Việt có dấu và ký tự đặc biệt",
  BENE_VUI_LONG_NHAP_SO_THE: "Quý khách vui lòng nhập số thẻ",
  BENE_VUI_LONG_NHAP_SO_THE_KHONG_CO_DAU: "Vui lòng không được nhập Thẻ ATM là Tiếng Việt có dấu và ký tự đặc biệt",
  BENE_VUI_LONG_NHAP_TEN_TAI_KHOAN: "Quý khách vui lòng nhập tên tài khoản",
  BENE_VUI_LONG_NHAP_TEN_TAI_KHOAN_CHUNG_KHOAN: "Quý khách vui lòng nhập họ tên chủ tài khoản chứng khoán",
  BENE_VUI_LONG_NHAP_TEN_TAI_KHOAN_KHONG_CO_DAU:
    "Vui lòng không được nhập tên tài khoản là Tiếng Việt có dấu và ký tự đặc biệt ngoại trừ dấu gạch ngang và dấu chấm",
  BENE_VUI_LONG_NHAP_TEN_GOI_NHO: "Quý khách vui lòng nhập tên gợi nhớ",
  BENE_XOA: "Xoá",
  BENE_LUU_THU_HUONG: "Lưu thụ hưởng",
  BENE_TEN_GOI_NHO: "Tên gợi nhớ",

  BIEU_DO_MAX: "Tối đa (VND)",
  BIEU_DO_MIN: "Tối thiểu (VND)",

  BILLING_CHUA_DANG_KY_THANH_TOAN_GIAO_DICH: "Quý khách chưa có hóa đơn nào đăng ký thanh toán tự động.",
  BILLING_CHUC_NANG_THANH_TOAN_HOA_DON: "Thanh toán hoá đơn",
  BILLING_DICH_VU: "Dịch vụ",
  BILLING_DIEN_THOAI_CO_DINH: "Điện thoại cố định",
  BILLING_DIEN_THOAI_CO_DINH_GPHONE_VNPT: "Điện thoại cố định, Gphone- VNPT",
  BILLING_DIEN_THOAI_HOME_PHONE: "Điện thoại Homephone",
  BILLING_DV_CONG: "Dịch vụ công",
  BILLING_DV_TRUYEN_HINH: "Dịch vụ truyền hình",
  BILLING_DV_TRUYEN_HINH_VNPT: "Dịch vụ truyền hình - VNPT",
  BILLING_GOI_DICH_VU: "Gói dịch vụ",
  BILLING_HOA_DON_ADSL: "Hoá đơn ADSL",
  BILLING_HOA_DON_ADSL_VNPT: "Hoá đơn ADSL - VNPT",
  BILLING_HOA_DON_DIEN_THOAI_TRA_SAU: "Hóa đơn điện thoại trả sau",
  BILLING_HOA_DON_INTERNET_TV: "Hóa đơn Internet TV",
  BILLING_HOA_DON_LEASED_LINE: "Hóa đơn Leased-line",
  BILLING_KHONG_CO_DU_LIEU: "Không có dữ liệu",
  BILLING_MA_HOA_DON: "Mã hoá đơn",
  BILLING_MA_HOA_DON_KHACH_HANG: "Mã khách hàng/ Mã hoá đơn/ Số điện thoại",
  BILLING_MA_HOA_DON_KHACH_HANG_KHONG_DUNG: "Mã khách hàng/ Mã hoá đơn/ Số điện thoại không hợp lệ",
  BILLING_MA_KHACH_HANG: "Mã khách hàng",
  BILLING_NAP_TIEN_THANH_CONG: "Thanh toán {so_tien} thành công hóa đơn {hoa_don} có mã {ma}",
  BILLING_NGAY_THANH_TOAN: "Ngày thanh toán",
  BILLING_NHA_CUNG_CAP: "Nhà cung cấp",
  BILLING_NOTE_GIAO_DICH_NHANH_THU_HUONG: "Để giao dịch nhanh hơn và không cần nhớ các thông tin?",
  BILLING_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  BILLING_SO_TIEN: "Số tiền",
  BILLING_SO_TIEN_THANH_TOAN: "Số tiền thanh toán",
  BILLING_TAI_KHOAN_NGUON: "Tài khoản nguồn",
  BILLING_THANH_TOAN_HOA_DON: "Thanh toán hoá đơn",
  BILLING_THONG_BAO_TRANG_THAI_TAI_KHOAN_CHUYEN:
    "Tài khoản chuyển ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  BILLING_THONG_TIN_HOA_DON: "Thông tin hóa đơn",
  BILLING_TIEN_DIEN: "Tiền điện",
  BILLING_TIEN_NUOC: "Tiền nước",
  BILLING_TIM_GOI_DICH_VU: "Tìm gói dịch vụ",
  BILLING_TIM_NHA_CUNG_CAP: "Tìm nhà cung cấp",
  BILLING_VE_MAY_BAY: "Vé máy bay",
  BILLING_VE_MAY_BAY_NEW: "Vé máy bay",
  BILLING_VUI_LONG_NHAP_MA_HOA_DON: "Quý khách vui lòng nhập mã hóa đơn hoặc mã khách hàng cần thanh toán.",
  BILLING_VUI_LONG_CHON_DICH_VU: "Quý khách vui lòng chọn dịch vụ",
  BILLING_VUI_LONG_CHON_NHA_CUNG_CAP: "Quý khách vui lòng chọn nhà cung cấp",
  BILLING_VUI_LONG_CHON_GOI_DICH_VU: "Quý khách vui lòng chọn gói dịch vụ",
  BILLING_THANH_TOAN_TOAN_BO_CUOC: "Thanh toán toàn bộ cước",

  CARD_BAN_CHUA_DANG_KI_LOAI_THE_GHI_NO_NAY: "Quý khách chưa có thẻ ghi nợ nào",
  CARD_BAN_CHUA_DANG_KI_LOAI_THE_NAY: "Quý khách chưa có thẻ nào",
  CARD_BAN_CHUA_DANG_KI_LOAI_THE_TIN_DUNG_NAY: "Quý khách chưa có thẻ tín dụng nào",
  CARD_BAN_CHUA_DANG_KI_LOAI_THE_TRA_TRUOC_NAY: "Quý khách chưa có thẻ trả trước nào",
  CARD_BY_CODE_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  CARD_CHECK_NOTE_DIEU_KHOAN: "Tôi đã đọc, hiểu và đồng ý với Điều khoản & Điều kiện phát hành thẻ trả trước phi vật lý của PVcomBank",
  CARD_CHI_TIET_THE: "Chi tiết thẻ",
  CARD_CHON_HINH_THUC_THANH_TOAN: "Chọn hình thức thanh toán",
  CARD_CHON_LOAI_PHAT_HANH_THE: "Loại phát hành thẻ",
  CARD_CHON_NGUON_KHAC: "CHỌN NGUỒN KHÁC",
  CARD_CHU_THE: "Chủ thẻ",
  CARD_DANG_KY: "Đăng ký",
  CARD_DANG_KY_PHAT_HANH_THE_PV: "MỞ THẺ NGAY",
  CARD_DANG_KY_PHAT_HANH_THE_VAT_LY: "Đăng ký phát hành thẻ vật lý",
  CARD_DANH_SACH_THE: "Danh sách thẻ",
  CARD_DANH_SACH_THE_TIN_DUNG: "Danh sách thẻ tín dụng",
  CARD_DAT_LAM_THE_THANH_TOAN_MAC_DINH: "Đặt làm thẻ thanh toán mặc định",
  CARD_DA_CO_LOI_XAY_RA: "Đã có lỗi xảy ra",
  CARD_DIA_CHI: "Địa chỉ",
  CARD_DICH_VU: "Dịch vụ",
  CARD_DICH_VU_THE: "Dịch vụ thẻ",
  CARD_DIEU_KHOAN_DIEU_KIEN_SU_DUNG: "Điều khoản và điều kiện sử dụng",
  CARD_DIEU_KHOAN_PHAT_HANH_THE_VAT_LY:
    "Tôi đảm bảo rằng mọi thông tin tôi cung cấp trên đây là hoàn toàn chính xác. Tôi xác nhận đã đọc và đồng ý với Điều khoản, điều kiện phát hành & sử dụng thẻ PVcomBank. Tôi đồng ý cho phép PVcomBank sử dụng các thông tin của tôi để giới thiệu các sản phẩm, dịch vụ và chương trình khuyến mãi của PVcomBank từ nay trở về sau.",
  CARD_DOWNLOAD_FILE_SAO_KE: "Tải về sao kê chi tiết",
  CARD_DU_NO: "Dư nợ",
  CARD_DU_NO_CAN_THANH_TOAN: "Dư nợ cần thanh toán",
  CARD_DU_NO_CON_LAI: "Dư nợ còn lại",
  CARD_EMAIL: "Email",
  CARD_GHI_CHU_KHONG_NAP_TIEN_NGAY: "Nếu không nạp tiền ngay khi phát hành thẻ. Quý khách vui lòng không nhập số tiền.",
  CARD_GIAO_DICH_KHAC: "Giao dịch khác",
  CARD_GIOI_THIEU_CHUC_NANG_PHAT_HANH_THE_VAT_LY:
    "Quý khách vui lòng để lại thông tin và PVcomBank sẽ liên hệ với Quý Khách trong thời gian sớm nhất",
  CARD_HAN_MUC_GIAO_DICH_ATM: "Hạn mức rút tiền ATM",
  CARD_HAN_MUC_GIAO_DICH_ATM_ASC: "Hạn mức rút tiền ATM tối đa một ngày là {}",
  CARD_HAN_MUC_GIAO_DICH_ATM_DESC: "Hạn mức rút tiền ATM tối đa một ngày là {}",
  CARD_HAN_MUC_GIAO_DICH_CHUYEN_TIEN: "Hạn mức giao dịch chuyển tiền/ ngày",
  CARD_HAN_MUC_GIAO_DICH_NGAY: "Hạn mức giao dịch ngày",
  CARD_HAN_MUC_GIAO_DICH_RUT_ATM: "Hạn mức giao dịch rút tiền ATM/ ngày",
  CARD_HAN_MUC_GIAO_DICH_THUONG_MAI_ASC: "Hạn mức giao dịch thương mại điện tử tối đa một ngày là {}",
  CARD_HAN_MUC_GIAO_DICH_THUONG_MAI_DESC: "Hạn mức giao dịch thương mại điện tử tối đa một ngày là {}",
  CARD_HAN_MUC_GIAO_DICH_THUONG_MAI_DIEN_TU: "Hạn mức giao dịch Thương mại điện tử",
  CARD_HAN_MUC_GIAO_DICH_TRUC_TUYEN: "Hạn mức giao dịch trực tuyến/ ngày",
  CARD_HAN_MUC_THE: "Hạn mức thẻ",
  CARD_HO_VA_TEN: "Họ và tên",
  CARD_KHOA: "Khóa",
  CARD_KHOA_GIAO_DICH_TRUC_TUYEN: "Khóa giao dịch trực tuyến",
  CARD_KHOA_MO_GIAO_DICH_TRUC_TUYEN: "Khóa/Mở giao dịch trực tuyến",
  CARD_KHOA_MO_GIAO_DICH_TRUC_TUYEN_FUN: "Khóa/Mở khóa giao dịch trực tuyến",
  CARD_KHOA_MO_THE: "Khóa/Mở thẻ",
  CARD_KHOA_MO_THE_FUN: "Kích hoạt/Khóa/Mở khóa thẻ",
  CARD_KHOA_THE: "Khóa thẻ",
  CARD_KICH_HOAT: "Kích hoạt",
  CARD_KICH_HOAT_NHAP_4_SO_CUOI: "Quý khách vui lòng nhập 4 số cuối trên thẻ",
  CARD_KICH_HOAT_GIAO_DICH_TRUC_TUYEN: "Kích hoạt giao dịch trực tuyến",
  CARD_KICH_HOAT_THE: "Kích hoạt thẻ",
  CARD_LICH_SU_GIAO_DICH: "Lịch sử giao dịch",
  CARD_LOAI_THE: "Loại thẻ",
  CARD_CHON_LOAI_THE: "Chọn loại thẻ",
  CARD_LOI_THAM_SO: "Lỗi tham số",
  CARD_MAX: "MAX",
  CARD_MA_GIAO_DICH: "Mã giao dịch",
  CARD_MIN: "MIN",
  CARD_MO: "Mở",
  CARD_MO_TA: "Mô tả",
  CARD_MO_THE: "Mở khóa thẻ",
  CARD_NAP_TIEN_THE_TRA_TRUOC: "Nạp tiền thẻ trả trước",
  CARD_NAP_TIEN_VAO_THE: "Nạp tiền vào thẻ",
  CARD_NAP_TIEN_VAO_THE_TRA_TRUOC: "Nạp tiền vào thẻ trả trước",
  CARD_NGAY_DEN_HAN_THANH_TOAN: "Ngày đến hạn thanh toán",
  CARD_NGAY_SAO_KE: "Ngày sao kê",
  CARD_NGUON_THANH_TOAN: "Nguồn thanh toán",
  CARD_NHAP_SO_THE_KHONG_HOP_LE: "Số thẻ không chính xác . Quý khách vui lòng kiểm tra lại",
  CARD_NOTE_CHUYEN_NHANH_THU_HUONG: "Để chuyển tiền nhanh hơn và không cần nhớ các thông tin?",
  CARD_PHAT_HANH_THE: "Phát hành thẻ",
  CARD_PHAT_HANH_THEM: "Phát hành thêm",
  CARD_PHAT_HANH_THE_TRA_TRUOC: "Phát hành thẻ trả trước",
  CARD_PHAT_HANH_THE_VAT_LY: "Phát hành thẻ vật lý",
  CARD_PHI_GIAO_DICH: "Phí giao dịch",
  CARD_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  CARD_SAO_KE_THE: "Sao kê thẻ",
  CARD_SAO_KE_THE_TIN_DUNG: "Sao kê thẻ tín dụng",
  CARD_SO_CVC: "Số CVC",
  CARD_SO_DIEN_THOAI: "Số điện thoại",
  CARD_SO_DIEN_THOAI_KHONG_HOP_LE: "Số điện thoại không chính xác. Quý khách vui lòng kiểm tra lại.",
  CARD_SO_DU_THE: "Số dư thẻ",
  CARD_SO_DU_KHA_DUNG: "Số dư khả dụng",
  CARD_SO_TAI_KHOAN: "Số tài khoản",
  CARD_SO_THE: "Số thẻ",
  CARD_SO_THE_KHAC: "Số thẻ khác",
  CARD_SO_THE_NAP: "Số thẻ nạp",
  CARD_SO_TIEN: "Số tiền",
  CARD_SO_TIEN_NAP: "Số tiền nạp",
  CARD_SO_TIEN_NAP_TOI_DA_THE_VO_DANH: "Số tiền nạp tối đa là {so_tien}",
  CARD_SO_TIEN_NAP_TOI_THIEU: "Số tiền nạp tối thiểu là {so_tien}",
  CARD_SO_TIEN_THANH_TOAN: "Số tiền thanh toán",
  CARD_SO_TIEN_THANH_TOAN_TOI_THIEU: "Số tiền thanh toán tối thiểu",
  CARD_SO_TIEN_THANH_TOAN_TOI_THIEU_KHONG_DU: "Số tiền thanh toán tối thiểu hiện tại không đủ để thực hiện giao dịch",
  CARD_SO_TIEN_THANH_TOAN_KHONG_HOP_LE: "Số tiền thanh toán không hợp lệ",
  CARD_SO_TIEN_TOI_DA_NGAY: "Số tiền tối đa/ngày",
  CARD_SO_TIEN_TONG_DU_NO_KHONG_DU: "Số tiền tổng dư nợ hiện tại không đủ để thực hiện giao dịch",
  CARD_TAB_KICH_HOAT_THE: "Kích hoạt{new_line}thẻ",
  CARD_TAB_LICH_SU_GD: "Lịch sử{new_line}giao dịch",
  CARD_TAB_SAO_KE: "Sao kê",
  CARD_TAB_THANH_TOAN_DU_NO: "Thanh toán{new_line}dư nợ",
  CARD_TAB_THONG_TIN_THE: "Thông tin{new_line}thẻ",
  CARD_TAI_KHOAN_CHUYEN: "Tài khoản chuyển",
  CARD_TAI_KHOAN_NGUON: "Tài khoản nguồn",
  CARD_TAI_KHOAN_THANH_TOAN: "Tài khoản thanh toán",
  CARD_TAI_KHOAN_THE: "Tài khoản thẻ",
  CARD_TAT_CA_CARD_DANH_SACH_THE: "Tất cả danh sách thẻ",
  CARD_TEN_CHU_THE: "Tên chủ thẻ",
  CARD_TEXT_NGAY_SAO_KE: "Ngày [date] hàng tháng",
  CARD_THANG_SAO_KE: "Tháng sao kê",
  CARD_THANH_TOAN_CHO_THE: "Thanh toán cho thẻ",
  CARD_THANH_TOAN_DU_NO: "Thanh toán dư nợ",
  CARD_THANH_TOAN_THE: "Thanh toán thẻ",
  CARD_THANH_TOAN_THE_TIN_DUNG: "Thanh toán thẻ tín dụng",
  CARD_THANH_TOAN_THE_TIN_DUNG_CHU_THE: "Chủ thẻ",
  CARD_THANH_TOAN_THE_TIN_DUNG_DICH_VU: "Dịch vụ",
  CARD_THANH_TOAN_THE_TIN_DUNG_HINH_THUC_THANH_TOAN: "Hình thức thanh toán",
  CARD_THANH_TOAN_THE_TIN_DUNG_NOI_DUNG: "Nội dung",
  CARD_THANH_TOAN_THE_TIN_DUNG_SO_THE: "Số thẻ",
  CARD_THANH_TOAN_THE_TIN_DUNG_SO_TIEN_THANH_TOAN: "Số tiền thanh toán",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_CA_NHAN: "Thanh toán cá nhân",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_DU_NO: "Thanh toán dư nợ",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_HO: "Thanh toán hộ",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_TOAN_BO_DU_NO: "Thanh toán toàn bộ dư nợ kì sao kê",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_TOI_THIEU: "Thanh toán tối thiểu",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_TUY_CHON: "Thanh toán tuỳ chọn",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch ?",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_NOI_DUNG_THANH_TOAN_KHONG_HOP_LE:
    "Vui lòng không được nhập Nội dung là Tiếng việt có dấu và ký tự đặc biệt ngoại trừ dấu gạch ngang và dấu chấm",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_SO_TIEN_TOI_THIEU: "Số tiền giao dịch tối thiểu là 10.000 VND",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_VUI_LONG_NHAP_DU_THONG_TIN: "Quý khách vui lòng nhập đủ thông tin",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_VUI_LONG_NHAP_NOI_DUNG_THANH_TOAN: "Quý khách vui lòng nhập nội dung giao dịch",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_VUI_LONG_NHAP_SO_THE: "Quý khách vui lòng nhập số thẻ",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_VUI_LONG_NHAP_SO_TIEN_THANH_TOAN: "Quý khách vui lòng nhập số tiền giao dịch",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_VUI_LONG_NHAP_TEN_CHU_THE: "Quý khách vui lòng nhập tên chủ thẻ",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_LOI_SO_TIEN_THANH_TOAN_TOI_THIEU:
    "Số tiền giao dịch lớn hơn hoặc bằng số tiền thanh toán tối thiểu",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_THE_SAI_SO_THE: "Số thẻ không chính xác! Quý khách vui lòng kiểm tra lại",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_TIN_THANH_TOAN: "Thông tin thanh toán",
  CARD_THANH_TOAN_THE_TIN_DUNG_TONG_DU_NO: "Tổng dư nợ kì sao kê",
  CARD_THANH_TOAN_THE_TIN_DUNG_KIEU: "Kiểu",
  CARD_THAY_DOI_HAN_MUC_GIAO_DICH_NGAY: "Thay đổi hạn mức giao dịch ngày",
  CARD_THE_GHI_NO: "Thẻ ghi nợ",
  CARD_THE_TIN_DUNG: "Thẻ tín dụng",
  CARD_THE_TRA_TRUOC: "Thẻ trả trước",
  CARD_THE_TRA_TRUOC_DINH_DANH: "Thẻ trả trước định danh",
  CARD_THE_TRA_TRUOC_VO_DANH: "Thẻ trả trước vô danh",
  CARD_THE_GHI_NO_NOI_DIA: "Thẻ ghi nợ nội địa",
  CARD_THE_GHI_NO_QUOC_TE: "Thẻ ghi nợ quốc tế",
  CARD_THE_PHU: "Thẻ phụ",
  CARD_THE_VO_DANH_SO_TIEN_NAP_LON_HON_MUC_TOI_DA_CHO_PHEP: "Số tiền nạp vào thẻ vô danh tối đa là 5 triệu đồng.",
  CARD_THOI_GIAN: "Thời gian",
  CARD_THONG_BAO_CHUA_CHON_LOAI_THE: "Quý khách chưa chọn loại thẻ. Vui lòng chọn loại thẻ để tiếp tục",
  CARD_THONG_BAO_CHUA_CHON_THE: "Quý khách vui lòng chọn thẻ",
  CARD_THONG_BAO_EMAIL_KHONG_HOP_LE: "Email không đúng định dạng. Quý khách vui lòng kiểm tra lại.",
  CARD_THONG_BAO_EMAIL_TRONG: "Quý khách vui lòng nhập email",
  CARD_THONG_BAO_GIAO_DICH_ONLINE_CHUYEN_SANG_HAN_MUC_TOI_DA:
    "Quý khách có muốn tăng hạn mức giao dịch thương mại điện tử một ngày của thẻ [card_num] lên mức tối đa không?",
  CARD_THONG_BAO_GIAO_DICH_ONLINE_CHUYEN_SANG_HAN_MUC_TOI_DA_THANH_CONG:
    "Hạn mức giao dịch thương mại điện tử một ngày của thẻ [card_num] đã được tăng lên mức tối đa.",
  CARD_THONG_BAO_GIAO_DICH_ONLINE_CHUYEN_SANG_HAN_MUC_TOI_THIEU:
    "Quý khách có muốn giảm hạn mức giao dịch thương mại điện tử một ngày của thẻ [card_num] xuống mức tối thiểu không?",
  CARD_THONG_BAO_GIAO_DICH_ONLINE_CHUYEN_SANG_HAN_MUC_TOI_THIEU_THANH_CONG:
    "Hạn mức giao dịch thương mại điện tử một ngày của thẻ [card_num] đã được giảm xuống mức tối thiểu",
  CARD_THONG_BAO_HOI_HUY_LAM_THANH_TOAN_MAC_DINH: "Quý khách muốn hủy chọn tài khoản [acc_number] làm nguồn thanh toán mặc định?",
  CARD_THONG_BAO_HOI_KHOA_GIAO_DICH_TRUC_TUYEN: "Quý khách có chắc chắn muốn khóa tính năng giao dịch trực tuyến của thẻ [card_num]?",
  CARD_THONG_BAO_HOI_KHOA_THE: "Quý khách có chắc chắn muốn khóa thẻ [card_num] không?",
  CARD_THONG_BAO_HOI_KICH_HOAT_THE: "Quý khách có đồng ý kích hoạt thẻ [card_num] không?",
  CARD_THONG_BAO_LOI_KICH_HOAT_THE: "Quý khách đã nhập sai [num1] lần. Số lần nhập còn lại: [num2]",
  CARD_THONG_BAO_LOI_KICH_HOAT_THE_LIMIT:
    "Quý khách đã nhập sai 4 số cuối trên thẻ quá số lần cho phép. Vui lòng quay trở lại sau hoặc liên hệ Tổng đài Dịch vụ khách hàng 24/7 1900 5555 92 để được hỗ trợ.",
  CARD_THONG_BAO_HOI_LAM_THANH_TOAN_MAC_DINH: "Quý khách muốn chọn tài khoản [acc_number] làm nguồn thanh toán mặc định?",
  CARD_THONG_BAO_HOI_MO_THE: "Quý khách có chắc chắn muốn mở khóa thẻ [card_num] không?",
  CARD_THONG_BAO_HO_VA_TEN_KHONG_KI_TU_DAC_BIET: "Vui lòng không được nhập họ tên chứa ký tự đặc biệt ngoại trừ dấu gạch ngang và dấu chấm",
  CARD_THONG_BAO_HO_VA_TEN_TRONG: "Quý khách vui lòng nhập họ tên",
  CARD_THONG_BAO_HUY_CHON_LAM_THANH_TOAN_MAC_DINH: "Nguồn thanh toán mặc định là tài khoản [acc_number]",
  CARD_THONG_BAO_KHOA_GIAO_DICH_ONLINE_THANH_CONG: "Đã khóa tính năng giao dịch trực tuyến trên thẻ [card_num].",
  CARD_THONG_BAO_KHOA_THE_THANH_CONG: "Khóa thẻ [card_num] thành công.",
  CARD_THONG_BAO_KHONG_CO_THE_TIN_DUNG_THANH_TOAN: "Quý khách không có thẻ tín dụng. Quý khách có muốn sử dụng thanh toán hộ",
  CARD_THONG_BAO_KHONG_TON_TAI_GIAO_DICH_NAO: "Không có giao dịch nào phát sinh",
  CARD_THONG_BAO_KICH_HOAT_GIAO_DICH_TRUC_TUYEN:
    "Quý khách có chắc chắn muốn kích hoạt tính năng giao dịch trực tuyến của thẻ [card_num] không?",
  CARD_THONG_BAO_KICH_HOAT_GIAO_DICH_TRUC_TUYEN_THANH_CONG: "Đã kích hoạt tính năng giao dịch trực tuyến trên thẻ [card_num] thành công.",
  CARD_THONG_BAO_KICH_HOAT_THE_CREDIT_THANH_CONG: "Thẻ [card_num] đã được kích hoạt thẻ thành công.",
  CARD_THONG_BAO_KICH_HOAT_THE_DEBIT_THANH_CONG:
    "Thẻ [card_num] đã được kích hoạt thẻ thành công. Quý khách vui lòng đổi PIN tại ATM của PVcomBank để sử dụng thẻ.",
  CARD_THONG_BAO_KIEM_TRA_SO_THE: "Số thẻ không chính xác . Quý khách vui lòng kiểm tra lại",
  CARD_THONG_BAO_LAM_THANH_TOAN_MAC_DINH: "Nguồn thanh toán mặc định là tài khoản [acc_number]",
  CARD_THONG_BAO_MO_KHOA_THE_THANH_CONG: "Mở khóa thẻ [card_num] thành công.",
  CARD_THONG_BAO_NHAP_SO_THE_NAP: "Quý khách vui lòng nhập số thẻ.",
  CARD_THONG_BAO_NHAP_SO_TIEN_NAP: "Quý khách vui lòng nhập số tiền nạp",
  CARD_THONG_BAO_RUT_TIEN_MAT_CHUYEN_SANG_HAN_MUC_TOI_DA:
    "Quý khách có muốn tăng hạn mức rút tiền mặt một ngày của thẻ [card_num] lên mức tối đa không?",
  CARD_THONG_BAO_RUT_TIEN_MAT_CHUYEN_SANG_HAN_MUC_TOI_DA_THANH_CONG:
    "Hạn mức rút tiền ATM một ngày của thẻ [card_num] đã được tăng lên mức tối đa.",
  CARD_THONG_BAO_RUT_TIEN_MAT_CHUYEN_SANG_HAN_MUC_TOI_THIEU:
    "Quý khách có muốn giảm hạn mức rút tiền mặt một ngày của thẻ [card_num] xuống mức tối thiểu không?",
  CARD_THONG_BAO_RUT_TIEN_MAT_CHUYEN_SANG_HAN_MUC_TOI_THIEU_THANH_CONG:
    "Hạn mức rút tiền ATM một ngày của thẻ [card_num] đã được giảm xuống mức tối thiểu.",
  CARD_THONG_BAO_SO_DIEN_THOAI_KHONG_HOP_LE: "Số điện thoại không chính xác. Quý khách vui lòng kiểm tra lại.",
  CARD_THONG_BAO_SO_DIEN_THOAI_TRONG: "Quý khách vui lòng nhập số điện thoại",
  CARD_THONG_BAO_SO_TIEN_GIAO_DICH_TOI_THIEU: "Số tiền giao dịch tối thiểu là 10,000 VND",
  CARD_THONG_BAO_TRANG_THAI_TAI_KHOAN_THANH_TOAN:
    "Tài khoản thanh toán ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  CARD_THONG_BAO_TRANG_THAI_TAI_KHOAN_THE:
    "Tài khoản thẻ ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  CARD_THONG_BAO_XAC_NHAN_DIEU_KHOAN: "Quý khách vui lòng đồng ý điều khoản để tiếp tục",
  CARD_THONG_BAO_YEU_CAU_PHAT_HANH_THE:
    "Yêu cầu phát hành thẻ của Quý khách đang được xử lý. PVcomBank sẽ liên hệ với Quý khách trong thời gian sớm nhất.",
  CARD_THONG_TIN_DANG_KY: "Thông tin đăng ký",
  CARD_THONG_TIN_GIAO_DICH: "Thông tin giao dịch",
  CARD_THONG_TIN_NAP_TIEN: "Thông tin nạp tiền",
  CARD_THONG_TIN_THE: "Thông tin thẻ",
  CARD_THONG_TIN_THE_PHU: "Thông tin thẻ phụ",
  CARD_THU_LAI: "Thử lại",
  CARD_TRANG_THAI: "Trạng thái",
  CARD_TRANG_THAI_CHUA_DOI_PIN: "Chưa đổi PIN",
  CARD_TRANG_THAI_CHUA_KICH_HOAT: "Chưa kích hoạt",
  CARD_TRANG_THAI_HOAT_DONG: "Hoạt động",
  CARD_TRANG_THAI_KHOA: "Khóa",
  CARD_TRANG_THAI_TAM_KHOA: "Tạm khoá",
  CARD_TRANG_THAI_CHUA_DOI_PIN_VALID: "Thẻ chưa đổi PIN",
  CARD_TRANG_THAI_CHUA_KICH_HOAT_VALID: "Thẻ chưa kích hoạt",
  CARD_TRANG_THAI_KHOA_VALID: "Thẻ đang bị khóa",
  CARD_TRANG_THAI_TAM_KHOA_VALID: "Thẻ đang bị khóa tạm thời",
  CARD_TRA_SOAT_GIAO_DICH: "Tra soát giao dịch",
  CARD_TRUY_VAN: "Truy vấn",
  CARD_VUI_LONG_NHAP_SO_DIEN_THOAI: "Quý khách vui lòng nhập số điện thoại",
  CARD_XAC_NHAN_NAP_TIEN: "Xác nhận nạp tiền",
  CARD_XEM_CHI_TIET_THE: "Xem chi tiết thẻ",
  CARD_CVV_NOTE: "Để thực hiện giao dịch trực tuyến, Quý khách cần hiển thị số thẻ và số CVV động.",
  CARD_CVV_NOTE_TIME_COUNT_DOWN: "CVV động hết hiệu lực sau",
  CARD_CVV_DONG: "Số CVV động",
  CARD_CVV_ASK_AGAIN: "Không hiển thị lại",
  CARD_TRANG_THAI_GD_THANH_CONG: "Giao dịch thành công",
  CARD_TRANG_THAI_GD_KHONG_THANH_CONG: "Giao dịch không hoàn thành",
  CARD_TRANG_THAI_TK_HET_HAN: "Tài khoản hết hạn",
  CARD_TRANG_THAI_TK_KHONG_XAC_DINH: "Không thể xác định tài khoản",

  CASH_BY_CODE_4_MA_DAU: "4 mã đầu",
  CASH_BY_CODE_BEN_CHIU_PHI: "Bên chịu phí",
  CASH_BY_CODE_BEN_CHUYEN: "Bên chuyển",
  CASH_BY_CODE_CHI_TIET_PHI: "Chi tiết phí",
  CASH_BY_CODE_DONG: "ĐÓNG",
  CASH_BY_CODE_GIAO_DICH_KHAC: "Giao dịch khác",
  CASH_BY_CODE_GIAO_DICH_THANH_CONG: "Giao dịch thành công",
  CASH_BY_CODE_HET_HIEU_LUC: "Hết hiệu lực",
  CASH_BY_CODE_HIEU_LUC_DEN: "Hiệu lực đến",
  CASH_BY_CODE_HUONG_DAN:
    "Chức năng cho phép chuyển tiền cho người nhận bằng mã số gửi qua số điện thoại. Người nhận tiền không cần có tài khoản tại Ngân hàng. Người nhận sử dụng số tài khoản nhận (do hệ thống tự sinh) và mã số (gồm 4 mã đầu và 4 mã cuối) để rút tiền tại ATM của PVcomBank. 4 mã đầu được gửi cho người chuyển. 4 mã cuối và số tài khoản nhận được gửi cho người nhận.",
  CASH_BY_CODE_HUY: "Hủy",
  CASH_BY_CODE_KET_THUC: "Kết thúc",
  CASH_BY_CODE_KHONG_HOI_LAI_LAN_NUA: "Không hiển thị lại",
  CASH_BY_CODE_LIST_HISTORY: "Lịch sử giao dịch",
  CASH_BY_CODE_LUU_Y_SDT_PHAI_LIEN_KET: "Lưu ý: Số điện thoại thụ hưởng phải đăng ký dịch vụ SMS Banking tại PVcomBank",
  CASH_BY_CODE_NHAP_SO_TIEN_LA_BOI_SO_10000: "Quý khách vui lòng nhập số tiền là bội số của 10,000 VND.",
  CASH_BY_CODE_NHAP_THIEU_SO_DIEN_THOAI: "Quý khách vui lòng nhập số điện thoại người nhận",
  CASH_BY_CODE_NOTE_CHUYEN_NHANH_THU_HUONG: "Để chuyển tiền nhanh hơn và không cần nhớ các thông tin?",
  CASH_BY_CODE_SO_DIEN_THOAI_KHONG_HOP_LE: "Số điện thoại không chính xác. Quý khách vui lòng kiểm tra lại.",
  CASH_BY_CODE_SO_DIEN_THOAI_NHAN_4_MA_CUOI: "Số điện thoại người nhận",
  CASH_BY_CODE_SO_DIEN_THOAI_NHAN_4_MA_DAU: "Số điện thoại nhận 4 mã đầu",
  CASH_BY_CODE_SO_TAI_KHOAN: "Số tài khoản",
  CASH_BY_CODE_SO_TIEN: "Số tiền",
  CASH_BY_CODE_TAI_KHOAN_CHUYEN: "Tài khoản chuyển",
  CASH_BY_CODE_TAI_KHOAN_THANH_TOAN: "Tài khoản thanh toán",
  CASH_BY_CODE_THEM_VAO_THU_HUONG: "Thêm vào danh sách thụ hưởng",
  CASH_BY_CODE_THOI_GIAN_GIAO_DICH: "Thời gian giao dịch",
  CASH_BY_CODE_THONG_BAO_CUNG_CAP_4_MA_DAU_CHO_NGUOI_NHAN: "Quý khách cung cấp 4 mã đầu cho người nhận để thực hiện rút tiền.",
  CASH_BY_CODE_THONG_BAO_KHONG_TON_TAI_GIAO_DICH_NAO: "Không có giao dịch nào phát sinh",
  CASH_BY_CODE_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Ngày bắt đầu và ngày kết thúc không quá 90 ngày.",
  CASH_BY_CODE_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "Quý khách vui lòng chọn ngày bắt đầu trước ngày kết thúc.",
  CASH_BY_CODE_THONG_BAO_TRANG_THAI_TAI_KHOAN_CHUYEN:
    "Tài khoản chuyển ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  CASH_BY_CODE_THONG_TIN_GIAO_DICH: "Thông tin giao dịch",
  CASH_BY_CODE_TIEP_TUC: "Tiếp tục",
  CASH_BY_CODE_TITLE: "Chuyển tiền qua code",
  CASH_BY_CODE_TONG_PHI: "Tổng phí",
  CASH_BY_CODE_TRANG_THAI: "Trạng thái",
  CASH_BY_CODE_TRA_SOAT: "Tra soát",
  CASH_BY_CODE_TRUY_VAN: "Truy vấn",
  CASH_BY_CODE_VUI_LONG_NHAP_SO_TIEN: "Quý khách vui lòng nhập số tiền chuyển.",
  CASH_BY_CODE_XEM: "Xem",

  CHART_HEALTH_CAP_NHAT_NGUONG_AN_TOAN: "Cài đặt số dư duy trì mong muốn",
  CHART_HEALTH_DONG_Y: "Đồng ý",
  CHART_HEALTH_GIA_TRI_MUC_MAX_KHONG_DUOC_TRONG: "Giá trị tối đa không được để trống.",
  CHART_HEALTH_GIA_TRI_MUC_MIN_KHONG_DUOC_TRONG: "Giá trị tối thiểu không được để trống.",
  CHART_HEALTH_GIA_TRI_NGUONG_AN_TOAN_KHONG_HOP_LE: "Mức tối thiểu không được lớn hơn hoặc bằng mức tối đa",
  CHART_HEALTH_HUY: "Hủy",

  COMMON_BAT_DAU_SU_DUNG: "Bắt đầu sử dụng",
  COMMON_LUU_ANH: "Tải về",
  COMMON_CHO_PHEP_QUYEN_TRUY_CAP_DANH_BA:
    "Quý khách vui lòng truy cập Cài đặt - Ứng dụng trên thiết bị để cấp quyền truy cập danh bạ cho ứng dụng.",
  COMMON_CHO_PHEP_TRUY_CAP: "Cho phép truy cập",
  COMMON_CHUC_NANG_SAP_RA_MAT: "Chức năng đang được phát triển.",
  COMMON_CHUP_ANH: "Chụp ảnh",
  COMMON_CHU_THICH: "Chú thích",
  COMMON_CHU_THICH_CHUA_BAT_FACE_ID_TREN_THIET_BI:
    "Quý khách có thể đăng nhập bằng nhận diện khuôn mặt. Vào Cài đặt thiết bị để cài đặt nhận diện khuôn mặt",
  COMMON_CHU_THICH_CHUA_BAT_VAN_TAY_TREN_THIET_BI: "Quý khách có thể đăng nhập bằng vân tay. Vào Cài đặt thiết bị để cài đặt vân tay",
  COMMON_CHU_THICH_FACE_LAN_DAU: "Quý khách có thể đăng nhập bằng nhận diện khuôn mặt. Truy cập chức năng Tiện ích để kích hoạt",
  COMMON_CHU_THICH_VAN_TAY_LAN_DAU: "Quý khách có thể đăng nhập bằng vân tay. Truy cập chức năng Tiện ích để kích hoạt",
  COMMON_DANG_KY_DICH_VU: "Giao dịch tự động",
  COMMON_DANH_SACH_TAI_KHOAN: "Danh sách tài khoản",
  COMMON_DEN_NGAY: "Đến ngày",
  COMMON_DICH_VU_DANG_DUOC_PHAT_TRIEN: "Dịch vụ đang được phát triển",
  COMMON_DICH_VU_KHONG_CO_NHA_CUNG_CAP: "{dich_vu} không có nhà cung cấp",
  COMMON_DONG: "Đóng",
  COMMON_DONG_Y: "Đồng ý",
  COMMON_GIAO_DICH_KHAC: "Giao dịch khác",
  COMMON_GIAO_DICH_THANH_CONG: "Giao dịch thành công",
  COMMON_DANG_KY_THANH_CONG: "Đăng ký thành công",
  COMMON_GIOI_THIEU: "Giới thiệu",
  COMMON_HOAC_DANG_NHAP_KHUON_MAT: "Hoặc đăng nhập sử dụng khuôn mặt",
  COMMON_HOAC_DANG_NHAP_VAN_TAY: "Hoặc đăng nhập sử dụng vân tay",
  COMMON_HOTLINE_MENU: "Hotline: 1900 5555 92",
  COMMON_HO_TEN: "Họ tên",
  COMMON_HO_TRO_KH: "Hỗ trợ KH",
  COMMON_HUY: "Hủy",
  COMMON_QUAY_LAI: "Quay lại",
  COMMON_KET_THUC: "Kết thúc",
  COMMON_KHAC_CHU_TAI_KHOAN: "Khác chủ tài khoản",
  COMMON_KHOAN_VAY: "Khoản vay",
  COMMON_KHONG_CO_DANH_BA: "Không có danh bạ",
  COMMON_KHONG_CO_DU_LIEU: "Không có dữ liệu",
  COMMON_KHONG_CO_MANG: "Không có mạng",
  COMMON_KHONG_TON_TAI_SDT: "Không tồn tại số điện thoại.",
  COMMON_LICH_SU_NOP_THEM_TIEN: "Lịch sử nộp thêm tiền",
  COMMON_LICH_SU_TRA_SOAT: "Lịch sử tra soát",
  COMMON_LOI_KHONG_KET_NOI_DUOC_MAY_CHU: "Có lỗi trong quá trình kết nối. Vui lòng kiểm tra lại kết nối mạng.",
  COMMON_LOI_KHONG_KET_NOI_DUOC_MAY_CHU_NGUNG_GIAO_DICH:
    "Có lỗi trong quá trình kết nối. Vui lòng kiểm tra lại kết nối mạng. Quý khách thực hiện lại chức năng giao dịch và huỷ dịch vụ này",
  COMMON_LOI_TOUCH_ID_DA_DOI_MAT_KHAU:
    "Mật khẩu của Quý khách đã được thay đổi. Quý khách vui lòng đăng nhập bằng mật khẩu mới và kích hoạt tính năng đăng nhập vân tay trong phần Tiện ích.",
  COMMON_MAIN_BOTTOM: "© 2019 - PVcomBank",
  COMMON_MA_OTP: "Mã OTP",
  COMMON_MA_OTP_HET_HIEU_LUC: "Giao dịch bị hủy do đã hết thời gian nhập mã xác thực.",
  COMMON_MOT_NGAY: "ngày",
  COMMON_MOT_THANG: "tháng",
  COMMON_MOT_TUAN: "tuần",
  COMMON_NAP_TIEN: "Nạp tiền",
  COMMON_HOA_DON: "Hoá đơn",
  COMMON_NGAN_HANG_TMCP_DAI_CHUNG_VIET_NAM: "Ngân Hàng TMCP Đại Chúng Việt Nam",
  COMMON_NGON_NGU_HIEN_THI: "Ngôn ngữ hiển thị",
  COMMON_NHAN_THEM_LAN_NUA_DE_THOAT: "Nhấm thêm lần nữa để thoát",
  COMMON_NHAP_MA_OTP: "Nhập mã OTP",
  COMMON_NHAP_MA_OTP_TIEU_DE: "Nhập SMS OTP để xác nhận. OTP sẽ hết hiệu lực sau",
  COMMON_NHAP_MA_SMART_OTP_TIEU_DE: "OTP sẽ hết hiệu lực sau",
  COMMON_NHIEU_NGAY: "ngày",
  COMMON_NHIEU_THANG: "tháng",
  COMMON_NHIEU_TUAN: "tuần",
  COMMON_NOI_DUNG_MO_CAMERA_SETTING:
    "Quý khách vui lòng truy cập Cài đặt - Ứng dụng trên thiết bị để cấp quyền sử dụng camera cho ứng dụng.",
  COMMON_NOI_DUNG_MO_LIBRARY_SETTING:
    "Quý khách vui lòng truy cập Cài đặt - Ứng dụng trên thiết bị để cấp quyền truy cập ảnh cho ứng dụng.",
  COMMON_NOI_DUNG_MO_STORAGE_SETTING:
    "Quý khách vui lòng truy cập Cài đặt - Ứng dụng trên thiết bị để cấp quyền sử dụng bộ nhớ cho ứng dụng.",
  COMMON_NOTE_CHON_NGON_NGU: "Quý khách có thể thay đổi lại ngôn ngữ trong phần Tiện ích",
  COMMON_NOTE_CHUP_ANH_HOAC_THU_VIEN: "Hãy chụp ảnh hoặc chọn từ thư viện",
  COMMON_PHIEN_BAN: "Mobile Banking - Phiên Bản 2.5",
  COMMON_PHIEN_BAN_APP: "© 2019 - PVcomBank",
  COMMON_PHIEN_BAN_IB: "Bản quyền © 2021 thuộc về Ngân hàng TMCP Đại Chúng Việt Nam (PVcomBank)",
  COMMON_PHIEN_GIAO_DICH: "Phiên giao dịch",
  COMMON_QR: "QR Pay",
  COMMON_SAO_KE_GIAO_DICH: "Sao kê giao dịch",
  COMMON_TAI_KHOAN: "Tài khoản",
  COMMON_TAO_GIAO_DICH_MOI: "Tạo giao dịch mới",
  COMMON_TAO_GIAO_DICH_TU_DANH_SACH_THU_HUONG: "Tạo giao dịch từ danh sách thụ hưởng",
  COMMON_TEN_CHI_NHANH_DIA_CHI: "Tên chi nhánh / Địa chỉ",
  COMMON_THANH_TOAN_HOA_DON: "Thanh toán hoá đơn",
  COMMON_THAY_DOI_ANH_DAI_DIEN: "Thay đổi ảnh đại diện",
  COMMON_THEM_VAO_DANH_SACH_THU_HUONG: "Thêm vào danh sách thụ hưởng",
  COMMON_THOAT: "Thoát",
  COMMON_THONG_BAO: "Thông báo",
  COMMON_THONG_BAO_CAP_NHAT_PBPM:
    "PV Mobile Banking đã có phiên bản mới. Quý khách vui lòng cập nhật để trải nghiệm ứng dụng ngân hàng số với nhiều tiện ích hấp dẫn.",
  COMMON_THONG_BAO_CHUA_DK_PHUONG_THUC_XAC_THUC: "Quý khách chưa đăng ký phương thức xác thực",
  COMMON_THONG_BAO_HET_PHIEN: "Quý khách đã hết phiên làm việc, vui lòng đăng nhập lại để tiếp tục sử dụng dịch vụ.",
  COMMON_THONG_BAO_KHONG_CO_TAI_KHOAN_KICH_HOAT:
    "Tài khoản của Quý khách ở trạng thái không hoạt động. Quý khách vui lòng đến quầy giao dịch PVcomBank để được hỗ trợ.",
  COMMON_THONG_BAO_LOI_CHUNG: "Có lỗi trong quá trình xử lý. Quý khách vui lòng thực hiện lại sau.",
  COMMON_THONG_BAO_QUA_HAN_MUC_GD_NGAY: "Vượt tổng số tiền giao dịch trong ngày",
  COMMON_THONG_BAO_THAY_DOI_FACE_ID_THIET_BI: "Chức năng {func} của Quý khách đã bị ngừng tự động do có sự thay đổi FaceID trên thiết bị.",
  COMMON_THONG_BAO_THAY_DOI_FACE_ID_THIET_BI_2_FUNC:
    "Chức năng {func_1} và {func_2} của Quý khách đã bị ngừng tự động do có sự thay đổi FaceID trên thiết bị.",
  COMMON_THONG_BAO_THAY_DOI_VAN_TAY_THIET_BI: "Chức năng {func} của Quý khách đã bị ngừng tự động do có sự thay đổi Vân tay trên thiết bị.",
  COMMON_THONG_BAO_THAY_DOI_VAN_TAY_THIET_BI_2_FUNC:
    "Chức năng {func_1} và {func_2} của Quý khách đã bị ngừng tự động do có sự thay đổi Vân tay trên thiết bị.",
  COMMON_THONG_BAO_CAI_DAT_FUNC_BEFORE_LOGIN: "Quý khách vui lòng kích hoạt lại chức năng này sau khi đăng nhập.",
  COMMON_THONG_BAO_CAI_DAT_FUNC_SETTING: "Quý khách vui lòng vào Tiện ích để kích hoạt lại chức năng này.",
  COMMON_THONG_BAO_TRANG_THAI_TAI_KHOAN_THANH_TOAN:
    "Tài khoản thanh toán ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ",
  COMMON_THONG_TIN_NGAN_HANG: "Thông tin ngân hàng",
  COMMON_THU_VIEN: "Thư viện",
  COMMON_TIENG_ANH: "Tiếng Anh",
  COMMON_TIENG_VIET: "Tiếng Việt",
  COMMON_TIEN_ICH: "Tiện ích",
  COMMON_TUY_CHINH: "Tuỳ chỉnh",
  COMMON_TIEP_TUC: "Tiếp tục",
  COMMON_TIET_KIEM: "Tiết kiệm",
  COMMON_TIM_KIEM: "Tìm kiếm",
  COMMON_TIM_KIEM_ATM: "Tìm kiếm ATM/CN",
  COMMON_TIM_KIEM_ATM_CN: "Tìm kiếm ATM/Chi nhánh",
  COMMON_TK: "TK",
  COMMON_TONG_SO_DU_THE: "Dư nợ thẻ tín dụng",
  COMMON_TONG_SO_DU_TKTK: "Tài khoản tiết kiệm",
  COMMON_TONG_SO_DU_TKTT: "Tài khoản thanh toán",
  COMMON_TONG_SO_DU_TKTV: "Tiền vay",
  COMMON_TRA_SOAT_GIAO_DICH: "Tra soát giao dịch",
  COMMON_TU_NGAY: "Từ ngày",
  COMMON_VERSION_MENU: "Phiên bản {version} - 2019 PVcomBank",
  COMMON_VUI_LONG_NHAP_OTP: "Quý khách vui lòng nhập mã xác thực",
  COMMON_XAC_NHAN: "Xác nhận",
  COMMON_XAC_THUC_OTP: "Xác thực",
  COMMON_XOA: "Xóa",
  COMMON_QUY_KHACH_THAY_DOI_MAT_KHAU_PVCONNECT: "Tài khoản PVcomBank Connect đã thay đổi. Quý khách vui lòng đăng nhập lại",
  COMMON_THONG_TIN_TAI_KHOAN: "Thông tin tài khoản",
  COMMON_THONG_TIN_GIAO_DICH: "Thông tin giao dịch",
  COMMON_CHAO_MUNG_QUY_KHACH: "Chào mừng Quý khách đến với{new_line}Ngân hàng số",
  COMMON_LUU_Y_CHO_KHACH_HANG: "Những lưu ý nhỏ cho khách hàng",
  COMMON_NOTE_1: "Với khách hàng đã có tài khoản Internet Banking:",
  COMMON_NOTE_2: "Tên đăng nhập là số CIF khách hàng",
  COMMON_NOTE_3: "Với khách hàng đã có tài khoản PVcomBank Connect:",
  COMMON_NOTE_4: "Tên đăng nhập là số điện thoại đã đăng ký dịch vụ",
  COMMON_IN: "In",
  COMMON_THU_VIEN_QR: "Thư viện QR",
  COMMON_DINH_DANH_GD: "Định danh giao dịch",
  COMMON_MA_GD: "Mã giao dịch",
  COMMON_NHAP_MA_XA_THUC: "Nhập mã xác thực",
  COMMON_QUET_LAY_MA_XA_THUC: "Quét để lấy mã xác thực",
  COMMON_HUONG_DAN_XAC_THUC: "Hướng dẫn chi tiết xem",
  COMMON_TAI_DAY: "tại đây",
  COMMON_HUONG_DAN: "Hướng dẫn",
  COMMON_XAC_THUC_GD: "Xác thực giao dịch",
  COMMON_BANG_CHU: "Bằng chữ",
  COMMON_IN_BIEN_LAI: "In biên lai",
  COMMON_CHIA_SE: "Chia sẻ",
  COMMON_NOTE_DESCRIPTION: "Nội dung nhập không dấu, không ký tự đặc biệt",
  COMMON_OTP_CHUA_NHAP: "Quý khách vui lòng nhập mã OTP",
  COMMON_OTP_KHONG_HOP_LE: "Mã OTP không hợp lệ",
  COMMON_VND: "VND",
  COMMON_SO_TIEN_KHONG_DUOC_DUOI_10000D: "Số tiền giao dịch tối thiểu là 10,000 VND",
  COMMON_TEN_NHDCVN: "Ngân hàng TMCP Đại Chúng Việt Nam",
  COMMON_NAM: "Năm",
  COMMON_SO_DONG_TRANG: "Số dòng trên trang",
  COMMON_TRANG: "Trang",
  COMMON_LOI: "Rất tiếc !",
  COMMON_KHAM_PHA_NGAY: "Khám phá ngay",
  COMMON_KHAO_SAT_NGAY: "Khảo sát ngay",
  COMMON_THONG_BAO_CHUC_NANG_DOI_MK: "Chức năng đang được nâng cấp, Quý khách vui lòng truy cập ứng dụng PV Mobile Banking để thực hiện.",
  COMMON_GIAY_BAO_CO: "Giấy báo có",
  COMMON_GIAY_BAO_NO: "Giấy báo nợ",
  COMMON_KHONG_TIM_THAY_TIM_KIEM: "Không tìm thấy kết quả theo yêu cầu",
  COMMON_XEM: "Xem",
  COMMON_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  COMMON_NOTE_KHONG_BAT_BUOC: "Nội dung không bắt buộc",
  COMMON_THONG_BAO_CHUC_NANG_TAM_KHOA: "Dịch vụ tạm thời gián đoạn. Quý khách vui lòng liên hệ tổng đài CSKH 24/7: 1900 5555 92 hoặc Chi nhánh/PGD gần nhất của PVcomBank để được hỗ trợ.",
  COMMON_THONG_BAO_LOCK_PVCONNECT_APP_TITLE: "CẬP NHẬT QUAN TRỌNG",
  COMMON_THONG_BAO_LOCK_PVCONNECT_APP: "Quý khách vui lòng truy cập ứng dụng PVConnect để tiếp tục sử dụng các dịch vụ Ngân hàng số.",
  COMMON_THONG_BAO_FORCE_PVCONNECT_APP_TITLE: "TRẢI NGHIỆM MỚI CÙNG PVCONNECT",
  COMMON_THONG_BAO_FORCE_PVCONNECT_APP: "Quý khách đã được chuyển đổi sang ứng dụng mới PVCONNECT nên không thể tiếp tục sử dụng dịch vụ này. Vui lòng truy cập ứng dụng và trải nghiệm dịch vụ Ngân hàng số tối ưu nhất.",
  COMMON_TOI_DA_HIEU: "Tôi đã hiểu",
  COMMON_QUET_QR: "Quét QR",
  COMMON_QUET_QR_UPDATE: "để tải ứng dụng PVConnect",

  DETAIL_QR_CHIT_TIET_GIAO_DICH: "Chi tiết giao dịch",
  DETAIL_QR_DIEM_BAN: "Điểm bán",
  DETAIL_QR_GHI_CHU: "Ghi chú",
  DETAIL_QR_SO_HOA_DON: "Số hoá đơn",
  DETAIL_QR_SO_TIEN_THANH_TOAN: "Số tiền thanh toán",
  DETAIL_QR_TAI_KHOAN_NGUON: "Tài khoản nguồn",
  DETAIL_QR_THANH_TOAN_CHO: "Thanh toán cho",
  DETAIL_QR_THOI_GIAN_GIAO_DICH: "Thời gian giao dịch",

  FEE_BEN_CHIU_PHI: "Bên chịu phí",
  FEE_BEN_CHUYEN: "Bên chuyển",
  FEE_BEN_NHAN: "Bên nhận",
  FEE_CHI_TIET_PHI: "Chi tiết phí",
  FEE_GIAM_PHI: "Giảm phí",
  FEE_PHI: "Phí",
  FEE_TONG: "Tổng",
  FEE_TONG_GHI_NO: "Tổng ghi nợ",
  FEE_TONG_PHI: "Tổng phí",
  FEE_TONG_THUC_CHUYEN: "Tổng thực chuyển",
  FEE_VAT: "VAT",
  FEE_XEM: "Xem",
  FEE_BIEU_PHI: "Biểu phí",

  FUNC_BOTTOM_QR_PAY: "QR Pay",
  FUNC_BOTTOM_TIM_KIEM_ATM_CN: "Mạng lưới",
  FUNC_BOTTOM_TU_VAN_TAI_CHINH: "Tư vấn",
  FUNC_BOTTOM_UU_DAI: "Ưu đãi",
  FUNC_BOTTOM_LAY_MA_OTP: "Lấy mã OTP",
  FUNC_CASH_BY_CODE: "Chuyển tiền{new_line}qua code",
  FUNC_CHUNG_KHOAN: "Chuyển tiền{new_line}chứng khoán",
  FUNC_DANG_KY_VAY_VON: "Đăng ký{new_line}vay vốn",
  FUNC_DAU_TU: "Đầu tư",
  FUNC_DIEN_THOAI: "Điện thoại",
  FUNC_DS_KHOAN_VAY: "Danh sách{new_line}khoản vay",
  FUNC_DS_THE: "Danh sách{new_line}thẻ",
  FUNC_DV_GIAO_DICH_TU_DONG: "Giao dịch tự động",
  FUNC_DV_KHAC: "Dịch vụ khác",
  FUNC_DV_NAP_TIEN: "Nạp tiền điện tử",
  FUNC_DV_THANH_TOAN: "Dịch vụ thanh toán",
  FUNC_DV_THANH_TOAN_HOA_DON: "Thanh toán hóa đơn",
  FUNC_HD_ADSL: "ADSL",
  FUNC_HD_ADSL_VNPT: "ADSL - VNPT",
  FUNC_HD_DIEN: "Điện",
  FUNC_HD_INTERNET_TV: "Internet TV",
  FUNC_HD_LEADED_LINE: "Leased-line",
  FUNC_HD_NUOC: "Nước",
  FUNC_HD_TRUYEN_HINH: "Truyền hình",
  FUNC_HD_TRUYEN_HINH_VNPT: "Truyền hình{new_line}VNPT",
  FUNC_HD_VE_MAY_BAY: "Hóa đơn{new_line}vé máy bay",
  FUNC_KHOA_MO_GD_TRUC_TUYEN: "Khóa/Mở giao{new_line}dịch trực tuyến",
  FUNC_LICH_SU_GIAO_DICH: "Lịch sử{new_line}giao dịch",
  FUNC_LOYALTY: "Đổi quà",
  FUNC_LS_VAY: "Lịch sử",
  FUNC_MAIN_CHUYEN_TIEN_CHUNG_KHOAN: "Đầu tư{new_line}chứng khoán",
  FUNC_MAIN_DAU_TU: "Đầu tư",
  FUNC_MAIN_DICH_VU_THANH_TOAN: "Dịch vụ{new_line}thanh toán",
  FUNC_MAIN_QUAN_LY_TAI_KHOAN: "Quản lý{new_line}tài khoản",
  FUNC_MAIN_TIET_KIEM_DIEN_TU: "Tiết kiệm{new_line}điện tử",
  FUNC_MAIN_TIM_KIEM_ATM_CN: "Tìm kiếm{new_line}ATM/CN",
  FUNC_MAIN_TU_VAN_GUI_TIET_KIEM: "Tư vấn{new_line}tài chính",
  FUNC_MAIN_TU_VAN_TAI_CHINH: "Tư vấn{new_line}tài chính",
  FUNC_MAIN_VAY_TRUC_TUYEN: "Tiền vay",
  FUNC_MAIN_ONLINE_LOAN: "Vay trực tuyến",
  FUNC_MAIN_ONLINE_LOAN_CREATE: "Tạo khoản vay",
  FUNC_MAIN_ONLINE_LOAN_TERMINATE: "Tất toán khoản vay",
  FUNC_MO_SO_TK: "Mở sổ",
  FUNC_NAP_TIEN_TU_DONG: "Nạp tiền{new_line}tự động",
  FUNC_NAP_TIEN_VE_MAY_BAY: "Nạp tiền đại lý{new_line}vé máy bay",
  FUNC_NGOAI_PVCB: "Ngoài{new_line}PVcomBank",
  FUNC_NHANH_24_7: "Nhanh 24/7",
  FUNC_NOP_THEM_STK: "Nộp thêm",
  FUNC_PHAT_HANH_THE_VAT_LY: "Phát hành{new_line}thẻ vật lý",
  FUNC_QR_PAY: "QR pay",
  FUNC_TAT_TOAN_STK: "Tất toán",
  FUNC_THANH_TOAN: "Thanh toán",
  FUNC_THANH_TOAN_HOA_DON_TU_DONG: "Thanh toán hóa{new_line}đơn tự động",
  FUNC_THANH_TOAN_THE_TIN_DUNG: "Thanh toán{new_line}thẻ tín dụng",
  FUNC_THONG_TIN_KHOAN_VAY: "Thông tin{new_line}khoản vay",
  FUNC_THU_HUONG: "Thụ hưởng",
  FUNC_TIEN_ICH: "Tiện ích",
  FUNC_TIEN_ICH_NHANH: "Tiện ích nhanh",
  FUNC_TIET_KIEM: "Tiết kiệm",
  FUNC_TIET_KIEM_DIEN_TU: "Tiết kiệm điện tử",
  FUNC_TIET_KIEM_TRUC_TUYEN: "Tiết kiệm trực tuyến",
  FUNC_TRANG_CHU: "Trang chủ",
  FUNC_TRONG_PVCB: "Trong{new_line}PVcomBank",
  FUNC_TU_VAN_GUI_TIET_KIEM: "Tư vấn{new_line}tài chính",
  FUNC_TU_VAN_MO_SO_TK: "Tư vấn mở{new_line}sổ tiết kiệm",
  FUNC_TU_VAN_TAI_CHINH: "Tư vấn tài chính",
  FUNC_UU_DAI: "Ưu đãi",
  FUNC_VAY_TRUC_TUYEN: "Tiền vay",
  FUNC_BOTTOM_HUONG_DAN_SU_DUNG: "Hướng dẫn sử dụng",
  FUNC_BOTTOM_HUONG_DAN_BAO_MAT: "Hướng dẫn bảo mật",
  FUNC_BOTTOM_CAU_HOI_THUONG_GAP: "Câu hỏi thường gặp",
  FUNC_PV_ONE: "Đổi quà",
  FUNC_LIEN_KET_NHANH: "Liên kết nhanh",
  FUNC_HO_TRO: "Hỗ trợ",
  FUNC_DICH_VU: "Dịch vụ",
  FUNC_TINH_NANG: "Tính năng",

  HISTORY_QR_CHON_TAI_KHOAN: "Danh sách tài khoản",
  HISTORY_QR_CHO_THANH_TOAN: "Chờ thanh toán",
  HISTORY_QR_DANG_THUC_HIEN_THANH_TOAN: "Đang thực hiện thanh toán",
  HISTORY_QR_DANG_XU_LY: "Đang xử lý",
  HISTORY_QR_KHONG_DU_SO_DU: "Không đủ số dư",
  HISTORY_QR_NGUON_THANH_TOAN: "Nguồn thanh toán",
  HISTORY_QR_NHA_CUNG_CAP: "Nhà cung cấp",
  HISTORY_QR_SO_TIEN: "Số tiền",
  HISTORY_QR_TAT_CA_TAI_KHOAN: "Tất cả tài khoản",
  HISTORY_QR_THANH_TOAN_THANH_CONG: "Thành công",
  HISTORY_QR_THANH_TOAN_THAT_BAI: "Thanh toán thất bại",
  HISTORY_QR_THE_GHI_NO: "Thẻ ghi nợ",
  HISTORY_QR_THE_THANH_TOAN: "TK thanh toán",
  HISTORY_QR_THE_TIN_DUNG: "Thẻ tín dụng",
  HISTORY_QR_THE_TRA_TRUOC: "Thẻ trả trước",
  HISTORY_QR_THOI_GIAN_GIAO_DICH: "Thời gian giao dịch",
  HISTORY_QR_THONG_BAO_KHONG_TON_TAI_GIAO_DICH_NAO: "Không có giao dịch nào phát sinh",
  HISTORY_QR_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Ngày bắt đầu và ngày kết thúc không quá 90 ngày.",
  HISTORY_QR_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "Quý khách vui lòng chọn ngày bắt đầu trước ngày kết thúc.",
  HISTORY_QR_TITLE: "Lịch sử giao dịch QR",
  HISTORY_QR_TRANG_THAI: "Trạng thái",
  HISTORY_QR_TRA_SOAT: "Tra soát",
  HISTORY_QR_TRUY_VAN: "Truy vấn",

  INFOMATION_DIA_CHI: "22 Ngô Quyền, phường Tràng Tiền, quận Hoàn Kiếm, Hà Nội, Việt Nam,",
  INFOMATION_DIEN_THOAI: "(+84) 02439426800",
  INFOMATION_DIEN_THOAI_HO_TRO: "1900 5555 92",
  INFOMATION_EMAIL: "pvb@pvcombank.com.vn",
  INFOMATION_FAX1: "(+84) 02439426796",
  INFOMATION_FAX2: "(+84) 02439426797",
  INFOMATION_WEBSITE: "www.pvcombank.com.vn",

  INSTRUCTION_CHANGE_TRANS_LIMIT: "Đổi gói hạn mức giao dịch",
  INSTRUCTION_CHUYEN_TIEN: "Chuyển tiền",
  INSTRUCTION_DANG_KY_NAP_TIEN_TU_DONG: "Đăng ký nạp tiền tự động",
  INSTRUCTION_DANG_KY_THANH_TOAN_HOA_DON_TU_DONG: "Đăng ký thanh toán hoá đơn tự động",
  INSTRUCTION_DANG_NHAP: "Đăng nhập",
  INSTRUCTION_DICH_VU_THE: "Dịch vụ thẻ",
  INSTRUCTION_LOYALTY: "Khách hàng thân thiết",
  INSTRUCTION_NAP_TIEN_DIEN_THOAI: "Nạp tiền điện thoại",
  INSTRUCTION_QUAN_LY_TAI_KHOAN: "Quản lý tài khoản",
  INSTRUCTION_SMART_CAI_DAT_FACEID: "Cài đặt FaceID Smart OTP",
  INSTRUCTION_SMART_CAI_DAT_VAN_TAY: "Cài đặt vân tay Smart OTP",
  INSTRUCTION_SMART_CHUYEN_THIET_BI: "Chuyển thiết bị đăng ký Smart OTP",
  INSTRUCTION_SMART_DANG_KY: "Đăng ký Smart OTP",
  INSTRUCTION_SMART_DOI_PIN: "Đổi mã PIN",
  INSTRUCTION_SMART_KHOI_PHUC_PIN: "Khôi phục PIN",
  INSTRUCTION_SMART_KICH_HOAT: "Kích hoạt Smart OTP",
  INSTRUCTION_SMART_LAY_MA_XAC_THUC: "Lấy mã xác thực OTP",
  INSTRUCTION_SMART_MAT_THIET_BI_KICH_HOAT_LAI: "Mất thiết bị/ Kích hoạt lại",
  INSTRUCTION_SMART_XOA_FACEID: "Xóa FaceID Smart OTP",
  INSTRUCTION_SMART_XOA_VAN_TAY: "Xóa vân tay Smart OTP",
  INSTRUCTION_THANH_TOAN_HOA_DON: "Thanh toán hoá đơn",
  INSTRUCTION_THANH_TOAN_QR: "Thanh toán QR",
  INSTRUCTION_THANH_TOAN_THE_TIN_DUNG: "Thanh toán thẻ tín dụng",
  INSTRUCTION_THU_HUONG: "Thụ hưởng",
  INSTRUCTION_TIEN_ICH: "Tiện ích",
  INSTRUCTION_TIET_KIEM_ONLINE: "Tiết kiệm online",
  INSTRUCTION_TIM_KIEM_ATM_CN: "Tìm kiếm ATM/Chi nhánh",
  INSTRUCTION_TRA_SOAT_GD: "Tra soát giao dịch",
  INSTRUCTION_TU_VAN_GUI_TIET_KIEM: "Tư vấn gửi tiết kiệm",
  INSTRUCTION_UU_DAI: "Ưu đãi",

  LOAN_CHI_NHAN_HO_TRO_LAM_HO_SO: "Chi nhánh hỗ trợ làm hồ sơ",
  LOAN_CHI_TIET_LICH_TRA_NO: "Chi tiết lịch trả nợ",
  LOAN_DANG_KY: "Đăng ký",
  LOAN_DANH_SACH_KHE_UOC: "Thông tin khoản vay",
  LOAN_DU_NO_CON_LAI: "Dư nợ còn lại",
  LOAN_DU_NO_GOC: "Dư nợ gốc",
  LOAN_HO_TEN: "Họ và tên",
  LOAN_HUY: "Hủy",
  LOAN_KHONG_CO_KHE_UOC: "Không có khế ước",
  LOAN_KHONG_CO_LS_TRA_NO: "Không có lịch sử trả nợ",
  LOAN_KY_HAN: "Kỳ hạn",
  LOAN_LAI_SUAT: "Lãi suất",
  LOAN_LICH_SU_TRA_NO: "Lịch sử trả nợ",
  LOAN_MUC_DICH_VAY: "Mục đích vay",
  LOAN_NGAY: "Ngày",
  LOAN_NGAY_HET_HAN: "Ngày hết hạn",
  LOAN_NGAY_HIEU_LUC: "Ngày hiệu lực",
  LOAN_NHAP_THIEU_HO_TEN: "Quý khách vui lòng nhập đầy đủ họ tên",
  LOAN_NHAP_THIEU_SO_DIEN_THOAI: "Quý khách vui lòng nhập số điện thoại liên hệ",
  LOAN_SO_DIEN_THOAI: "Số điện thoại liên hệ",
  LOAN_SO_DIEN_THOAI_KHONG_HOP_LE: "Số điện thoại không chính xác. Quý khách vui lòng kiểm tra lại.",
  LOAN_SO_KHE_UOC: "Số khế ước",
  LOAN_THOI_GIAN: "Thời gian",
  LOAN_THONG_TIN_KHOAN_VAY: "Thông tin khoản vay",
  LOAN_TIM_THAY_KHE_UOC: "Không tìm thấy khế ước",
  LOAN_TITLE: "Đăng ký vay vốn",
  LOAN_TRUY_VAN: "Truy vấn",

  LOYALTY_ALL: "Tất cả",
  LOYALTY_AP_DUNG: "Áp dụng",
  LOYALTY_CHECK_QUA_CO_THE_DOI: "Chỉ hiển thị ưu đãi tôi có thể đổi",
  LOYALTY_CHI_TIET_DOI_QUA: "Xác nhận",
  LOYALTY_DANH_MUC: "Danh mục",
  LOYALTY_DANH_SACH_QUA_TANG: "Danh sách quà tặng",
  LOYALTY_DA_HET_QUA: "Đã hết quà",
  LOYALTY_DK_THE: "Đăng ký thẻ",
  LOYALTY_DIEM: "Điểm",
  LOYALTY_DIEM_CAO_THAP: "Điểm cao đến thấp",
  LOYALTY_DIEM_CON_LAI: "Điểm còn lại",
  LOYALTY_DIEM_DOI_QUA: "Điểm đổi quà",
  LOYALTY_DIEM_HET_HAN_TIME: "Sẽ hết hạn vào {date}",
  LOYALTY_DIEM_QUY_DOI: "Điểm quy đổi",
  LOYALTY_DIEM_SAN_CO: "Điểm sẵn có",
  LOYALTY_DIEM_SE_QUY_DOI: "Điểm sẽ quy đổi",
  LOYALTY_DIEM_THAP_CAO: "Điểm thấp đến cao",
  LOYALTY_DIEM_THUONG_CO_SAN: "Điểm thưởng sẵn có",
  LOYALTY_DIEU_KHOAN_DIEU_KIEN: "Điều khoản và điều kiện",
  LOYALTY_DOI_QUA: "Đổi quà",
  LOYALTY_DOI_QUA_KHONG_THANH_CONG: "Đăng ký đổi quà không thành công",
  LOYALTY_DOI_QUA_THANH_CONG: "Đăng ký đổi quà thành công",
  LOYALTY_DOI_QUA_THANH_CONG_NOTE_1: "Yêu cầu đổi quà của Quý khách đã được tiếp nhận với mã yêu cầu",
  LOYALTY_DOI_QUA_THANH_CONG_NOTE_2: "Quý khách vui lòng kiểm tra tình trạng đổi quà tại kênh điện tử hoặc liên hệ",
  LOYALTY_DONE: "Xong",
  LOYALTY_IN: "Cộng điểm",
  LOYALTY_KHONG_CO_LS_DOI_QUA: "Không có giao dịch nào phát sinh",
  LOYALTY_KHONG_CO_LS_GIAO_DICH: "Không có giao dịch nào phát sinh",
  LOYALTY_KHONG_CO_QUA: "Không có quà",
  LOYALTY_KHONG_TIM_THAY_QUA: "Không tìm thấy quà theo điều kiện lọc",
  LOYALTY_LICH_SU_DOI_QUA: "Lịch sử đổi quà",
  LOYALTY_LICH_SU_GIAO_DICH: "Lịch sử điểm thưởng",
  LOYALTY_LIEN_HE: "Liên hệ",
  LOYALTY_LOC: "Lọc",
  LOYALTY_LOC_THEO: "Lọc theo",
  LOYALTY_LOC_VA_PHAN_LOAI: "Lọc và phân loại",
  LOYALTY_LOI_CHUA_NHAP_DIA_CHI: "Quý khách vui lòng nhập địa chỉ",
  LOYALTY_LOI_CHUA_NHAP_EMAIL: "Quý khách vui lòng nhập email",
  LOYALTY_LOI_CHUA_NHAP_SO_DIEN_THOAI: "Quý khách vui lòng nhập số điện thoại",
  LOYALTY_LOI_EMAIL_KHONG_HOP_LE: "Email không hợp lệ",
  LOYALTY_LOI_KHONG_DU_DIEM: "Không đủ điểm",
  LOYALTY_LOI_MA_THANH_VIEN_VINID: "Quý khách vui lòng chỉ nhập mã thành viên VINID có 16 chữ số",
  LOYALTY_LOI_NHAP_MA_THANH_VIEN_VINID: "Quý khách vui lòng nhập mã thành viên VINID",
  LOYALTY_LOI_NHAP_SO_THE_HOI_VIEN_BSV: "Quý khách vui lòng nhập số thẻ hội viên Bông Sen Vàng",
  LOYALTY_LOI_NHAP_STK_THANH_TOAN: "Quý khách vui lòng nhập số tài khoản",
  LOYALTY_LOI_SO_DIEN_THOAI_KHONG_HOP_LE: "Số điện thoại không hợp lệ",
  LOYALTY_LOI_SO_THE_HOI_VIEN_BSV: "Quý khách vui lòng chỉ nhập số thẻ hội viện Bông Sen Vàng có 8/10 chữ số",
  LOYALTY_MA_THANH_VIEN_VINID: "Mã thành viên VinID",
  LOYALTY_MA_YEU_CAU: "Mã yêu cầu",
  LOYALTY_MOI_NHAT: "Mới nhất",
  LOYALTY_NHAP_DIA_CHI: "Địa chỉ",
  LOYALTY_NHAP_EMAIL: "Email",
  LOYALTY_NHAP_SO_DIEN_THOAI: "Số điện thoại",
  LOYALTY_NOI_DUNG_UU_DAI: "Nội dung ưu đãi",
  LOYALTY_NOTE_LOCK_CBNV:
    "PVcomBank sẽ chính thức triển khai Chương trình đổi quà dành cho khách hàng thân thiết trong năm 2020 và sẽ thông báo tới Quý khách hàng trong thời gian sớm nhất. Cảm ơn Quý khách hàng đã đồng hành và sử dụng sản phẩm dịch vụ của PVcomBank. Mọi chi tiết xin vui lòng liên hệ: {hot_line}.",
  LOYALTY_NOTE_HOT_LINE: "1900555592",
  LOYALTY_OUT: "Trừ điểm",
  LOYALTY_PHAN_LOAI_THEO: "Phân loại theo",
  LOYALTY_PHO_BIEN: "Phổ biến",
  LOYALTY_PROGRAM: "Khách hàng thân thiết",
  LOYALTY_SO_DIEN_THOAI_LIEN_HE: "1900 5555 92",
  LOYALTY_SO_LUONG: "Số lượng",
  LOYALTY_SO_THE_HOI_VIEN_BSV: "Số thẻ hội viên Bông Sen Vàng",
  LOYALTY_STK_THANH_TOAN_NHAN_TIEN: "Số tài khoản thanh toán nhận tiền",
  LOYALTY_TAT_CA: "Tất cả",
  LOYALTY_TEN_QUA: "Tên quà",
  LOYALTY_THE_LE: "Thể lệ",
  LOYALTY_THONG_BAO_HOI_HUY_DOI: "Quý khách có chắc chắn muốn Hủy đổi điểm quà?",
  LOYALTY_THONG_BAO_KHONG_DOI_QUA: "Quý khách không đủ điều kiện để đổi quà.",
  LOYALTY_THONG_BAO_TRANG_THAI_01:
    "Chương trình đổi quà dành cho khách hàng thân thiết chỉ áp dụng dành cho Khách hàng sở hữu thẻ tín dụng tại PVcomBank, Quý khách vui lòng đăng ký mở thẻ hoặc liên hệ CN/PGD gần nhất của PVcomBank hoặc liên hệ {hot_line} để được hỗ trợ. Chúc quý khách có những trải nghiệm tốt đẹp khi sử dụng SPDV của PVcomBank.",
  LOYALTY_THONG_TIN_NHAN_QUA: "Thông tin nhận quà",
  LOYALTY_THUONG_HIEU: "Thương hiệu",
  LOYALTY_TIM_HIEU_THEM: "Tìm hiểu thêm",
  LOYALTY_TIM_KIEM: "Tìm kiếm",
  LOYALTY_TRANG_THAI: "Trạng thái",
  LOYALTY_UU_DAI_MOI_NHAT: "Ưu đãi mới nhất",
  LOYALTY_PV_ONE: "PV One",
  LOYALTY_DIEM_HIEN_TAI: "Số điểm hiện tại",
  LOYALTY_DIEM_HET_HAN: "Ngày hết hạn",

  MAP_TAT_CA: "Tất cả",
  MAP_TIM_QUAN_HUYEN: "Tìm quận/huyện",
  MAP_TIM_TINH_THANH: "Tìm tỉnh/thành phố",

  NOTIFY_DANG_NHAP_DE_XEM_THONG_BAO: "Quý khách vui lòng đăng nhập để xem Thông báo.",
  NOTIFY_KHONG_CO_THONG_BAO: "Không có thông báo nào.",
  NOTIFY_TAT_CA: "Tất cả",
  NOTIFY_THONG_BAO: "Thông báo",
  NOTIFY_UU_DAI: "Ưu đãi",
  NOTIFY_UU_DAI_DA_BI_XOA: "Ưu đãi đã hết hạn",

  QR_ADDRESS_NOT_CONTAIN_SPECIAL: "Địa chỉ người nhận hàng không được chứa kí tự đặc biệt",
  QR_ADDRESS_NOT_NULL: "Địa chỉ người nhận hàng không được để trống",
  QR_ADDRESS_NOT_VIETNAMESE: "Địa chỉ người nhận hàng không được chứa tiếng Việt có dấu",
  QR_ADDRESS_REQUIRE: "Quý khách vui lòng nhập địa chỉ giao hàng",
  QR_BAN_CHUA_CHON_NGUON_THANH_TOAN: "Quý khách vui lòng chọn nguồn thanh toán",
  QR_CHI_TIET_GIAO_DICH: "Chi tiết giao dịch",
  QR_CHON_ANH_QR: "Chọn ảnh QR",
  QR_CHON_NGUON_KHAC: "CHỌN NGUỒN KHÁC",
  QR_CHO_PHEP: "Cho phép",
  QR_CONTENT_LUU_MA_THANH_CONG: "Đã lưu mã QR thành công",
  QR_DANG_NHAP_BANG_TAI_KHOAN_KHAC: "Đăng nhập bằng tài khoản khác",
  QR_DANG_NHAP_DE_THANH_TOAN: "Đăng nhập để thanh toán",
  QR_DANH_SACH_QUAN_HUYEN: "Danh sách Quận/Huyện",
  QR_DANH_SACH_THE: "Danh sách thẻ",
  QR_DANH_SACH_TINH_THANH: "Danh sách Tỉnh/Thành phố",
  QR_DIA_CHI: "Địa chỉ",
  QR_DIA_CHI_GIAO_HANG: "Địa chỉ giao hàng",
  QR_DIA_CHI_NHAN_HANG: "Địa chỉ nhận hàng",
  QR_DICH_VU: "Dịch vụ",
  QR_DIEM_BAN: "Điểm bán",
  QR_DISTRICT_REQUIRE: "Quý khách vui lòng chọn Quận/Huyện",
  QR_DON_GIA: "Đơn giá",
  QR_EMAIL: "Thư điện tử",
  QR_EMAIL_ERROR: "Thư điện tử không đúng định dạng. Quý khách vui lòng kiểm tra lại",
  QR_EMAIL_NOT_NULL: "Thư điện tử không được để trống",
  QR_EMAIL_REQUIRE: "Quý khách vui lòng nhập thư điện tử",
  QR_GHI_CHU: "Ghi chú",
  QR_GIAO_DICH_KHAC: "Giao dịch khác",
  QR_HO_TEN: "Họ tên",
  QR_HUY: "Hủy",
  QR_KHONG_DECODE_DC_MA_QR: "Mã QR không hợp lệ. Quý khách vui lòng kiểm tra lại.",
  QR_KHONG_HOP_LE: "Mã QR không hợp lệ. Quý khách vui lòng kiểm tra lại.",
  QR_KY_CUOC: "Kỳ cước",
  QR_LABLE_HUONG_DAN_NHAP_DIA_CHI: "Quý khách vui lòng nhập địa chỉ giao hàng",
  QR_LABLE_TAI_KHOAN_THANH_TOAN: "Tài khoản thanh toán",
  QR_LABLE_THE_GHI_NO: "Thẻ ghi nợ",
  QR_LABLE_THE_TIN_DUNG: "Thẻ tín dụng",
  QR_LABLE_THE_TRA_TRUOC: "Thẻ trả trước",
  QR_LICH_SU_GIAO_DICH: "Lịch sử giao dịch",
  QR_LUU_DIA_CHI: "Lưu",
  QR_LUU_MA: "Lưu mã QR",
  QR_MA_DIEM_BAN: "Mã điểm bán",
  QR_MA_GIAM_GIA: "Mã giảm giá",
  QR_MA_HOA_DON: "Số hóa đơn",
  QR_MA_KHACH_HANG: "Mã khách hàng",
  QR_MA_SAN_PHAM: "Mã sản phẩm",
  QR_NAME_ADDRESS_NOT_CONTAIN_SPECIAL: "Tên người nhận hàng không được chứa kí tự đặc biệt",
  QR_NAME_ADDRESS_NOT_NULL: "Tên người nhận hàng không được để trống",
  QR_NAME_ADDRESS_NOT_VIETNAMESE: "Tên người nhận hàng không được chứa tiếng Việt có dấu",
  QR_NAME_ADDRESS_REQUIRE: "Quý khách vui lòng nhập họ và tên người nhận hàng",
  QR_NGUON_THANH_TOAN: "Nguồn thanh toán",
  QR_NGUON_THANH_TOAN_KHAC: "Nguồn thanh toán",
  QR_NHA_CUNG_CAP: "Nhà cung cấp",
  QR_NOI_DUNG_HUONG_DAN: "Di chuyển camera đến hình ảnh mã QR",
  QR_NOI_DUNG_POPUP_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  QR_NOI_DUNG_POPUP_XIN_QUYEN: "Cho phép PV-Mobile Banking sử dụng camera trên thiết bị của Quý khách?",
  QR_NOI_DUNG_POPUP_XOA_DIA_CHI: "Quý khách có chắc chắn muốn xóa địa chỉ này?",
  QR_OPEN_SETTING: "Cài đặt",
  QR_PASSWORD_KHONG_DUOC_DE_TRONG: "Quý khách vui lòng nhập mật khẩu",
  QR_PHONE_ERROR: "Quý khách vui lòng kiểm tra lại số điện thoại",
  QR_PHONE_NOT_NULL: "Số điện thoại không được để trống",
  QR_PHONE_REQUIRE: "Quý khách vui lòng nhập số điện thoại",
  QR_PROVINCE_REQUIRE: "Quý khách vui lòng chọn Tỉnh/Thành phố",
  QR_QUAN_HUYEN: "Quận/Huyện",
  QR_QUET_THEM_MA: "Quét thêm mã",
  QR_QUY_KHACH_CHUA_CO_THE_GHI_NO: "Quý khách chưa có thẻ ghi nợ",
  QR_QUY_KHACH_CHUA_CO_THE_TIN_DUNG: "Quý khách chưa có thẻ tín dụng",
  QR_QUY_KHACH_CHUA_CO_THE_TRA_TRUOC: "Quý khách chưa có thẻ trả trước",
  QR_QUY_KHACH_VUI_LONG_CHON_DIA_CHI: "Quý khách vui lòng chọn địa chỉ giao hàng hoặc nhập địa chỉ mới",
  QR_QUY_KHACH_VUI_LONG_NHAP_SO_TIEN: "Quý khách vui lòng nhập số tiền thanh toán.",
  QR_SO_DIEN_THOAI: "Số điện thoại",
  QR_SO_DU: "Số dư",
  QR_SO_HOA_DON: "Số hóa đơn",
  QR_SO_LUONG: "Số lượng",
  QR_SO_TIEN: "Số tiền",
  QR_SO_TIEN_THANH_TOAN: "Số tiền thanh toán",
  QR_TAI_KHOAN: "Tài khoản",
  QR_TAI_KHOAN_NGUON: "Tài khoản nguồn",
  QR_TAI_KHOAN_THANH_TOAN: "Chọn tài khoản thanh toán",
  QR_TAI_KHOAN_THANH_TOAN_LABLE: "Tài khoản thanh toán",
  QR_TAI_KHOAN_THE_KHONG_DU_SO_DU: "Số dư của thẻ không đủ để thực hiện giao dịch.",
  QR_TAI_KHONG_DUOC_THUC_HIEN_GIAO_DICH:
    "Tài khoản nguồn ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  QR_TAO_DIA_CHI_GIAO_HANG: "Địa chỉ giao hàng",
  QR_TEN_KHACH_HANG: "Tên khách hàng",
  QR_TEN_SAN_PHAM: "Tên sản phẩm",
  QR_THANH_TOAN_CHO: "Thanh toán cho",
  QR_THANH_TOAN_QR: "Quét mã QR",
  QR_THE_BI_KHOA: "Thẻ của Quý khách đang bị khóa. Vui lòng liên hệ CN/PGD gần nhất hoặc 1900555592 để được hỗ trợ.",
  QR_THE_CHUA_KICH_HOAT: "Thẻ của Quý khách chưa được kích hoạt.",
  QR_THE_CHUA_KICH_HOAT_GIAO_DICH_TRUC_TUYEN: "Thẻ của Quý khách chưa được kích hoạt giao dịch trực tuyến.",
  QR_THE_GHI_NO: "Chọn thẻ ghi nợ",
  QR_THE_THANH_TOAN: "Thẻ thanh toán",
  QR_THE_TIN_DUNG: "Chọn thẻ tín dụng",
  QR_THE_TRA_TRUOC: "Chọn thẻ trả trước",
  QR_THE_TRA_TRUOC_DINH_DANH: "Chọn thẻ trả trước định danh",
  QR_THOI_HAN_THANH_TOAN: "Thời hạn thanh toán",
  QR_THONG_BAO: "Thông báo",
  QR_THONG_BAO_DANG_THUC_HIEN_QUET_THEM_MA_SAN_PHAM:
    "Định dạng QR sản phẩm này không giống với định dạng QR sản phẩm đã quét trước đó. Quý khách vui lòng kiểm tra lại.",
  QR_THONG_TIN_THANH_TOAN: "Thông tin thanh toán",
  QR_THONG_TIN_THANH_TOAN_QR: "Thanh toán QR",
  QR_TINH_THANH_PHO: "Tỉnh/Thành phố",
  QR_TU_CHOI: "Từ chối",
  QR_USER_NAME_KHONG_DUOC_DE_TRONG: "Quý khách vui lòng nhập tên đăng nhập",
  QR_XAC_NHAN: "Xác thực giao dịch",
  QR_CHU_TAI_KHOAN: "Tên chủ tài khoản",
  QR_TAO_MA_QR_KHAC: "Tạo mã QR",
  QR_TAI_QR: "Lưu",

  SALE_BO_LOC: "Bộ lọc",
  SALE_CHI_TIET: "Chi tiết",
  SALE_DANH_GIA: "Đánh giá",
  SALE_HUY: "Hủy",
  SALE_KHONG_CO_DU_LIEU: "Không có chương trình ưu đãi",
  SALE_KHONG_CO_DU_LIEU_FILTER: "Không tìm thấy ưu đãi theo điều kiện lọc",
  SALE_LINH_VUC: "Lĩnh vực",
  SALE_PHAN_LOAI_TIN: "Phân loại tin",
  SALE_TAT_CA: "Tất cả",
  SALE_UU_DAI: "Ưu đãi",
  SALE_XONG: "Xong",

  SAVING_CHI_TIET_SO_TIET_KIEM: "Chi tiết sổ tiết kiệm",
  SAVING_CHI_NHANH_QUAN_LY_SO: "Chi nhánh quản lý sổ",
  SAVING_CHON_CHI_NHANH_QUAN_LY_SO: "Chọn chi nhánh quản lý sổ",
  SAVING_CHON_HINH_THUC_DAO_HAN: "Chọn hình thức đáo hạn",
  SAVING_CHON_KY_HAN: "Chọn kỳ hạn",
  SAVING_CHON_SAN_PHAM: "Chọn sản phẩm",
  SAVING_CHON_SO_TIET_KIEM: "Chọn sổ tiết kiệm",
  SAVING_CHUYEN_VAO_TAI_KHOAN: "Chuyển vào tài khoản",
  SAVING_DANH_SACH_SO_TIET_KIEM: "Danh sách sổ tiết kiệm",
  SAVING_DIEN_THOAI: "Điện thoại",
  SAVING_DUOC_NOP_THEM_TIEN_VAO_SO: "Được nộp thêm tiền vào sổ",
  SAVING_DUOC_RUT_TUNG_PHAN_TRUOC_HAN: "Được rút từng phần trước hạn",
  SAVING_HINH_THUC_DAO_HAN: "Hình thức đáo hạn",
  SAVING_HINH_THUC_NOP: "Hình thức nộp",
  SAVING_KHONG_CO_SAN_PHAM: "Không có sản phẩm",
  SAVING_KHONG_CO_SO_TIET_KIEM: "Quý khách chưa có tài khoản tiết kiệm",
  SAVING_KHONG_CO_SO_TIET_KIEM_NOP_THEM: "Quý khách chưa có tài khoản tiết kiệm tích lũy",
  SAVING_KHONG_CO_SO_TIET_KIEM_TAT_TOAN: "Quý khách chưa có tài khoản tiết kiệm nào được phép tất toán",
  SAVING_KHONG_DUOC_NOP_THEM_TIEN_VAO_SO: "Không được nộp thêm tiền vào sổ",
  SAVING_KHONG_DUOC_RUT_TUNG_PHAN_TRUOC_HAN: "Không được rút từng phần trước hạn",
  SAVING_KY_HAN: "Kỳ hạn",
  SAVING_KY_HAN_NOP_SO_TIEN_NOP: "Kỳ hạn số tiền nộp",
  SAVING_LAI_DA_NHAN: "Lãi đã nhận",
  SAVING_LAI_DUOC_NHAN: "Lãi được nhận",
  SAVING_LAI_NHAN_DUOC: "Lãi nhận được",
  SAVING_LAI_SUAT: "Lãi suất",
  SAVING_LAI_SUAT_NOP_GAN_NHAT: "Lãi suất nộp gần nhất",
  SAVING_LAI_SUAT_SO_TIEN_NOP: "Lãi suất số tiền nộp",
  SAVING_LAI_THUC_NHAN: "Lãi thực nhận",
  SAVING_LAI_XUAT_VIET_THUONG: "lãi suất",
  SAVING_LOI_CHUA_CHON_CHI_NHANH_QUAN_LY_SO: "Quý khách chưa chọn chi nhánh quản lý sổ",
  SAVING_LOI_CHUA_CHON_HINH_THUC_DAO_HAN: "Quý khách chưa chọn hình thức đáo hạn",
  SAVING_LOI_CHUA_CHON_KY_HAN: "Quý khách chưa chọn kỳ hạn",
  SAVING_LOI_CHUA_CHON_SAN_PHAM: "Quý khách chưa chọn sản phẩm",
  SAVING_LOI_CHUA_NHAP_SO_TIEN: "Mời quý khách nhập số tiền",
  SAVING_LOI_KY_TU_DAC_BIET: "Mã ưu đãi không được chứa ký tự đặc biệt",
  SAVING_MO_SO: "Mở sổ",
  SAVING_MO_SO_TIET_KIEM: "Mở sổ tiết kiệm",
  SAVING_NGAY_DAO_HAN: "Ngày đáo hạn",
  SAVING_NGAY_DEN_HAN: "Ngày đến hạn",
  SAVING_NGAY_GIAO_DICH: "Ngày giao dịch",
  SAVING_NGAY_MO_SO: "Ngày mở sổ",
  SAVING_NGAY_NHAN_LAI: "Ngày nhận lãi",
  SAVING_NGAY_NOP_GAN_NHAT: "Ngày nộp gần nhất",
  SAVING_NHAP_SO_TIEN: "Nhập số tiền",
  SAVING_NOP_THEM: "Nộp thêm",
  SAVING_NOTE_ADVICE: "Lãi suất các sản phẩm là lãi suất được hưởng khi mở sổ trên Mobile Banking, áp dụng cho khách hàng thông thường",
  SAVING_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  SAVING_SAN_PHAM: "Sản phẩm",
  SAVING_SO_DU_SO: "Số dư sổ",
  SAVING_SO_DU_SO_SAU_NOP_THEM: "Số dư sổ sau khi nộp thêm",
  SAVING_SO_DU_HIEN_TAI: "Số dư hiện tại",
  SAVING_SO_SO: "Số sổ",
  SAVING_SO_TAI_KHOAN: "Số tài khoản",
  SAVING_SO_TIEN: "Số tiền",
  SAVING_SO_TIEN_GIAO_DICH_TOI_THIEU: "Số tiền giao dịch tối thiểu là",
  SAVING_SO_TIEN_GUI: "Số tiền gửi",
  SAVING_SO_TIEN_GUI_KDV: "Số tiền gửi",
  SAVING_SO_TIEN_NOP: "Số tiền nộp",
  SAVING_SO_TIEN_NOP_THEM: "Số tiền nộp thêm",
  SAVING_SO_TIEN_RUT: "Số tiền rút",
  SAVING_SO_TIEN_TOI_THIEU: "Số tiền tối thiểu là",
  SAVING_SO_TIET_KIEM: "Sổ tiết kiệm",
  SAVING_SO_TIET_ONLINE: "Sổ tiết kiệm online",
  SAVING_SO_TIET_TAI_QUAY: "Sổ tiết kiệm tại quầy",
  SAVING_TAI_KHOAN: "Tài khoản",
  SAVING_TAI_KHOAN_GHI_CO: "Tài khoản ghi có",
  SAVING_TAI_KHOAN_GHI_NO: "Tài khoản ghi nợ",
  SAVING_TAI_KHOAN_TRICH_NO: "Tài khoản trích nợ",
  SAVING_TAI_KHOAN_NGUON: "Tài khoản nguồn",
  SAVING_TAI_KHOAN_THANH_TOAN: "Tài khoản thanh toán",
  SAVING_TAT_TOAN: "Tất toán",
  SAVING_TEN_TAI_KHOAN: "Tên tài khoản",
  SAVING_THAY_DOI_MAT_KHAU: "Thay đổi mật khẩu",
  SAVING_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "Quý khách vui lòng chọn ngày bắt đầu trước ngày kết thúc.",
  SAVING_THONG_BAO_TRANG_THAI_TAI_KHOAN_NGUON:
    "Tài khoản nguồn ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  SAVING_THONG_TIN_GIAO_DICH: "Thông tin giao dịch",
  SAVING_THONG_TIN_SO_TIET_KIEM: "Thông tin sổ tiết kiệm",
  SAVING_TONG_GHI_CO: "Tổng ghi có",
  SAVING_TRUY_VAN: "Truy vấn",
  SAVING_TU_VAN_GUI_TIET_KIEM: "Tư vấn gửi tiết kiệm",
  SAVING_PROMO_CODE: "Mã ưu đãi",
  SAVING_YOUR_PROMOTION_CODE: "Mã ưu đãi của quý khách",
  SAVING_INFO_NOT_MATCH_PROMO:
    "Thông tin mở sổ tiết kiệm không đúng với mã ưu đãi. Quý khách có muốn sử dụng đúng thông tin với mã ưu đãi?",
  SAVING_DAC_DIEM: "Đặc điểm",
  SAVING_TAT_TOAN_STK_THANH_CONG: "Tất toán sổ tiết kiệm thành công",
  SAVING_TEN_NGUOI_THU_HUONG: "Tên người thụ hưởng",
  SAVING_VUI_LONG_CHON_SO_TIET_KIEM: "Quý khách vui lòng chọn sổ tiết kiệm",
  SAVING_VUI_LONG_CHON_TAI_KHOAN_NHAN: "Quý khách vui lòng chọn tài khoản nhận",
  SAVING_THOI_GIAN_GHI_NHAN_MO_SO: "Thời gian ghi nhận mở sổ tiết kiệm",
  SAVING_THONG_BAO_GHI_NHAN_MO_SO:
    "Hiện tại đang là thời gian khoá hệ thống ghi nhận số liệu của PVcomBank nên sổ tiết kiệm này sẽ được ghi nhận vào ngày {day}",
  SAVING_PROMOTION_CONTENT:
    "Chúc mừng Quý khách đủ điều kiện tham gia CTKM {event_name} và có cơ hội nhận tới 10.000.000 điểm PVOne. Tham gia ngay?",
  SAVING_PROMOTION_SUB_CONTENT:
    "(Bằng việc đồng ý tham gia CTKM, Quý khách đồng thời đồng ý để PVcomBank phong tỏa Thẻ tiết kiệm này trong vòng 01 tháng kể từ ngày mở).",
  SAVING_PROMOTION_EVENT_NAME: "Mở tiềm năng – Mở tương lai",
  SAVING_PROMOTION_EVENT_MORE_INFO: "Chi tiết thể lệ Quý khách vui lòng xem ",
  SAVING_PROMOTION_EVENT_HERE: "tại đây",
  SAVING_PROMOTION_APPLY_SUCCESS_AMOUNT:
    "PVcomBank chúc mừng Quý khách đã nhận được quà tặng tiền mặt vào tài khoản thanh toán trị giá {amount}.",
  SAVING_PROMOTION_APPLY_SUCCESS: `Chúc mừng Quý khách đã nhận được lượt tham gia nhận quà từ CTKM “Mở tiềm năng – Mở tương lai”. \n Truy cập và tham gia ngay trên ứng dụng PV Mobile Banking!`,
  SAVING_PROPMOTION_FINALIZATION_MESSAGE:
    "Tài khoản tiết kiệm của Quý khách đang tham gia CTKM {event_name}, khi tất toán trước hạn PVcomBank sẽ thu hồi giá trị quà tặng Quý khách đã nhận từ chương trình.",
  SAVING_PROMOTION_ACTION_AGREE: "Đồng ý",
  SAVING_PROMOTION_ACTION_NOT_AGREE: "Thoát",
  SAVING_NOTE_CUT_OFF_TIME_OPEN:
    "Lưu ý: Các giao dịch mở mới tài khoản tiết kiệm thực hiện vào thời gian khóa ngày sẽ được tính lãi vào ngày kế tiếp theo điều khoản, điều kiện tại PVcomBank",
  SAVING_NOTE_CUT_OFF_TIME_TOPUP:
    "Lưu ý: Các giao dịch nộp thêm vào tài khoản tiết kiệm thực hiện vào thời gian khóa ngày sẽ được tính lãi vào ngày kế tiếp theo điều khoản, điều kiện tại PVcomBank",
  SAVING_NOTE_DIEU_KHOAN_DIEU_KIEN_1: "Tôi đã đọc và đồng ý với các",
  SAVING_NOTE_DIEU_KHOAN_DIEU_KIEN_2: "điều khoản, điều kiện",
  SAVING_NOTE_DIEU_KHOAN_DIEU_KIEN_3: "về mở và sử dụng sổ tiết kiệm điện tử của ngân hàng PVcomBank",

  SETTING_BD_MAC_DINH: "Mặc định",
  SETTING_BD_NGUONG_AN_TOAN: "Ngưỡng an toàn",
  SETTING_BIEU_DO_HIEN_THI: "Biểu đồ hiển thị",
  SETTING_CAP_NHAT_NGON_NGU_THANH_CONG: "Cập nhật ngôn ngữ hiển thị thành công",
  SETTING_CAP_NHAT_NGON_NGU_THAT_BAI: "Cập nhật ngôn ngữ hiển thị thất bại",
  SETTING_CHON_BIEU_DO_HIEN_THI: "Chọn biểu đồ hiển thị",
  SETTING_CHON_NGON_NGU: "Chọn ngôn ngữ",
  SETTING_CHUC_NANG_TAM_THOI_BI_KHOA: "Chức năng này tạm thời bị khóa",
  SETTING_CHU_THICH_CHO_PHEP_NHAN_THONG_BAO: "Quý khách sẽ nhận được thông báo về các sự kiện, ưu đãi từ PVcomBank",
  SETTING_CHU_THICH_KHUON_MAT: "Quý khách có thể đăng nhập bằng cách sử dụng khuôn mặt",
  SETTING_CHU_THICH_NHAN_THONG_BAO: "Hãy bật tính năng này để nhận thông báo về các sự kiện, ưu đãi từ PVcomBank",
  SETTING_CHU_THICH_QUEN_MAT_KHAU: "Quý khách vui lòng đến chi nhánh gần nhất để lấy lại mật khẩu",
  SETTING_CHU_THICH_VAN_TAY: "Quý khách có thể đăng nhập bằng cách sử dụng vân tay",
  SETTING_CHU_Y: "Chú ý",
  SETTING_DANG_NHAP_BANG_KHUON_MAT: "Đăng nhập bằng khuôn mặt",
  SETTING_DANG_NHAP_BANG_VAN_TAY: "Đăng nhập bằng vân tay",
  SETTING_DANG_NHAP_KHUON_MAT_NOTE: "Lưu ý: Tất cả khuôn mặt đã được đăng ký trong thiết bị đều có thể xác thực",
  SETTING_DANG_NHAP_LUC: "Đăng nhập lúc",
  SETTING_DANG_NHAP_VAN_TAY_NOTE: "Lưu ý: Tất cả vân tay đã được đăng ký trong thiết bị đều có thể xác thực",
  SETTING_DANH_BA: "Danh bạ",
  SETTING_DANH_SACH_DICH_VU: "Danh sách dịch vụ",
  SETTING_HUONG_DAN_SU_DUNG: "Hướng dẫn sử dụng",
  SETTING_KHACH_HANG_THAN_THIET: "Khách hàng thân thiết",
  SETTING_LOI_CHUA_NHAP_MAT_KHAU_HIEN_TAI: "Quý khách vui lòng nhập mật khẩu hiện tại",
  SETTING_LOI_CHUA_NHAP_MAT_KHAU_MOI: "Quý khách vui lòng nhập mật khẩu mới",
  SETTING_LOI_CHUA_NHAP_LAI_MAT_KHAU_MOI: "Quý khách vui lòng nhập lại mật khẩu mới",
  SETTING_MAT_KHAU: "Mật khẩu",
  SETTING_NHAN_THONG_BAO: "Nhận thông báo",
  SETTING_THAY_DOI_MAT_KHAU: "Thay đổi mật khẩu",
  SETTING_NHAP_MAT_KHAU_HIEN_TAI: "Nhập mật khẩu hiện tại",
  SETTING_NHAP_MAT_KHAU_MOI: "Nhập mật khẩu mới",
  SETTING_NHAP_LAI_MAT_KHAU_MOI: "Nhập lại mật khẩu mới",
  SETTING_LOI_MAT_KHAU_BI_TRUNG: "Mật khẩu mới không được trùng với tên đăng nhập hoặc mật khẩu hiện tại",
  SETTING_LOI_MAT_KHAU_KHONG_HOP_LE: "Mật khẩu không hợp lệ",
  SETTING_LOI_NHAP_SAI_MAT_KHAU: "Mật khẩu hiện tại không chính xác",
  SETTING_LOI_NHAP_SAI_MAT_KHAU_CONFIRM: "Mật khẩu mới không trùng khớp",
  SETTING_NOTE_DOI_MAT_KHAU: "Lưu ý: Mật khẩu hợp lệ phải đáp ứng các tiêu chí sau:",
  SETTING_RULES_CHANGE_PASS_1: "- Độ dài tối thiểu 06 ký tự",
  SETTING_RULES_CHANGE_PASS_2: "- Bao gồm chữ cái và chữ số, chữ hoa và chữ thường hoặc ký tự đặc biệt",
  SETTING_RULES_CHANGE_PASS_3: "- Không được trùng với tên đăng nhập",
  SETTING_RULES_CHANGE_PASS_4: "- Không được trùng với mật khẩu cũ",
  SETTING_THAY_DOI_MAT_KHAU_THANH_CONG: "Thay đổi mật khẩu thành công. Quý khách vui lòng đăng nhập lại.",
  SETTING_NOTE_DOI_MAT_KHAU_FORCE_CHANGE:
    "Để đảm bảo an toàn các giao dịch, Quý khách vui lòng cập nhật mật khẩu để tiếp tục sử dụng dịch vụ.",
  SETTING_NOTE_DOI_MAT_KHAU_HET_HAN:
    "Mật khẩu đăng nhập PV-Mobile Banking của quý khách đã hết hạn. Quý khách vui lòng thay đổi mật khẩu để tiếp tục sử dụng dịch vụ.",
  SETTING_NOTE_DOI_MAT_KHAU_LAN_DAU: "Quý khách vui lòng đổi mật khẩu cho lần đăng nhập đầu tiên",
  SETTING_THONG_BAO_BAT_MO_KHOA_BANG_KHUON_MAT: "Thiết bị chưa cài đặt xác thực khuôn mặt. Quý khách vui lòng kiểm tra lại.",
  SETTING_THONG_BAO_BAT_MO_KHOA_BANG_VAN_TAY: "Thiết bị chưa cài đặt xác thực vân tay. Quý khách vui lòng kiểm tra lại.",
  SETTING_THONG_BAO_CAI_DAT_XAC_THUC_KHUON_MAT:
    "Quý khách vui lòng đăng nhập ứng dụng. Chọn Tiện ích để kích hoạt tính năng Đăng nhập bằng khuôn mặt.",
  SETTING_THONG_BAO_CAI_DAT_XAC_THUC_VAN_TAY:
    "Quý khách vui lòng đăng nhập ứng dụng. Chọn Tiện ích để kích hoạt tính năng Đăng nhập bằng vân tay.",
  SETTING_THONG_BAO_DONG_XAC_THUC_KHUON_MAT: "Đã tắt tính năng đăng nhập bằng khuôn mặt.",
  SETTING_THONG_BAO_DONG_XAC_THUC_VAN_TAY: "Đã tắt tính năng đăng nhập bằng vân tay.",
  SETTING_THONG_BAO_HOI_OFF_ACCOUNT_BLANCE: "Quý khách có muốn tắt xem số dư tài khoản",
  SETTING_THONG_BAO_HOI_ON_ACCOUNT_BLANCE: "Quý khách có muốn bật xem số dư tài khoản",
  SETTING_THONG_BAO_KHOA_KHUON_MAT:
    "Quý khách đã nhập sai khuôn mặt quá nhiều lần. Vui lòng vào cài đặt khuôn mặt của thiết bị để kích hoạt lại tính năng này.",
  SETTING_THONG_BAO_KHOA_VAN_TAY:
    "Quý khách đã nhập sai vân tay quá nhiều lần. Vui lòng vào cài đặt vân tay của thiết bị để kích hoạt lại tính năng này.",
  SETTING_THONG_BAO_MO_XAC_THUC_KHUON_MAT: "Đã bật tính năng xác thực đăng nhập bằng khuôn mặt.",
  SETTING_THONG_BAO_MO_XAC_THUC_VAN_TAY: "Đã bật tính năng xác thực đăng nhập bằng vân tay.",
  SETTING_THONG_BAO_OFF_ACCOUNT_BLANCE: "Vô hiệu hóa để xem số dư tài khoản {account} thành công",
  SETTING_THONG_BAO_OFF_NOTIFY: "Đã tắt tính năng nhận thông báo",
  SETTING_THONG_BAO_ON_ACCOUNT_BLANCE: "Đăng ký xem số dư tài khoản {account} thành công",
  SETTING_THONG_BAO_ON_NOTIFY: "Đã bật tính năng nhận thông báo",
  SETTING_THONG_BAO_QUET_VAN_TAY_DANG_NHAP: "Quý khách vui lòng quét vân tay để đăng nhập ứng dụng.",
  SETTING_THONG_BAO_QUET_VAN_TAY_TREN_THIET_BI: "Quý khách vui lòng quét dấu vân tay đã đăng ký trên thiết bị.",
  SETTING_THONG_BAO_TAM_KHOA_VAN_TAY: "Quý khách đã nhập sai vân tay nhiều lần. Vui lòng thử lại sau 30 giây.",
  SETTING_TIEN_ICH: "Tiện ích",
  SETTING_CAI_DAT: "Cài đặt",
  SETTING_VAN_TAY: "Vân tay",
  SETTING_XAC_THUC_KHUON_MAT: "Xác thực khuôn mặt",
  SETTING_XAC_THUC_LOI: "Lỗi",
  SETTING_XAC_THUC_LOI_THU_LAI: "Xác thực không đúng. Thử lại",
  SETTING_XAC_THUC_VAN_TAY: "Xác thực vân tay",
  SETTING_XEM_SO_DU: "Xem số dư",
  SETTING_QL_DS_THU_HUONG: "Quản lý danh sách thụ hưởng",
  SETTING_DOI_MAT_KHAU_DANG_NHAP: "Đổi mật khẩu đăng nhập",
  SETTING_PHUONG_THUC_XAC_THUC: "Cài đặt phương thức xác thực",
  SETTING_TINH_NANG_YEU_THICH: "Cài đặt tính năng yêu thích",
  SETTING_TK_MAC_DINH: "Cài đặt tài khoản mặc định",
  SETTING_GOI_HAN_MUC: "Thay đổi gói hạn mức giao dịch",
  SETTING_THONG_BAO: "Cài đặt thông báo",
  SETTING_THONG_TIN_NGUOI_DUNG: "Cài đặt thông tin người dùng",
  SETTING_LAY_MA_XAC_THUC: "Lấy mã xác thực",
  SETTING_CAI_DAT_CHU_DE: "Cài đặt chủ đề",
  SETTING_CHU_DE_MAC_DINH: "Mặc định",
  SETTING_CHU_DE_NAM_MOI: "Năm mới",
  SETTING_PV_ONLINE_BANKING: "PV Online Banking",
  SETTING_CAU_HOI_THUONG_GAP: "Câu hỏi thường gặp",

  SMS_BANK_DANG_KY: "Đăng ký",
  SMS_BANK_DANG_KY_NGAY: "Đăng ký ngay",
  SMS_BANK_DANG_KY_SMS_BANKING: "Đăng ký SMS Banking",
  SMS_BANK_DICH_VU: "Dịch vụ",
  SMS_BANK_DICH_VU_TAI_CHINH: "Dịch vụ tài chính",
  SMS_BANK_DV_TAI_CHINH_NOTE:
    "Dịch vụ tài chính cho phép sử dụng số điện thoại đã đăng ký để thực hiện nạp tiền điện thoại, kích hoạt dịch vụ PV-eCommerce, truy vấn số dư và giao dịch tài khoản qua tin nhắn SMS",
  SMS_BANK_HUY: "Hủy",
  SMS_BANK_HUY_DV: "Hủy dịch vụ",
  SMS_BANK_LUU: "Lưu",
  SMS_BANK_NOTE_CHUA_DANG_KY_SMS: "Quý khách chưa đăng ký cài đặt SMS Banking.",
  SMS_BANK_SMS_BIEN_DONG_SO_DU: "Tin nhắn biến động số dư",
  SMS_BANK_SMS_BIEN_DONG_SO_DU_NOTE: "Nhận tin nhắn biến động số dư của các tài khoản thanh toán",
  SMS_BANK_SMS_KHAC: "Tin nhắn khác",
  SMS_BANK_SO_DIEN_THOAI: "Số điện thoại",
  SMS_BANK_THEM_SO: "Thêm số",
  SMS_BANK_THOAT: "Thoát",
  SMS_BANK_THONG_BAO_CHUA_NHAP_SDT: "Quý khách vui lòng nhập số điện thoại.",
  SMS_BANK_THONG_BAO_DK_IT_NHAT: "Quý khách vui lòng đăng ký nhận biến động số dư của ít nhất 1 tài khoản thanh toán.",
  SMS_BANK_THONG_BAO_KHONG_DUOC_DANG_KY_DO_SDT_DA_DK_DV:
    "Dịch vụ tài chính không được đăng ký do số điện thoại đã đăng ký dịch vụ tài chính cho người khác.",
  SMS_BANK_THONG_BAO_SDT_DA_DUOC_DK_NGUOI_DUNG_KHAC:
    "Số điện thoại đã đăng ký dịch vụ tài chính cho người dùng khác. Quý khách vui lòng sử dụng số điện thoại khác.",
  SMS_BANK_THONG_BAO_SDT_KHONG_TON_TAI: "Số điện thoại không tồn tại.",
  SMS_BANK_THONG_BAO_TU_NGAN_HANG: "Thông báo từ ngân hàng",
  SMS_BANK_TIEN_GUI: "Tiền gửi",
  SMS_BANK_TIEN_ICH: "Tiện ích",
  SMS_BANK_TIEN_VAY: "Tiền vay",
  SMS_BANK_TK_THANH_TOAN: "Tài khoản thanh toán",
  SMS_BANK_TK_TRICH_NO: "Tài khoản trích nợ",
  SMS_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",

  SM_OTP_BUOC_1: "1. Xác nhận đăng ký",
  SM_OTP_BUOC_2: "2. Tạo mã PIN bảo vệ. Hoàn tất đăng ký",
  SM_OTP_CAI_DAT_FACE_ID: "Xác thực giao dịch bằng khuôn mặt",
  SM_OTP_CAI_DAT_VAN_TAY: "Xác thực giao dịch bằng vân tay",
  SM_OTP_CHUA_NHAP_MA_GIAO_DICH: "Quý khách chưa nhập mã giao dịch",
  SM_OTP_CHUA_NHAP_MA_KICH_HOAT: "Quý khách vui lòng nhập mã kích hoạt",
  SM_OTP_CHUA_NHAP_PASS_DANG_NHAP: "Quý khách vui lòng nhập mật khẩu",
  SM_OTP_CHUA_NHAP_PIN: "Quý khách chưa mhập mã PIN.",
  SM_OTP_CHUA_NHAP_PIN_CONFIRM: "Quý khách vui lòng nhập lại mã PIN mới",
  SM_OTP_CHUA_NHAP_PIN_NEW: "Quý khách vui lòng nhập mã PIN mới",
  SM_OTP_CHUA_NHAP_PIN_OLD: "Quý khách vui lòng nhập mã PIN hiện tại",
  SM_OTP_CHUA_NHAP_USER: "Quý khách vui lòng nhập Tên đăng nhập",
  SM_OTP_DANG_KY_SM_OTP: "Đăng ký Smart OTP",
  SM_OTP_DANG_KY_NGAY: "Đăng ký",
  SM_OTP_DOI_MA_PIN: "Đổi mã PIN",
  SM_OTP_DOI_MA_PIN_SMART: "Đổi mã PIN",
  SM_OTP_ERROR_CONFIRM_PIN_MOI: "Nhập lại mã PIN mới không chính xác. Quý khách vui lòng kiểm tra lại",
  SM_OTP_ERROR_MA_KICH_HOAT: "Mã kích hoạt không hợp lệ. Quý khách vui lòng kiểm tra lại",
  SM_OTP_ERROR_NHAP_LAI_MA_PIN: "Mã PIN không khớp. Quý khách vui lòng kiểm tra lại",
  SM_OTP_ERROR_NHAP_MA_PIN: "Mã PIN không hợp lệ. Quý khách vui lòng kiểm tra lại",
  SM_OTP_ERROR_PIN: "Mã PIN Smart OTP không chính xác. Quý khách vui lòng kiểm tra lại.",
  SM_OTP_ERROR_PIN_MOI: "Mã PIN mới không được trùng với mã PIN hiện tại",
  SM_OTP_ERROR_PIN_MOI_KHONG_HOP_LE: "Mã PIN không hợp lệ. Quý khách vui lòng kiểm tra lại",
  SM_OTP_GIOI_THIEU_SM_OTP: "Giới thiệu Smart OTP",
  SM_OTP_HET_SO_LAN_NHAP_MA_PIN:
    "Phương thức xác thực của Quý khách bị tạm khóa trong vòng 30 phút, do nhập sai mã PIN quá số lần cho phép",
  SM_OTP_HOAC_NHAP_MA_GIAO_DICH: "Hoặc nhập mã giao dịch",
  SM_OTP_HOAC_NHAP_MA_GIAO_DICH_KICH_HOAT: "Hoặc nhập mã kích hoạt",
  SM_OTP_HOAC_QUET_QR: "Hoặc quét mã QR",
  SM_OTP_HOAC_QUET_QR_KICH_HOAT: "Hoặc quét mã QR code để kích hoạt",
  SM_OTP_KHONG_THE_DANG_KY_DO_1: "Quý khách đã đăng ký Smart OTP trên thiết bị khác.",
  SM_OTP_KHONG_THE_DANG_KY_DO_2: "Quý khác đã xóa ứng dụng PVCombank hoặc đã cài đặt lại thiết bị.",
  SM_OTP_KICH_HOAT: "Kích hoạt",
  SM_OTP_KICH_HOAT_SM_OTP: "Kích hoạt Smart OTP",
  SM_OTP_LAY_LAI_MA_KICH_HOAT: "Lấy lại mã kích hoạt",
  SM_OTP_LAY_MA_OTP: "Lấy mã xác thực OTP",
  SM_OTP_LOAI_GIAO_DICH: "Loại giao dịch",
  SM_OTP_LOI_MA_KICH_HOAT_3_LAN:
    "Mã kích hoạt bị hủy do Quý khách đã nhập sai quá 03 lần. Trường hợp quên mã kích hoạt, Quý khách vui lòng thực hiện lấy lại mã kích hoạt mới.",
  SM_OTP_LOI_NHAP_USER: "Tên đăng nhập không chính xác",
  SM_OTP_LOI_PASS_DANG_NHAP: "Mật khẩu không chính xác",
  SM_OTP_MAT_THIET_BI_HOAC_KICH_HOAT_LAI_SM_OTP: "Mất thiết bị/Kích hoạt lại",
  SM_OTP_MA_GIAO_DICH: "Mã giao dịch",
  SM_OTP_MA_GIAO_DICH_KHONG_HOP_LE: "Mã giao dịch không hợp lệ. Quý khách vui lòng kiểm tra lại",
  SM_OTP_MA_KICH_HOAT: "Mã kích hoạt",
  SM_OTP_MA_OTP: "Mã OTP",
  SM_OTP_MA_QR_KHONG_HOP_LE: "Mã QR không hợp lệ",
  SM_OTP_NHAP_LAI_MA_PIN: "Nhập lại mã PIN",
  SM_OTP_NHAP_LAI_PIN_MOI: "Nhập lại mã PIN mới",
  SM_OTP_NHAP_MA: "Nhập mã",
  SM_OTP_NHAP_MA_GIAO_DICH: "Nhập mã giao dịch",
  SM_OTP_NHAP_MA_HIEN_THI_XAC_THUC_GIAO_DICH: "Nhập mã giao dịch hiển thị trên màn hình xác thực giao dịch",
  SM_OTP_NHAP_MA_PIN: "Nhập mã PIN",
  SM_OTP_NHAP_MA_PIN_SAI: "Mã PIN không chính xác. Quý khách còn {counter} lần nhập",
  SM_OTP_NHAP_PIN_HIEN_TAI: "Nhập mã PIN hiện tại",
  SM_OTP_NHAP_PIN_MOI: "Nhập mã PIN mới",
  SM_OTP_NHAP_PIN_SAI_CON_1_LAN:
    "Quý khách đã nhập sai mã PIN 04 lần. Nếu nhập sai lần tiếp theo, phương thức xác thực của Quý khách sẽ tạm khóa trong vòng 30 phút.",
  SM_OTP_NOI_DUNG_GIOI_THIEU_SM_OTP:
    "Smart OTP là phương thức bảo mật tiên tiến, giúp nâng cao tính bảo mật trong các giao dịch trực tuyến. Đăng ký Smart OTP qua 2 bước đơn giản:",
  SM_OTP_NOTE_CHECK_AUTH_1: "Tôi đồng ý với",
  SM_OTP_NOTE_CHECK_AUTH_2: "Điều khoản và điều kiện",
  SM_OTP_NOTE_CHECK_AUTH_3: "sử dụng Smart OTP",
  SM_OTP_NOTE_CHECK_CHUYEN_THIET_BI: "Tôi đồng ý chuyển đổi thiết bị đăng ký Smart OTP.",
  SM_OTP_NOTE_CHECK_CHU_SO_HUU_DUY_NHAT_1: "Tôi là",
  SM_OTP_NOTE_CHECK_CHU_SO_HUU_DUY_NHAT_2: "CHỦ SỞ HỮU DUY NHẤT",
  SM_OTP_NOTE_CHECK_CHU_SO_HUU_DUY_NHAT_3: "của thiết bị mới đó.",
  SM_OTP_NOTE_CHUYEN_THIET_BI: "Xác nhận chuyển Smart OTP sang thiết bị mới",
  SM_OTP_NOTE_ERROR_NHAP_MA: "Mã kích hoạt không hợp lệ. Quý khách vui lòng kiểm tra lại",
  SM_OTP_NOTE_KICH_HOAT: "Kích hoạt Smart OTP dành cho khách hàng mới hoặc khách hàng yêu cầu cài đặt Smart OTP trên Internet Banking",
  SM_OTP_NOTE_NHAP_LAI_MA_PIN: "Nhập lại mã PIN bảo vệ Smart OTP",
  SM_OTP_NOTE_NHAP_MA: "Mã kích hoạt Smart OTP được gửi qua tin nhắn đến số điện thoại {number}. Thời hạn hiệu lực trong vòng 24h.",
  SM_OTP_NOTE_NHAP_PHIEN_XAC_THUC_GIAO_DICH:
    "Sử dụng PV MobileBanking đã cài đặt Smart OTP để quét mã QR hoặc nhập mã số giao dịch dưới đây để lấy mã xác thực OTP",
  SM_OTP_NOTE_TAO_MA_PIN: "Tạo mã PIN bảo vệ Smart OTP",
  SM_OTP_NOTE_TAO_MA_PIN_TRUNG_LIEN_TUC: "Quý khách không nên đặt mã PIN gồm các số liên tiếp hoặc trùng nhau. Ví dụ: 123456, 111111…",
  SM_OTP_NOTE_THEM_TOUCH: "Lưu ý: Tất cả vân tay đã đăng ký trong thiết bị đều có thể xác thực",
  SM_OTP_PASS_DANG_NHAP: "Mật khẩu",
  SM_OTP_PHIEN_GIAO_DICH: "Phiên giao dịch",
  SM_OTP_QUEN_MA_PIN: "Khôi phục mã PIN",
  SM_OTP_QUEN_PIN_COUNT_DOWN: "Phương thức xác thực của Quý khách đang tạm khóa. Vui lòng thực hiện sau thời gian tạm khóa",
  SM_OTP_QUET_QR_XAC_THUC_GIAO_DICH: "Quét mã QR trên màn hình xác thực giao dịch",
  SM_OTP_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  SM_OTP_SETTING_SM_OTP: "Cài đặt Smart OTP",
  SM_OTP_SO_TIEN: "Số tiền",
  SM_OTP_TAO_MA_PIN: "Tạo mã PIN",
  SM_OTP_TERM:
    "<p style='text-align: justify;background: transparent;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'><strong>Điều 1. Phạm vi áp dụng</strong></p>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;text-indent: 0.2in;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'>Điều khoản và điều kiện áp dụng đối với khách hàng cá nhân và doanh nghiệp sử dụng các dịch vụ Ngân hàng điện tử của PVcomBank và xác thực giao dịch bằng phương thức Smart OTP.</p>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'><strong>Điều 2. Giải thích từ ngữ</strong></p>\r\n\r\n\r\n<ol>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Ngân hàng: Là Ngân hàng Thương mại cổ phần Đại Chúng Việt Nam, gọi tắt là PVcomBank.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PVcomBank Smart OTP: Là ứng dụng được phát triển bởi PVcomBank, cài đặt trên điện thoại di động của khách hàng và được sử dụng để xác thực giao dịch trên các kênh Ngân hàng điện tử của PVcomBank.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>OTP (One Time Password): Là mật khẩu sử dụng một lần, do hệ thống Smart OTP sinh ra, sử dụng để xác thực giao dịch trực tuyến của khách hàng. OTP được ứng dụng PVcomBank Smart OTP sinh ra ngẫu nhiên khi phát sinh giao dịch, có hiệu lực trong khoảng thời gian xác định theo quy định của Ngân hàng trong từng thời kỳ.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PIN: Là mã số do khách hàng cài đặt, được sử dụng để xác nhận quyền truy cập, sử dụng, thay đổi và tạo mã xác thực trong ứng dụng Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Thời gian xử lý giao dịch: thời gian xử lý các giao dịch điện tử do Khách hàng chủ động gửi yêu cầu:</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Khách hàng được thực hiện giao dịch 24 giờ trong ngày và 07 ngày trong tuần.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PvcomBank sẽ gửi thông báo ngay cho Khách hàng ngay khi có yêu cầu từ phía khách hàng. Trên thông báo giao dịch cuối kỳ, đối với những giao dịch nhận được sau thời gian chạy xử lý cuối ngày sẽ được hệ thống PvcomBank coi là giao dịch của ngày tiếp theo.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Đối với các giao dịch trả lãi tự động, thu nợ tự động… PvcomBank sẽ gửi thông báo biến động tài khoản vào sáng của ngày kế tiếp.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n</ol>\r\n\r\n\r\n<p style='margin-bottom: 0.04in; line-height: 100%; text-align: justify; background: transparent; margin-top: 0.04in;'><strong>Điều 3. Quyền của khách hàng</strong></p>\r\n\r\n\r\n<ol>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Cài đặt, đăng ký ứng dụng PVcomBank Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Thiết lập và thay đổi phương thức bảo vệ Smart OTP qua mã PIN, vân tay hoặc nhận diện khuôn mặt.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Chuyển đổi thiết bị cài đặt PVcomBank Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Hủy đăng ký xác thực bằng Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Yêu cầu Ngân hàng cấp lại mã PIN khi quên hoặc xóa ứng dụng Smart OTP khi chưa hủy đăng ký phương thức xác thực này.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n</ol>\r\n\r\n\r\n<p style='margin-bottom: 0.04in; line-height: 100%; text-align: justify; background: transparent; margin-top: 0.04in;'><strong>Điều 4. Trách nhiệm của khách hàng</strong></p>\r\n\r\n\r\n<ol>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Bảo đảm thiết bị cài đặt Smart OTP an toàn. Không được sử dụng các thiết bị đã can thiệp vào quyền quản trị thiết bị (admin) thông qua các biện pháp như jailbreak (trên hệ điều hành iOS) hoặc root (trên hệ điều hành Android); thiết bị cài đặt các ứng dụng bên thứ ba không được phát hành trên các kho ứng dụng chính thống của các hệ điều hành iOS (App Store), Android (Google Play).</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Không tiết lộ phương thức bảo vệ Smart OTP (mã PIN, vân tay, nhận diện khuôn mặt) và mã xác thực OTP cho bất kỳ người nào.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Thông báo ngay cho Ngân hàng thông qua hotline hoặc các chi nhánh, phòng giao dịch khi phát hiện hoặc nghi ngờ các thông tin tên đăng nhập, mật khẩu, phương thức bảo vệ Smart OTP (mã PIN, vân tay, nhận diện khuôn mặt), mã OTP bị lộ.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Chịu trách nhiệm hoàn toàn về việc bảo quản và sử dụng tên đăng nhập, mật khẩu, các thông tin liên quan đến Smart OTP kể từ khi được Ngân hàng cung cấp. Khách hàng phải thông báo ngay cho PVcomBank để kịp thời xử lý khi tên truy cập, mật khẩu hoặc các yếu tố định danh khác bị mất, đánh cắp, bị lội hoặc nghi bị đánh cắp, đồng thời khách hàng phải chịu trách nhiệm về những thiệt hại, tổn thất và rủi ro khác trước khi thông báo cho PVcomBank.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Tuân thủ đúng hướng dẫn về bảo mật được Ngân hàng ban hành, sửa đổi theo từng thời kỳ khi sử dụng các dịch vụ Ngân hàng điện tử của PvcomBank</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Khách hàng thừa nhận rằng bất cứ hành động truy cập nào vào dịch vụ Ngân hàng điện tử bằng tên truy cập với đúng mật khẩu truy cập và/ hoặc các yếu tố định danh khác do Pvcombank cấp cho khách hàng đều được coi là Khách hàng truy cập.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Tin nhắn được coi là đã gửi cho khách hàng nếu việc gửi tin này đã được thực hiện bởi nhà cung cấp dịch vụ bất kể khách hàng có thực sự nhận được tin nhắn hay không.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Khách hàng chịu trách nhiệm áp dụng mọi biện pháp hợp lý nhằm đảm bảo an toàn, thiết bị kết nối, phầm mềm hệ thống truy cập, phần mềm ứng dụng… do khách hàng sử dụng nhằm kiểm soát, phòng ngừa và ngăn chặn việc sử dụng hoặc truy cập trái phép dịch vụ.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n</ol>\r\n\r\n\r\n<p style='margin-bottom: 0.04in; line-height: 100%; text-align: justify; background: transparent; margin-top: 0.04in;'><strong>Điều 5. Quyền của Ngân hàng</strong></p>\r\n\r\n\r\n<ol>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Yêu cầu KH cung cấp thông tin cá nhân khi thực hiện các yêu cầu liên quan đến dịch vụ PVcomBank Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Có quyền ngừng cung cấp hoặc chấm dứt dịch vụ mà không cần có sự đồng ý của khách hàng trong trường hợp vi phạm các quy định tại Điều khoản và điều kiện sử dụng dịch vụ PVcomBank Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Khi khách hàng khiếu nại dịch vụ qua hotline hoặc chi nhánh, phòng giao dịch, Ngân hàng có quyền ghi âm cuộc gọi, lưu trữ thông tin khách hàng để xử lý các vấn đề phát sinh nếu có.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Phí dich vụ được PvcomBank công bố từng thời kỳ.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Khách hàng uỷ quyền cho PVcomBank được quyền tự động trích nợ phí sử dụng dịch vụ trên bất kỳ tài khoản nào mở tại PVcomBank để thanh toán. Phí dịch vụ được thu trước hoặc sau hoặc ngay khi phát sinh giao dịch tuỳ vào từng loại hình dịch vụ PVcomBank cung cấp.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PvcomBank được quyền thay đổi nội dung các điều kiện, điều khoản này bằng cách gửi thông báo thay đổi cho khách hàng.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n</ol>\r\n\r\n\r\n<p style='margin-bottom: 0.04in; line-height: 100%; text-align: justify; background: transparent; margin-top: 0.04in;'><strong>Điều 6. Trách nhiệm của Ngân hàng</strong></p>\r\n\r\n\r\n<ol>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Cung cấp dịch vụ, đảm bảo an toàn thông tin giao dịch, thông tin xác thực giao dịch của khách hàng.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Hướng dẫn, hỗ trợ khách hàng sử dụng dịch vụ, khiếu nại liên quan nếu có.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PVcomBank không chịu trách nhiệm đối với những thiệt hại, tổn thất do Khách hàng phát sinh trong quá trình sử dụng dịch vụ, trừ phi những thiệt hại, tổn thất này là do lỗi cố ý của PvcomBank.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PvcomBank không chịu trách nhiệm đối với những thiệt hại trực tiếp hoặc gián tiếp mà Khách hàng phải chịu phát sinh từ/ hoặc do:</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Việc khách hàng để mất hoặc lộ thông tin truy cập, mật khẩu hoặc các yếu tố định danh khác PvcomBank cung cấp.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Việc tin nhắn được thực hiện bởi 1 bên thứ ba mà bên thứ ba đã thực hiện việc kết nối thiết bị của họ tới số điện thoại mà Khách hàng đã đăng ký hoặc</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Sự gián đoạn của hệ thống trong quá trình cung cấp dịch vụ do các nguyên nhân ngoài khả năng kiểm soát hợp lý của PvcomBank, bao gồm nhưng không giới hạn như dịch vụ đang nâng cấp, lỗi đường truyền của nhà cung cấp dịch vụ Internet, hệ thống của bên thứ ba tham gia, các gián đoạn bất khả kháng…</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Tất cả các chỉ dẫn thanh toán do Khách hàng gửi yêu cầu được coi là không huỷ ngang.</p>\r\n\r\n\r\n</li>\r\n\r\n\r\n</ol>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;text-indent: 0.2in;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'>Trường hợp cần thêm thông tin về dịch vụ, Quý khách vui lòng liên hệ:</p>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;text-indent: 0.2in;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'>Trung tâm Chăm sóc khách hàng (PVcomBank Call Center). </p>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;text-indent: 0.2in;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'>Hotline: 1900555592.</p>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;text-indent: 0.2in;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'>Hoặc email <a>pvb@pvcombank.com.vn</a>.</p>",
  SM_OTP_THAY_DOI_THIET_BI_SM_OTP: "Chuyển thiết bị kích hoạt Smart OTP",
  SM_OTP_THEM_FACE_ID: "Cài đặt xác thực khuôn mặt",
  SM_OTP_THEM_VAN_TAY: "Cài đặt xác thực vân tay",
  SM_OTP_THONG_BAO_ACC_DA_DK_SMART_TREN_DEVICE_KHAC:
    "Quý khách đã đăng ký Smart OTP trên thiết bị khác. Nếu quý khách muốn đăng ký Smart OTP trên thiết bị này, vui lòng đăng nhập trên thiết bị đã đăng ký Smart OTP và thực hiện Chuyển thiết bị đăng ký Smart OTP. Hoặc đến chi nhánh gần nhất để được tư vấn.",
  SM_OTP_THONG_BAO_CHUA_CAI_DAT_PIN_SMART: "Quý khách vui lòng hoàn thành kích hoạt Smart OTP",
  SM_OTP_THONG_BAO_CHUYEN_THIET_BI_THANH_CONG:
    "Chuyển thiết bị đăng ký Smart OTP thành công. Từ thời điểm hiện tại thiết bị này hết hiệu lực xác thực giao dịch.{new_line}Vui lòng đăng nhập PV-Moblie Banking và thực hiện kích hoạt Smart OTP trên thiết bị mới để hoàn tất quá trình chuyển đổi.",
  SM_OTP_THONG_BAO_DANG_KY_THANH_CONG_NOTE:
    "Quý khách đã đăng ký thành công Smart OTP trên thiết bị này.Quý khách tuyệt đối không cung cấp tên đăng nhập, mật khẩu, mã PIN bảo vệ Smart OTP và mã OTP cho người khác hoặc các trang web không phải của PVcomBank hoặc không liên kết với PVcomBank.",
  SM_OTP_THONG_BAO_DANG_NHAP_KHOI_PHUC_PIN: "Quý khách vui lòng Đăng nhập để Khôi phục PIN",
  SM_OTP_THONG_BAO_DA_KICH_HOAT_THIET_BI_KHAC:
    "Tài khoản của Quý khách đã cài đặt trên thiết bị khác hoặc xóa ứng dụng PV- Mobile Banking hoặc đã cài đặt lại điện thoại.",
  SM_OTP_THONG_BAO_DOI_MA_PIN_THANH_CONG:
    "Mã PIN bảo vệ Smart OTP đã được thay đổi thành công. Quý khách vui lòng không cung cấp mã PIN cho bất kỳ ai.",
  SM_OTP_THONG_BAO_HOI_CAI_DAT_FACE_ID: "Quý khách có muốn cài đặt thêm Face ID cho Smart OTP?",
  SM_OTP_THONG_BAO_HOI_CAI_DAT_VAN_TAY: "Quý khách có muốn cài đặt thêm vân tay cho Smart OTP?",
  SM_OTP_THONG_BAO_HOI_DANG_KY_SMART:
    "Smart OTP là Phương thức bảo mật cao nhất dành cho khách hàng được NHNN khuyến cáo sử dụng. Từ hôm nay, Quý khách có thể chuyển đổi sang phương thức xác thực mới Smart OTP. Sau ngày 31/12/2020 nếu chưa chuyển đổi, Quý khách hàng chỉ có thể giao dịch với hạn mức tối đa 100 triệu đồng/ngày trên Internet Banking và Mobile Banking.",
  SM_OTP_THONG_BAO_HOI_HUY_DANG_KY: "Quý khách chắc chắn muốn Hủy đăng ký Smart OTP?",
  SM_OTP_THONG_BAO_HOI_HUY_KICH_HOAT: "Quý khách có chắc chắn muốn Hủy kích hoạt Smart OTP?",
  SM_OTP_THONG_BAO_HOI_HUY_LAY_MA: "Quý khách có chắc chắn muốn hủy lấy mã OTP",
  SM_OTP_THONG_BAO_HUONG_DAN_KICH_HOAT_LAI:
    "<ol>\r\n    <li style='line-height: 1.5;'>Nếu muốn chuyển Smart OTP từ thiết bị cũ sang thiết bị mới, vui lòng thực hiện:<br>Bước 1:&nbsp;Đăng nhập lại ứng dụng PV-Mobile Banking trên thiết bị cũ.<br>Bước 2: Tại LeftMenu chọn&nbsp;<strong>Chuyển đổi thiết bị kích hoạt Smart OTP</strong> -&gt; Đồng ý chuyển đổi.<br>Bước 3:&nbsp;Đăng nhập app PV-Mobile Banking trên thiết bị mới và thực hiện kích hoạt Smart OTP.</li>\r\n    <li style='line-height: 1.5;'>Trường hợp Quý khách đã xóa ứng dụng hoặc không dùng thiết bị cũ, vui lòng thực hiện:<br>Bước 1:&nbsp;Dùng số điện thoại đã đăng ký với ngân hàng thực hiện soạn tin nhắn&nbsp;<span style='color: #ff0000;'>PVB HUY SMARTOTP</span> gửi&nbsp;<span style='color: #ff0000;'>8049</span>/<span style='color: #ff0000;'>6089</span>.<br>Bước 2: Sau khi nhận được tin nhắn thông báo hủy thành công, đăng nhập lại app và thực hiện đăng ký lại.</li>\r\n</ol>",
  SM_OTP_THONG_BAO_KHONG_THE_DANG_KY: "Quý khách không thể đăng ký Smart OTP trên thiết bị này do:",
  SM_OTP_THONG_BAO_KICH_HOAT_LAI_THANH_CONG_NOTE:
    "Quý khách đã kích hoạt thành công Smart OTP. Để đảm bảo an toàn cho Quý khách PVcomBank chuyển hạn mức Quý khách về 100 triệu/ngày. Trường hợp Quý khách mong muốn nâng hạn mức vui lòng liên hệ 1900555592",
  SM_OTP_THONG_BAO_LAY_LAI_PASS_THANH_CONG_NOTE:
    "Để đảm bảo an toàn cho Quý khách PVcomBank chuyển hạn mức Quý khách về 100 triệu/ngày. Trường hợp Quý khách mong muốn nâng hạn mức vui lòng liên hệ 1900555592. Quý khách khôi phục mã PIN thành công trên thiết bị này. Quý khách tuyệt đối không cung cấp tên đăng nhập, mật khẩu, mã PIN bảo vệ Smart OTP và mã OTP cho người khác hoặc các trang web không phải của PVcomBank hoặc không liên kết với PVcomBank",
  SM_OTP_THONG_BAO_LOI_CHALLENGE_VALUE: "Đã có lỗi xảy ra, Quý khách vui lòng thực hiện lại.",
  SM_OTP_THONG_BAO_QUEN_PIN: "Quý khách vui lòng đến chi nhánh gần nhất để lấy lại mã PIN bảo vệ Smart OTP.",
  SM_OTP_THONG_BAO_SMART_OTP: "Smart OTP",
  SM_OTP_THONG_BAO_THEM_FACE_THANH_CONG: "Cài đặt xác thực bằng Face ID thành công",
  SM_OTP_THONG_BAO_THEM_TOUCH_THANH_CONG: "Cài đặt xác thực bằng vân tay thành công.",
  SM_OTP_THONG_BAO_THIET_BI_DA_DK_SMART_ACC_KHAC:
    "Thiết bị đang đăng ký Smart OTP cho một tài khoản khác. Nếu tiếp tục thiết bị sẽ xóa cài đặt Smart OTP cũ. Quý khách có muốn tiếp tục đăng ký Smart OTP cho tài khoản này?",
  SM_OTP_THONG_BAO_XOA_FACE_THANH_CONG: "Xóa xác thực bằng Face ID thành công",
  SM_OTP_THONG_BAO_XOA_TOUCH_THANH_CONG: "Xóa xác thực bằng vân tay thành công.",
  SM_OTP_THONG_BAO_YEU_CAU_HOAN_THANH_KICH_HOAT_SMART:
    "Quý khách đã đăng ký Smart OTP. Vui lòng thực hiện bước kích hoạt để hoàn tất quy trình.",
  SM_OTP_THONG_TIN_GIAO_DICH: "Thông tin giao dịch",
  SM_OTP_TITLE_CHUYEN_THIET_BI: "Chuyển đổi thiết bị",
  SM_OTP_TITLE_THONG_BAO_DANG_KY: "Đăng ký dịch vụ Smart OTP",
  SM_OTP_TK_CHUA_DK_PHUONG_THUC_XAC_THUC: "Tài khoản của Quý khách chưa đăng kí phương thức xác thực",
  SM_OTP_USER: "Tên đăng nhập Internet Banking",
  SM_OTP_VUI_LONG_NHAP_MA_PIN: "Quý khách vui lòng nhập mã PIN",
  SM_OTP_XAC_NHAN: "Xác nhận",
  SM_OTP_XAC_THUC: "Xác thực OTP",
  SM_OTP_XAC_THUC_THANH_CONG: "Xác thực thành công",
  SM_OTP_XOA_FACE_ID: "Xóa xác thực bằng khuôn mặt",
  SM_OTP_XOA_VAN_TAY: "Xóa vân tay",
  SM_OTP_NOTE_XAC_THUC_GIAO_DICH: "Nhập mã Pin để xác thực giao dịch",
  SM_OTP_NOTE_LAY_MA_XAC_THUC: "Nhập mã Pin để lấy mã OTP",
  SM_OTP_NOTE_XAC_THUC_GIAO_DICH_VAN_TAY: "Nhập mã Pin hoặc xác thực qua Vân tay để xác thực giao dịch",
  SM_OTP_NOTE_LAY_MA_XAC_THUC_VAN_TAY: "Nhập mã Pin hoặc xác thực qua Vân tay để lấy mã OTP",
  SM_OTP_NOTE_XAC_THUC_GIAO_DICH_FACEID: "Nhập mã Pin hoặc xác thực qua FaceID để xác thực giao dịch",
  SM_OTP_NOTE_LAY_MA_XAC_THUC_FACEID: "Nhập mã Pin hoặc xác thực qua FaceID để lấy mã OTP",
  SM_OTP_MA_OTP_TIEU_DE: "Mã OTP để xác nhận",
  SM_OTP_MA_OTP_TIME_COUNT_DOWN: "OTP sẽ hết hiệu lực sau",
  SM_OTP_MA_OTP_SMART_TIEU_DE: "Mã OTP sẽ hết hiệu lực sau",
  SM_OTP_THONG_BAO_TRANS_LIT_SMART_NOT_REGIS: "Quý khách thay đổi hạn mức vui lòng đăng ký phương thức xác thực Smart OTP",
  SM_OTP_THONG_BAO_TRANS_LIT_SMART_DEACTIVE: "Quý khách thay đổi hạn mức vui lòng kích hoạt phương thức xác thực Smart OTP",

  STEP_KHOI_TAO: "Khởi tạo",
  STEP_XAC_NHAN: "Xác nhận",
  STEP_XAC_THUC: "Xác thực",
  STEP_KET_QUA: "Kết quả",

  TOPUP_CHUA_DANG_KY_GIAO_DICH_NAO: "Quý khách chưa có số điện thoại đăng ký nạp tiền tự động",
  TOPUP_CHUC_NANG_NAP_TIEN: "Chức năng nạp tiền",
  TOPUP_CHON_DICH_VU: "Chọn dịch vụ",
  TOPUP_CHON_NHA_CUNG_CAP: "Chọn nhà cung cấp",
  TOPUP_DAI_LY_VE_MAY_BAY: "Nạp tiền đại lý vé máy bay",
  TOPUP_DICH_VU: "Dịch vụ",
  TOPUP_DV_GIAO_THONG: "Dịch vụ giao thông",
  TOPUP_HO_TEN: "Họ tên",
  TOPUP_MA_NGUOI_DUNG: "Mã người dùng",
  TOPUP_MENH_GIA: "Mệnh giá",
  TOPUP_NAP_TIEN_DIEN_THOAI: "Nạp tiền điện thoại",
  TOPUP_NAP_TIEN_THANH_CONG: "Nạp tiền {so_tien} thành công cho số điện thoại {so_dien_thoai}",
  TOPUP_NHA_CUNG_CAP: "Nhà cung cấp",
  TOPUP_NOTE_GIAO_DICH_NHANH_THU_HUONG: "Để giao dịch nhanh hơn và không cần nhớ các thông tin?",
  TOPUP_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  TOPUP_SO_DIEN_THOAI: "Số điện thoại",
  TOPUP_SO_DIEN_THOAI_KHONG_HOP_LE: "Số điện thoại không chính xác. Quý khách vui lòng kiểm tra lại.",
  TOPUP_SO_DIEN_THOAI_TAI_KHOAN_DICH_VU: "Số điện thoại/ Tài khoản",
  TOPUP_SO_TIEN: "Số tiền",
  TOPUP_SO_TIEN_NAP: "Số tiền nạp",
  TOPUP_TAI_KHOAN_GAME: "Tài khoản Game",
  TOPUP_TAI_KHOAN_NGUON: "Tài khoản nguồn",
  TOPUP_TAI_KHOAN_THANH_TOAN: "Tài khoản thanh toán",
  TOPUP_THONG_BAO_TRANG_THAI_TAI_KHOAN:
    "Tài khoản thanh toán ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  TOPUP_VI_DIEN_TU: "Ví điện tử",
  TOPUP_VUI_LONG_CHON_DICH_VU: "Quý khách vui lòng chọn dịch vụ",
  TOPUP_VUI_LONG_CHON_MENH_GIA: "Quý khách vui lòng chọn mệnh giá",
  TOPUP_VUI_LONG_NHAP_SO_TIEN: "Quý khách vui lòng nhập số tiền",
  TOPUP_VUI_LONG_CHON_NHA_CUNG_CAP: "Quý khách vui lòng chọn nhà cung cấp",
  TOPUP_VUI_LONG_NHAP_SO_DIEN_THOAI: "Quý khách vui lòng nhập số điện thoại",
  TOPUP_VUI_LONG_NHAP_SO_DIEN_THOAI_SO_TAI_KHOAN: "Quý khách vui lòng nhập số điện thoại / tài khoản",

  TRANFER_247_KIEU: "Kiểu",
  TRANFER_BEN_CHIU_PHI: "Bên chịu phí",
  TRANFER_BEN_CHUYEN: "Bên chuyển",
  TRANFER_BEN_NHAN: "Bên nhận",
  TRANFER_CHI_NHANH: "Chi nhánh",
  TRANFER_CHI_NHANH_KHAC: "Chi nhánh khác",
  TRANFER_CHON_CHI_NHANH: "Chọn chi nhánh",
  TRANFER_CHON_CONG_TY_CHUNG_KHOAN: "Chọn công ty chứng khoán",
  TRANFER_CHON_NGAY_THANH_TOAN: "Chọn ngày thanh toán",
  TRANFER_CHON_NGAN_HANG: "Chọn ngân hàng",
  TRANFER_CHON_KHU_VUC: "Chọn khu vực",
  TRANFER_CHON_PHUONG_THUC_CHUYEN_TIEN: "Chọn phương thức chuyển tiền",
  TRANFER_CHON_PHUONG_THUC_THANH_TOAN: "Chọn phương thức thanh toán",
  TRANFER_CHON_TAI_KHOAN_NHAN: "Chọn tài khoản nhận",
  TRANFER_CHUNG_KHOAN: "Chứng khoán",
  TRANFER_CHUYEN_TIEN: "Chuyển tiền",
  TRANFER_DESCRIPTION_CHUYEN_TIEN: "Chuyen tien",
  TRANFER_DESCRIPTION_CHUYEN_TIEN_CHUNG_KHOAN: "Nop tien vao tai khoan",
  TRANFER_CHUYEN_TIEN_CHUNG_KHOAN: "Chuyển tiền chứng khoán",
  TRANFER_CHUYEN_TIEN_NGOAI_PVCOMBANK: "Chuyển tiền ngoài PVcomBank",
  TRANFER_CHUYEN_TIEN_NHANH_247: "Chuyển tiền nhanh NAPAS 24/7",
  TRANFER_CHUYEN_TIEN_TRONG_PVCOMBANK: "Chuyển tiền trong PVcomBank",
  TRANFER_CHU_TAI_KHOAN: "Tên chủ tài khoản",
  TRANFER_CONG_TY_CHUNG_KHOAN: "Công ty chứng khoán",
  TRANFER_CUNG_CHU_TAI_KHOAN: "Cùng chủ tài khoản",
  TRANFER_DICH_VU: "Dịch vụ",
  TRANFER_DICH_VU_CHUNG_KHOAN: "Dịch vụ chứng khoán",
  TRANFER_KHAC_CHU_TAI_KHOAN: "Khác chủ tài khoản",
  TRANFER_KHU_VUC: "Khu vực",
  TRANFER_NGAN_HANG: "Ngân hàng",
  TRANFER_NGOAI_PV: "Ngoài PVcomBank",
  TRANFER_NHANH_247: "Nhanh 24/7",
  TRANFER_NHA_CUNG_CAP: "Nhà cung cấp",
  TRANFER_NOI_DUNG: "Nội dung",
  TRANFER_NOI_DUNG_CHUYEN_TIEN: "Nội dung chuyển tiền",
  TRANFER_NOI_DUNG_CHUYEN_TIEN_KHONG_HOP_LE:
    "Vui lòng không được nhập Nội dung là Tiếng việt có dấu và ký tự đặc biệt ngoại trừ gạch ngang và dấu chấm",
  TRANFER_NOTE_CHUYEN_NHANH_THU_HUONG: "Để chuyển tiền nhanh hơn và không cần nhớ các thông tin?",
  TRANFER_QUY_KHACH_KHONG_CO_TAI_THANH_TOAN: "Quý khách không thực hiện được giao dịch này do quý khách chỉ có một tài khoản hợp lệ.",
  TRANFER_QUY_KHACH_MUON_HUY_GIAO_DICH: "Quý khách có chắc chắn muốn Hủy giao dịch?",
  TRANFER_SO_DIEN_THOAI: "Số điện thoại",
  TRANFER_SO_DIEN_THOAI_SO_TAI_KHOAN: "Số điện thoại / Số tài khoản",
  TRANFER_SO_TAI_KHOAN: "Số tài khoản",
  TRANFER_SO_TAI_KHOAN_CHUNG_KHOAN: "Số tài khoản chứng khoán",
  TRANFER_SO_TAI_KHOAN_HOAC_DIEN_THOAI_KHONG_DUNG: "Tài khoản nhận không tồn tại",
  TRANFER_SO_TAI_KHOAN_KHONG_DUNG: "Tài khoản nhận không tồn tại",
  TRANFER_SO_THE_ATM: "Số thẻ ATM",
  TRANFER_SO_TIEN: "Số tiền",
  TRANFER_SO_TIEN_CON_LAI: "Số tiền còn lại",
  TRANFER_SO_TIEN_KHONG_DUOC_VUOT_TREN_LAN: "Số tiền giao dịch không được vượt quá {amount} / 1 giao dịch",
  TRANFER_TAI_KHOAN: "Tài khoản",
  TRANFER_TAI_KHOAN_CHUYEN: "Tài khoản chuyển",
  TRANFER_TAI_KHOAN_NGUON: "Tài khoản nguồn",
  TRANFER_TAI_KHOAN_NHAN: "Tài khoản nhận",
  TRANFER_TAI_NGAN_HANG: "Ngân hàng",
  TRANFER_TEN_CHI_NHANH: "Tên chi nhánh",
  TRANFER_TEN_TAI_KHOAN: "Tên tài khoản",
  TRANFER_THANH_TOAN_CUOC_VIEN_THONG: "Thanh toán cước viễn thông",
  TRANFER_THONG_BAO_CHUA_NHAP_NOI_DUNG: "Quý khách vui lòng nhập nội dung giao dịch.",
  TRANFER_THONG_BAO_CHUYEN_KHOAN_THANH_CONG: "Chuyển {so_tien} thành công đến tài khoản {tai_khoan}",
  TRANFER_THONG_BAO_NHAP_THIEU_CONG_TY_CHUNG_KHOAN: "Quý khách vui lòng chọn công ty chứng khoán.",
  TRANFER_THONG_BAO_NHAP_THIEU_NGAN_HANG: "Quý khách vui lòng nhập ngân hàng nhận",
  TRANFER_THONG_BAO_NHAP_THIEU_SO_TIEN: "Quý khách vui lòng nhập số tiền giao dịch.",
  TRANFER_THONG_BAO_NHAP_THIEU_TAI_KHOAN: "Quý khách vui lòng nhập tài khoản nhận.",
  TRANFER_THONG_BAO_NHAP_THIEU_TAI_KHOAN_CHUNG_KHOAN: "Quý khách vui lòng nhập số tài khoản chứng khoán.",
  TRANFER_THONG_BAO_NOI_DUNG_KHONG_DE_TRONG: "Nội dung không được để trống.",
  TRANFER_THONG_BAO_TRANG_THAI_TAI_KHOAN_CHUYEN:
    "Tài khoản chuyển ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  TRANFER_THONG_BAO_TRANG_THAI_TAI_KHOAN_DICH:
    "Tài khoản nhận ở trạng thái không hoạt động. Quý khách vui lòng liên hệ CN/PGD gần nhất để được hỗ trợ.",
  TRANFER_TIM_CHI_NHANH: "Tìm chi nhánh",
  TRANFER_TIM_KHU_VUC: "Tìm khu vực",
  TRANFER_TIM_NGAN_HANG: "Tìm ngân hàng",
  TRANFER_TRONG_PV: "Trong PVcomBank",
  TRANFER_VUI_LONG_CHON_CHI_NHANH: "Quý khách vui lòng chọn chi nhánh.",
  TRANFER_VUI_LONG_CHON_CHI_NHANH_CONG_TY_CHUNG_KHOAN: "Quý khách vui lòng chọn chi nhánh công ty chứng khoán",
  TRANFER_VUI_LONG_CHON_KHU_VUC: "Quý khách vui lòng chọn khu vực.",
  TRANFER_VUI_LONG_CHON_NGAN_HANG: "Quý khách vui lòng chọn ngân hàng",
  TRANFER_VUI_LONG_KHONG_NHAP_TAI_KHOAN_CO_DAU_VA_KI_TU: "Vui lòng không được nhập Tài khoản nhận là Tiếng Việt có dấu và ký tự đặc biệt",
  TRANFER_VUI_LONG_NHAP_CHI_NHANH_KHAC: "Quý khách vui lòng chọn chi nhánh khác.",
  TRANFER_VUI_LONG_NHAP_DAY_DU_THONG_TIN: "Quý khách vui lòng nhập đầy đủ thông tin",
  TRANFER_VUI_LONG_NHAP_DU_THONG_TIN: "Quý khách vui lòng nhập đủ thông tin.",
  TRANFER_VUI_LONG_NHAP_SO_TAI_KHOAN_KHONG_CO_DAU: "Vui lòng không được nhập số tài khoản là Tiếng Việt có dấu và ký tự đặc biệt",
  TRANFER_VUI_LONG_NHAP_SO_TAI_KHOAN_NHAN: "Quý khách vui lòng nhập số tài khoản nhận",
  TRANFER_VUI_LONG_NHAP_SO_THE_ATM: "Quý khách vui lòng nhập số thẻ ATM",
  TRANFER_VUI_LONG_NHAP_SO_TIEN: "Quý khách vui lòng nhập số tiền giao dịch",
  TRANFER_VUI_LONG_NHAP_TEN_CHU_TAI_KHOAN_CONG_TY_CHUNG_KHOAN: "Quý khách vui lòng nhập họ tên chủ tài khoản chứng khoán",
  TRANFER_VUI_LONG_NHAP_TEN_TAI_KHOAN: "Quý khách vui lòng nhập tên tài khoản",
  TRANFER_VUI_LONG_NHAP_TEN_TAI_KHOAN_KHONG_CO_DAU:
    "Vui lòng không được nhập tên tài khoản là Tiếng Việt có dấu và ký tự đặc biệt ngoại trừ dấu gạch ngang và dấu chấm",
  TRANFER_CHUYEN_HAN_MUC_GD: "Đổi gói hạn mức giao dịch",
  TRANFER_GOI_HAN_MUC_HIEN_TAI: "Gói hạn mức hiện tại",
  TRANFER_CHON_GOI_HAN_MUC_MOI: "Chọn gói hạn mức mới",
  TRANFER_KHUYEN_CAO: "Khuyến cáo",
  TRANFER_NOTE_CHANGE_TRANS_LIMIT:
    "Quý khách chỉ tăng hạn mức trong trường hợp thực sự cần thiết. Để giảm thiểu rủi ro, trường hợp không sử dụng hết Gói hạn mức cao, Quý khách vui lòng chuyển về các Gói hạn mức thấp hơn.",
  TRANFER_DIEU_KHOAN_BAO_MAT: "Điều khoản và điều kiện",
  TRANFER_NOI_DUNG_DIEU_KHOAN_BAO_MAT: "",
  TRANFER_TOI_DONG_Y: "Tôi đồng ý",
  TRANFER_CHUYEN_HAN_MUC_THANH_CONG:
    "Quý khách thay đổi hạn mức thành công, hạn mức mới của quý khách là {limit}. Quý khách cần hỗ trợ vui lòng liên hệ CN/PGD hoặc Hotline {hotline}.",
  TRANFER_CHUYEN_TIEN_NOI_BO: "Chuyển tiền nội bộ",
  TRANFER_STK_THU_HUONG: "Số tài khoản thụ hưởng",
  TRANFER_TEN_NGUOI_THU_HUONG: "Tên người thụ hưởng",
  TRANFER_THONG_BAO_TRUNG_TK_NGUON: "Tài khoản nhận và chuyển đang bị trùng",
  TRANFER_LOI_TAI_KHOAN: "Tài khoản không đúng định dạng",
  TRANFER_CHUYEN_TIEN_TU_THIEN: "Chuyển tiền từ thiện",
  TRANFER_CHARITY_DON_VI_TIEP_NHAN: "Đơn vị tiếp nhận",
  TRANFER_CHARITY_TEN_NGUOI_UNG_HO: "Họ tên người ủng hộ",
  TRANFER_CHARITY_DIA_CHI: "Địa chỉ người ủng hộ",
  TRANFER_CHARITY_SO_DIEN_THOAI: "Số điện thoại người ủng hộ",
  TRANFER_CHARITY_HOAN_CANH_UNG_HO: "Nội dung ủng hộ",

  TRANSACTION_DA_GUI_YEU_CAU: "Đã gửi yêu cầu",
  TRANSACTION_DA_TRA_LOI_YEU_CAU: "Đã trả lời yêu cầu",
  TRANSACTION_EMAIL: "Email (không bắt buộc)",
  TRANSACTION_GUI_YEU_CAU: "Gửi yêu cầu",
  TRANSACTION_HUY: "Hủy",
  TRANSACTION_ID_TRA_SOAT: "ID tra soát",
  TRANSACTION_KET_QUA_TRA_SOAT: "Kết quả tra soát",
  TRANSACTION_KET_QUA_XU_LY: "Kết quả xử lý",
  TRANSACTION_KET_THUC: "Kết thúc",
  TRANSACTION_KHONG_CO_YEU_CAU_TRA_SOAT: "Không có yêu cầu tra soát.",
  TRANSACTION_LICH_SU_TRA_SOAT: "Lịch sử tra soát",
  TRANSACTION_LY_DO_TRA_SOAT: "Lý do tra soát",
  TRANSACTION_MO_TA: "Mô tả",
  TRANSACTION_NGAY_YEU_CAU: "Ngày yêu cầu",
  TRANSACTION_NOI_DUNG: "Nội dung",
  TRANSACTION_NOI_DUNG_TRA_LOI: "Nội dung trả lời",
  TRANSACTION_SO_BUT_TOAN: "Số bút toán",
  TRANSACTION_SO_DIEN_THOAI: "Số điện thoại",
  TRANSACTION_SO_DIEN_THOAI_KHONG_HOP_LE: "Số điện thoại không chính xác. Quý khách vui lòng kiểm tra lại.",
  TRANSACTION_SO_TIEN: "Số tiền",
  TRANSACTION_THOI_GIAN_GIAO_DICH: "Thời gian giao dịch",
  TRANSACTION_THONG_BAO_EMAIL_KHONG_HOP_LE: "Email không đúng định dạng. Quý khách vui lòng kiểm tra lại.",
  TRANSACTION_THONG_BAO_HOI_HUY_TRA_SOAT: "Quý khách muốn hủy tạo yêu cầu tra soát giao dịch?",
  TRANSACTION_THONG_BAO_KHONG_CO_LY_DO: "Không có lý do tra soát",
  TRANSACTION_TIM_KIEM: "Tìm kiếm",
  TRANSACTION_TRANG_THAI: "Trạng thái",
  TRANSACTION_TRA_SOAT_GIAO_DICH: "Tra soát giao dịch",
  TRANSACTION_TRA_SOAT_GIAO_DICH_KHAC: "Tra soát giao dịch khác",
  TRANSACTION_TRUY_VAN: "Truy vấn",
  TRANSACTION_VUI_LONG_NHAP_LY_DO_TRA_SOAT: "Quý khách vui lòng nhập lý do tra soát",
  TRANSACTION_VUI_LONG_NHAP_SO_DIEN_THOAI: "Quý khách vui lòng nhập số điện thoại",
  TRANSACTION_YEU_CAU_TRA_SOAT_THANH_CONG:
    "Yêu cầu tra soát giao dịch của Quý khách đã được ghi nhận. PVcomBank sẽ phản hồi kết quả trong thời gian sớm nhất. Trân trọng cảm ơn!",

  dieu_khoan_su_dung:
    "<p align='center'><span style='color: #0070c0;'><strong>ĐIỀU KHOẢN</strong></span></span><span style='color: #0070c0;'><strong> DỊCH VỤ NGÂN HÀNG ĐIỆN TỬ</strong></span></span></p>\r\n<p align='justify'><br></p>\r\n<p align='justify'><span style=' font-weight: 700;'>Điều 1. Phạm vi cung cấp dịch vụ</span></p>\r\n<p align='justify'>1. PVcomBank (NH) cung cấp cho khách hàng (KH) các dịch vụ Ngân hàng điện tử (NHĐT) bao gồm: Dịch vụ Ngân hàng trực tuyến (Online Banking/Mobile Banking), dịch vụ Ngân hàng di động (SMS Banking), dịch vụ Thanh toán trực tuyến (eComerce) và các dịch vụ khác mà PVcomBank cung cấp trong từng thời kỳ (sau đây gọi tắt là “Dịch vụ”).</span><br></p>\r\n<p align='justify'>2. Tuỳ từng thời kỳ, NH có quyền thay đổi, bổ sung các chức năng của từng gói dịch vụ và sẽ thông báo cho KH thông qua website www.pvcombank.com.vn.</span></p>\r\n<p align='justify'><br></p>\r\n<p align='justify'><span style=' font-weight: 700;'>Điều 2. Quyền và nghĩa vụ của khách hàng</span><br></p>\r\n<p align='justify'>1. Sử dụng các dịch vụ NHĐT do NH cung cấp đúng mục đích và hợp pháp; đảm bảo không sử dụng các dịch vụ/sản phẩm đã đăng ký tại Ngân hàng để phục vụ cho các hoạt động kinh doanh tiền ảo, đánh bạc trực tuyến và các mục đích bất hợp pháp khác theo quy định của pháp luật.</span><br></p>\r\n<p align='justify'>2. Tuân thủ các quy định của NH về đăng ký, sử dụng dịch vụ và các hướng dẫn khác.</span><br></p>\r\n<p align='justify'>3. KH phải thực hiện đúng Hướng dẫn sử dụng dịch vụ do NH ban hành và đăng tải trên website của NH. Trường hợp có sự thay đổi về HDSD dịch vụ, KH thừa nhận và đồng ý việc NH sẽ đăng tải lên website mà không cần thêm bất kỳ sự thông báo nào khác từ NH.</span><br></p>\r\n<p align='justify'>4. KH sử dụng dịch vụ theo hạn mức đăng ký với NH (nếu có) hoặc theo quy định của NH trong từng thời kỳ.</span><br></p>\r\n<p align='justify'>5. Bảo mật các thông tin về tên truy cập,mật khẩu truy cập và thiết bị bảo mật.</span><br></p>\r\n<p align='justify'>6. Hoàn toàn chịu mọi trách nhiệm và thiệt hại có thể xảy ra do việc sử dụng trái phép của người không có thẩm quyền truy cập.</span><br></p>\r\n<p align='justify'>7. KH tự đảm bảo quá trình thực hiện giao dịch chính xác và đầy đủ.</span><br></p>\r\n<p align='justify'>8. Thông báo kịp thời cho NH trong trường hợp tên truy cập, mật khẩu truy cập bị lộ hoặc thiết bị bảo mật bị thất lạc.</span><br></p>\r\n<p align='justify'>9. Thông báo ngay cho NH bất kỳ sự thay đổi gì liên quan đến địa chỉ thư điện tử, số điện thoại di động đã đăng ký của KH. Trừ khi nhận được thông báo thay đổi của KH, NH sẽ tiếp tục cung cấp dịch vụ qua địa chỉ email hoặc số điện thoại di động mà KH đã đăng ký.</span><br></p>\r\n<p align='justify'>10. Trường hợp KH sử dụng dịch vụ để thanh toán cho các Nhà cung ứng dịch vụ (NCƯ), KH chịu mọi trách nhiệm đối với giao dịch cung cấp không chính xác mã dịch vụ, mã thanh toán và các thông tin khác; tự giải quyết các tranh chấp liên quan đến việc cung ứng dịch vụ của NCƯ về số tiền thanh toán, mã thanh toán, thời điểm thanh toán; chịu trách nhiệm về các giao dịch được gửi nhiều lần và các vấn đề khác giữa KH và NCƯ trong mọi thời điểm.</span><br></p>\r\n<p align='justify'>11. Có quyền chấm dứt việc sử dụng các dịch vụ do NH cung cấp bất cứ lúc nào sau khi thông báo bằng văn bản cho NH về việc đóng dịch vụ.</span><br></p>\r\n<p align='justify'>12. Tuân thủ quy định về việc nộp phí dịch vụ của NH.</span><br></p>\r\n<p align='justify'>13. Hoàn toàn chịu mọi trách nhiệm liên quan tới việc sử dụng Số điện thoại di động làm thông tin để đăng ký mở hồ sơ khách hàng, thay đổi thông tin hồ sơ khách hàng và đăng ký sử dụng các dịch vụ tại Ngân hàng.</span><br></p>\r\n<p align='justify'>14. Thực hiện ngay việc đăng ký thay đổi số điện thoại di động phục vụ cho việc sử dụng các dịch vụ/sản phẩm tại Ngân hàng trong trường hợp có bất kỳ sự thay đổi có liên quan đến số điện thoại di động đã đăng ký.</span><br></p>\r\n<p align='justify'><br></p>\r\n<p align='justify'><span style=' font-weight: 700;'>Điều 3. Quyền và nghĩa vụ của NH</span></p>\r\n<p align='justify'>1. Cung cấp dịch vụ và thực hiện các giao dịch điện tử của KH khi nhận đúng các thông tin khai báo như tên truy cập, mật khẩu truy cập, mật khẩu của thiết bị bảo mật.</span><br></p>\r\n<p align='justify'>2. Đảm bảo hệ thống dịch vụ vận hành ổn định, an toàn và tuân thủ các quy dịnh của pháp luật liên quan đến việc cung ứng dịch vụ.</span><br></p>\r\n<p align='justify'>3. NH không chịu trách nhiệm đối với những thiệt hại, rủi ro có thể xảy ra trong các trường hợp sau:</span><br></p>\r\n<p align='justify'>a. KH để lộ tên truy cập, mật khẩu truy cập, mã xác thực OTP còn hiệu lực, thất lạc thiết bị bảo mật hoặc các thông tin khác dẫn đến việc người khác có thể dùng các thông tin đó để sử dụng dịch vụ trái phép; Người sử dụng dịch vụ phải là KH, hoặc là người được KH ủy quyền hoặc cho phép sử dụng tên truy cập, mật khẩu truy cập để sử dụng dịch vụ;</span><br></p>\r\n<p align='justify'>b. Ngân hàng được miễn trừ hoàn toàn mọi trách nhiệm đối với các thiệt hại phát sinh khi KH không đăng ký thay đổi Số điện thoại di động để thực hiện giao dịch tại Ngân hàng.</span><br></p>\r\n<p align='justify'>c. Các trường hợp bất khả kháng nằm ngoài sự kiểm soát của ngân hàng và KH theo quy định của pháp luật.</span><br></p>\r\n<p align='justify'>4. NH có quyền tự động trích từ tài khoản tiền gửi của KH để thu phí dịch vụ theo quy định.</span><br></p>\r\n<p align='justify'>5. NH có quyền thay đổi, ngừng hoặc chấm dứt việc cung ứng dịch vụ cho KH bất kỳ lúc nào mà không cần sự đồng ý của KH trong các trường hợp:</span><br></p>\r\n<p align='justify'>a. Việc sử dụng dịch vụ của KH có thể gây ảnh hưởng tới tính an toàn, bảo mật của hệ thống của NH;</span><br></p>\r\n<p align='justify'>b. NH ngừng vận hành hoặc nâng cấp hệ thống trong một thời gian nhất định;</span><br></p>\r\n<p align='justify'>c. Các trường hợp bất khả kháng theo quy định của pháp luật.</span><br></p>\r\n<p align='justify'>6. NH có thể từ chối không thực hiện lệnh thanh toán của KH trong trường hợp tài khoản của KH không đủ số dư; hoặc do tài khoản của KH đã đóng hoặc không hợp lệ; hoặc do nhà cung cấp dịch vụ không cho phép thực hiện thanh toán hóa đơn bằng phương tiện điện tử, và trong những trường hợp như vậy, NH sẽ gửi thông báo cho KH.</span><br></p>\r\n<p align='justify'>7. NH không chấp nhận việc hủy bỏ lệnh thanh toán mà KH đã thực hiện thành công. Tất cả các lệnh thanh toán do KH đưa ra khi sử dụng dịch vụ được coi là không hủy ngang, cho dù lệnh thanh toán này do KH hay một người khác được hiểu là KH thực hiện. Việc hủy bỏ phải từ phía nhà cung cấp dịch vụ và phải được sự đồng ý của NH.</span><br></p>\r\n<p align='justify'>8. NH được quyền tự động trích nợ tài khoản KH sử dụng trong Dịch vụ để thanh toán cho các hóa đơn mà KH mua hàng hóa hoặc sử dụng dịch vụ với các nhà cung cấp mà KH tham gia. Việc thanh toán này có thể được thực hiện theo yêu cầu của KH hoặc theo yêu cầu của chính nhà cung cấp dịch vụ.</span></p>\r\n<p align='justify'><br></p>\r\n<p align='justify'><span style=' font-weight: 700;'>Điều 4. Phí sử dụng dịch vụ</span><br></p>\r\n<p align='justify'>1. Phí dịch vụ được áp dụng theo biểu phí do NH ban hành và có thể được thay đổi cho phù hợp với từng thời kỳ.</span><br></p>\r\n<p align='justify'>2. KH ủy quyền cho NH được quyền tự động trích nợ phí sử dụng Dịch vụ trên bất kỳ tài khoản nào mở tại NH để thanh toán tiền phí sử dụng Dịch vụ này.</span><br></p>\r\n<p align='justify'><br></span></p>\r\n<p align='justify'><span style=' font-weight: bold;'>Điều 5. Các quy định khác</span><br></p>\r\n<p align='justify'>1. Các thiết kế, biểu tượng, hình ảnh và các thông tin khác do NH cung cấp qua các dịch vụ Ngân hàng điện tử là tài sản thuộc sở hữu trí tuệ của NH. Mọi sự sao chép, thay thế, sửa chữa mà không được sự chấp thuận của NH đều bị coi là bất hợp pháp.</span><br></p>\r\n<p align='justify'>2. Những vấn đề chưa được nêu trong quy định này được thực hiện theo các quy định của pháp luật.</span><br></p>\r\n<p align='justify'>3. Bằng việc ký vào bản đăng ký này, các bên đã thống nhất và chấp nhận các điều khoản đã quy định. KH cam kết đã đọc, hiểu rõ và tuân thủ đúng, đầy đủ những điều khoản, điều kiện như trên và các quy định liên quan của pháp luật.</span><br></p>",
  note_password_rule:
    "<p><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>&nbsp;Lưu ý:&nbsp;</span><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>Mật khẩu hợp lệ phải đáp ứng các tiêu chí sau:</span></p><p><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>- Độ dài tối thiểu 06 ký tự</span></p><p><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>- Bao gồm chữ cái và chữ số, chữ hoa và chữ thường hoặc ký tự đặc biệt</span></p><p><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>- Không được trùng với tên đăng nhập</span></p><p><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>- Không được trùng với mật khẩu cũ</span></p>",
  ONLINE_LOAN_MORTGAGE_ERROR_MAX_SELECTED: "Quý khách vui lòng chọn tối đa 3 sổ",
  ONLINE_LOAN_SELECT_SAVING_ACCOUNT_TITLE: "Vui lòng chọn sổ tiết kiệm",
  ONLINE_LOAN_CREATE_TITLE: "Tạo gói vay mới",
  ONLINE_LOAN_MORTGAGE_SAVING_TITLE: "Gói vay cầm cố sổ tiết kiệm",
};
